(function() {
  'use strict';

  angular
    .module('minotaur', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'pascalprecht.translate',
      'cfp.loadingBar',
      'slick',
      'chart.js',
      'localytics.directives',
      'ngTable',
      'ngFileUpload',
      'firebase',
      'ngAlertify',
      'FBAngular',
      'validation.match'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurRightbar', minotaurRightbar);

  /** @ngInject */
  function minotaurRightbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/rightbar/rightbar.html',
      controller: RightbarController,
      controllerAs: 'rightbar',
      bindToController: true,
      link: function (scope, $el) {

          var app = angular.element('.appWrap'),
              $rightbar_toggle = app.find('#rightbar'),
              $close_righbar = $el.find('#close-rightbar');

          $rightbar_toggle.on('click', function(){
            $el.toggleClass('rightbar-expanded');
            app.toggleClass('rightbar-expanded');
          });

          $close_righbar.on('click', function(){
            $el.removeClass('rightbar-expanded');
            app.removeClass('rightbar-expanded');
          });
      }
    };

    return directive;

    /** @ngInject */
    function RightbarController() {
      //var rightbar = this;



    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurNav', minotaurNav);

  /** @ngInject */
  function minotaurNav($timeout, $window) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/navigation/navigation.html',
      controller: NavigationController,
      controllerAs: 'navigation',
      bindToController: true,
      link: function (scope, $el) {

        $timeout(function(){

          var $dropdowns = $el.find('ul').parent('li'),
              $a = $dropdowns.children('a'),
              $notDropdowns = $el.find('.nav-sidebar').children('li').not($dropdowns),
              $notDropdownsLinks = $notDropdowns.children('a'),
              $expand_toggle = $el.find('#expand-toggle'),
              app = angular.element('.appWrap'),
              $navigation_toggle = app.find('#navigation-toggle'),
              w = angular.element($window);

          $el.on('mouseenter', function() {
            if (!$el.hasClass('force-expanded') && !app.hasClass('viewport-sm')) {
              $el.addClass('nav-expanded');
              app.addClass('nav-expanded');
            }
          });
          $el.on('mouseleave', function() {
            if (!$el.hasClass('force-expanded') && !app.hasClass('viewport-sm')) {
              $el.removeClass('nav-expanded');
              app.removeClass('nav-expanded');
            }
          });

          $expand_toggle.on('click', function(){
            $el.toggleClass('force-expanded');
            app.toggleClass('force-expanded');
          });

          $navigation_toggle.on('click', function(){
            $el.toggleClass('nav-expanded');
            app.toggleClass('nav-expanded');
          });

          $dropdowns.addClass('dropdown');

          var $submenus = $dropdowns.find('ul >.dropdown');
          $submenus.addClass('submenu');

          $a.append('<span class="indicator"></span>');

          $a.on('click', function(event) {

            var $this = angular.element(this),
                $parent = $this.parent('li'),
                $openSubmenu = angular.element('.submenu.open');

            if (!$parent.hasClass('submenu')) {
              $dropdowns.not($parent).removeClass('open').find('ul').slideUp();
            }

            $openSubmenu.not($this.parents('.submenu')).removeClass('open').find('ul').slideUp();
            $parent.toggleClass('open').find('>ul').stop().slideToggle();
            event.preventDefault();
          });

          $notDropdownsLinks.on('click', function() {
            $dropdowns.removeClass('open').find('ul').slideUp();
          });

          var $activeDropdown = angular.element('.dropdown>ul>.active').parent();

          $activeDropdown.css('display', 'block');

          scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){
            if ($el.find('ul').parent('li.open.active').length > 0 && toState.parent !== fromState.parent) {
                $dropdowns.find('ul').slideUp();
            }
            if (app.hasClass('viewport-sm')) {
              $el.removeClass('nav-expanded');
              app.removeClass('nav-expanded');
            }
          });

          function forceExpandVisibility(){
            if($window.innerWidth < 1200){
              $expand_toggle.hide();
              $el.removeClass('force-expanded nav-expanded');
              app.removeClass('force-expanded nav-expanded');
            } else {
              $expand_toggle.show();
            }
          }

          forceExpandVisibility();

          w.bind('resize', forceExpandVisibility);

        });

      }
    };

    return directive;

    /** @ngInject */
    function NavigationController() {
      //var navigation = this;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurHeader', minotaurHeader);

  /** @ngInject */
  function minotaurHeader($window, $timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/header/header.html',
      controller: HeaderController,
      controllerAs: 'header',
      bindToController: true,
      link: function (scope, element) {
        var app = angular.element('.appWrap'),
            $el = angular.element(element),
            w = angular.element($window);

        function toggleStickyHeader(){
          if (!$el.hasClass('force-header-sm') && !$el.hasClass('header-aside')){
            if(!$el.hasClass('header-sm') && $window.pageYOffset > 10){
              $el.addClass('header-sm');
              app.addClass('header-sm animate');
              $timeout(function(){
                app.removeClass('animate');
              }, 400);
            } else if($el.hasClass('header-sm') && $window.pageYOffset <= 10){
              $el.removeClass('header-sm');
              app.addClass('animate');
              app.removeClass('header-sm');
              $timeout(function(){
                app.removeClass('animate');
              }, 400);
            }
          }
        }

        w.bind('scroll', toggleStickyHeader);

        function setViewport(){
          if($window.innerWidth < 768){
            $el.addClass('viewport-sm');
            app.addClass('viewport-sm');
          } else {
            $el.removeClass('viewport-sm');
            app.removeClass('viewport-sm');
          }
        }

        setViewport();

        w.bind('resize', setViewport);
      }
    };

    return directive;

    /** @ngInject */
    function HeaderController(Auth, $state, $window) {
      var vm = this;

      vm.logout = function() {
        Auth.$signOut().then(function(){
          $state.go('core.login', {}, {reload: true});
        });
        // destroy all firebase refs
        angular.forEach($window.openFirebaseConnections, function (item) {
          item.$destroy();
        });
      };

      vm.notifications = [{
        content: 'User Imrich cancelled account',
        time: '6 minutes ago',
        icon: 'fa fa-ban',
        color: 'bg-danger'
      },{
        content: 'New user registered',
        time: '12 minutes ago',
        icon: 'fa fa-bolt',
        color: 'bg-primary'
      },{
        content: 'User Robert locked account',
        time: '18 minutes ago',
        icon: 'fa fa-lock',
        color: 'bg-greensea'
      },{
        content: 'User Jon cancelled account',
        time: '36 minutes ago',
        icon: 'fa fa-ban',
        color: 'bg-danger'
      },{
        content: 'User Joffrey has been muted',
        time: '42 minutes ago',
        icon: 'fa fa-bullseye',
        color: 'bg-warning'
      },{
        content: 'User Sam locked account',
        time: '58 minutes ago',
        icon: 'fa fa-lock',
        color: 'bg-greensea'
      }]

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurCustomize', minotaurCustomize);

  /** @ngInject */
  function minotaurCustomize() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/customize/minotaur-customize.html',
      link: function (scope, element) {
        var toggle = element.find('.toggle');
        toggle.on('click', function(){
          element.toggleClass('open');
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('WeatherController', WeatherController)
    .controller('NewWeatherController', NewWeatherController)
    .controller('EditWeatherController', EditWeatherController)
    .controller('ShowWeatherController', ShowWeatherController);

  /** @ngInject */
  function WeatherController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.weather = $firebaseArray(ref.child('weather'));
    vm.weatherObject = $firebaseObject(ref.child('weather'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
    //////////////////////////// *General database variable

    vm.locations.$loaded().then(function() {
      vm.childLocations = [];
      //extend array
      angular.forEach(vm.locations, function (value) {
        if (value.parentId && vm.locationsObject[value.parentId]) {
          value.parentName = vm.locationsObject[value.parentId].name;
          vm.childLocations.push(value);
        } else {
          if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
            vm.childLocations.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (weather) {
      if (confirm('Are you sure?')) {
        vm.weather.$remove(weather).then(function () {
          $log.log('weather deleted');
          toastr.success('weather Removed!', 'weather has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.weather.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.weather, function(value){
          if (value.locationId && vm.locationsObject[value.locationId]) {
            value.locationName = vm.locationsObject[value.locationId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.weather
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewWeatherController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/weather/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.weather = $firebaseArray(ref.child('weather'));
    vm.weathe = {};

    vm.processing = false;

    ref.child('weatherCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.weather.id = $filter('digits')(data+1,6);
        } else {
          vm.weather.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.weather.$add(vm.weather).then(function (weatherRef) {
          ref.child('weatherCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('weather').child(weatherRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('weather Added!', 'weather has been created');
          $state.go('weather.list', {}, {reload: true});
        });
      }

      if (vm.weather.images) {
        storageRef.putFiles(vm.weather.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.weather.images[key] = {};
            vm.weather.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditWeatherController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/weather/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
   // var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.weather = $firebaseObject(ref.child('weather').child(id));
    vm.weathe = $firebaseArray(ref.child('weather'));

    vm.editing = true;
    vm.processing = false;

    vm.weather.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.weather.$save().then(function (weatherRef) {
            ref.child('weathe').child(weatherRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('weather Saved!', 'weather has been saved');
            $state.go('weather.list', {}, {reload: true});
          });
        }

        {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowWeatherController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.weather = $firebaseObject(ref.child('weather').child(id));
    vm.weatherObject = $firebaseObject(ref.child('weather'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('VivaController', VivaController)
    .controller('NewVivaController', NewVivaController)
    .controller('EditVivaController', EditVivaController)
    .controller('ShowVivaController', ShowVivaController);

  /** @ngInject */
  function VivaController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.viva = $firebaseArray(ref.child('viva'));
    vm.vivaObject = $firebaseObject(ref.child('viva'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
    //////////////////////////// *General database variable

    vm.locations.$loaded().then(function() {
      vm.childLocations = [];
      //extend array
      angular.forEach(vm.locations, function (value) {
        if (value.parentId && vm.locationsObject[value.parentId]) {
          value.parentName = vm.locationsObject[value.parentId].name;
          vm.childLocations.push(value);
        } else {
          if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
            vm.childLocations.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (viva) {
      if (confirm('Are you sure?')) {
        vm.viva.$remove(viva).then(function () {
          $log.log('viva deleted');
          toastr.success('viva Removed!', 'viva has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.viva.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.viva, function(value){
          if (value.locationId && vm.locationsObject[value.locationId]) {
            value.locationName = vm.locationsObject[value.locationId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.viva
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewVivaController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/viva/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.viva = $firebaseArray(ref.child('viva'));
    vm.weathe = {};

    vm.processing = false;

    ref.child('vivaCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.viva.id = $filter('digits')(data+1,6);
        } else {
          vm.viva.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.viva.$add(vm.viva).then(function (vivaRef) {
          ref.child('vivaCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('viva').child(vivaRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('viva Added!', 'viva has been created');
          $state.go('viva.list', {}, {reload: true});
        });
      }

      if (vm.viva.images) {
        storageRef.putFiles(vm.viva.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.viva.images[key] = {};
            vm.viva.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditVivaController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
   firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/viva/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.viva = $firebaseObject(ref.child('viva').child(id));
    vm.vivas = $firebaseArray(ref.child('viva'));

    vm.editing = true;
    vm.processing = false;

    vm.viva.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.viva.$save().then(function (vivaRef) {
            ref.child('viva').child(vivaRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('viva Saved!', 'viva has been saved');
            $state.go('viva.list', {}, {reload: true});
          });
        }

         if (vm.viva.images) {
        storageRef.putFiles(vm.viva.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.viva.images[key] = {};
            vm.viva.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else 
        {
        save();
      }
      
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowVivaController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.viva = $firebaseObject(ref.child('viva').child(id));
    vm.vivaObject = $firebaseObject(ref.child('viva'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('UsersController', UsersController)
    .controller('NewUserController', NewUserController)
    .controller('EditUserController', EditUserController)
    .controller('ShowUserController', ShowUserController);

  /** @ngInject */
  function UsersController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject, currentAuth, Auth) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.users = $firebaseArray(ref.child('users'));
    vm.blockedUsers = ref.child('blockedUsers');

    vm.currentUser = $firebaseObject(ref.child('users').child(currentAuth.uid));
    //////////////////////////// *General database variable

    vm.currentUser.$loaded(function(){
      if (vm.currentUser.role === 'admin'){
        vm.roles = {
          admin: "admin",
          superuser: "superuser",
          user: "user"
        };
      } else {
        vm.roles = {
          superuser: "superuser",
          user: "user"
        };
      }
    });


    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (user) {
      if (confirm('Are you sure?')) {
        vm.users.$ref().child(user.$id).child('blocked').set(true);
        vm.blockedUsers.child(user.$id).set({blocked: true});
        vm.tableParams.reload();
      }
    };
    //////////////////////////// *Delete CRUD operation

    // password reset operation
    vm.passReset = function (user) {
      if (confirm('Are you sure?')) {
        Auth.$sendPasswordResetEmail(user.email).then(function(){
          toastr.success('We have sent an email with new password', 'Password reset!');
          $log.log("Password reset email sent successfully");
        }, function(error){
          $log.log("Error sending password reset email:", error);
        });
      }
    };
    //////////////////////////// *password reset operation


    // Initialize table
    vm.users.$loaded().then(function() {

      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.users;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        },
        filter: {
          blocked: false
        }
      }, {
        dataset: vm.users
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewUserController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.users = $firebaseArray(ref.child('users'));
    var profiles = ref.child('users');

    // Submit operation
    vm.submit = function() {

      vm.userEntry = {
        name: vm.user.name,
        email: vm.user.email,
        role: vm.user.role,
        address: {
          street: vm.user.address.street,
          city: vm.user.address.city,
          zip: vm.user.address.zip,
          country: vm.user.address.country
        },
        phone: vm.user.phone,
        blocked: false
      };

      /* eslint-disable */
      secondaryApp.auth().createUserWithEmailAndPassword(vm.user.email, vm.user.password)
        .then(function(userData) {
          profiles.child(userData.uid).set(vm.userEntry);
          secondaryApp.auth().signOut();
          secondaryApp.delete();
          $log.log("Successfully created user account with uid:", userData.uid);
          toastr.success('User has been created', 'User Added!');
          $state.go('users.list', {}, {reload: true});
        }, function(error) {
          $log.log("Error creating user:", error);
          toastr.error(error.message, 'Adding User Error!');
        }); /////////////////////// *Create CRUD operation

    };
    /* eslint-enable */
    /////////////////////// *Submit operation

  }

  function EditUserController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.editing = true;

    vm.user = $firebaseObject(ref.child('users').child(id));
    vm.users = $firebaseArray(ref.child('users'));
    var profiles = ref.child('users');

    vm.users.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.userEntry = {
          name: vm.user.name,
          email: vm.user.email,
          role: vm.user.role,
          address: {
            street: vm.user.address.street,
            city: vm.user.address.city,
            zip: vm.user.address.zip,
            country: vm.user.address.country
          },
          phone: vm.user.phone
        };

        var updateOnSuccess = function() {
          profiles.child(vm.user.$id).update(vm.userEntry, function() {
            toastr.success('User has been saved', 'User Saved!');
            $state.go('users.list', {}, {reload: true});
          });
        };

        updateOnSuccess();
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowUserController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.user = $firebaseObject(ref.child('users').child(id));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('SupportController', SupportController);

  /** @ngInject */
  function SupportController(firebase, $firebaseObject, toastr) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.support = $firebaseObject(ref.child('support'));
    //////////////////////////// *General database variable

    vm.save = function(){
      vm.support.$save().then(function(){
        toastr.success('Support has been updated.', 'Support Saved!');
      });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('StocksController', StocksController)
    .controller('NewStockController', NewStockController)
    .controller('EditStockController', EditStockController)
    .controller('ShowStockController', ShowStockController);

  /** @ngInject */
  function StocksController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.stocks = $firebaseArray(ref.child('stocks'));
    vm.stocksObject = $firebaseObject(ref.child('stocks'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
    //////////////////////////// *General database variable

    vm.locations.$loaded().then(function() {
      vm.childLocations = [];
      //extend array
      angular.forEach(vm.locations, function (value) {
        if (value.parentId && vm.locationsObject[value.parentId]) {
          value.parentName = vm.locationsObject[value.parentId].name;
          vm.childLocations.push(value);
        } else {
          if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
            vm.childLocations.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (stock) {
      if (confirm('Are you sure?')) {
        vm.stocks.$remove(stock).then(function () {
          $log.log('stock deleted');
          toastr.success('stock Removed!', 'stock has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.stocks.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.stocks, function(value){
          if (value.locationId && vm.locationsObject[value.locationId]) {
            value.locationName = vm.locationsObject[value.locationId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.stocks
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewStockController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/stocks/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.stocks = $firebaseArray(ref.child('stocks'));
    vm.stock = {};

    vm.processing = false;

    ref.child('stocksCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.stock.id = $filter('digits')(data+1,6);
        } else {
          vm.stock.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.stocks.$add(vm.stock).then(function (stockRef) {
          ref.child('stocksCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('stocks').child(stockRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('stock Added!', 'stock has been created');
          $state.go('stocks.list', {}, {reload: true});
        });
      }

      if (vm.stock.images) {
        storageRef.putFiles(vm.stock.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.stock.images[key] = {};
            vm.stock.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditStockController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/stocks/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.stock = $firebaseObject(ref.child('stocks').child(id));
    vm.stocks = $firebaseArray(ref.child('stocks'));

    vm.editing = true;
    vm.processing = false;

    vm.stocks.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.stock.$save().then(function (stockRef) {
            ref.child('stocks').child(stockRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('stock Saved!', 'stock has been saved');
            $state.go('stocks.list', {}, {reload: true});
          });
        }

        if (vm.form.images.$modelValue[0] && vm.form.images.$modelValue[0].size && vm.form.images.$valid) {
          storageRef.putFiles(vm.stock.images).then(function(metadatas) {
            // Get an array of file metadata
            angular.forEach(metadatas, function(meta, key){
              var file = meta.a;
              vm.stock.images[key] = {};
              vm.stock.images[key].src = file.downloadURLs[0];
            });
            save();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        } else {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowStockController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.stock = $firebaseObject(ref.child('stocks').child(id));
    vm.stocksObject = $firebaseObject(ref.child('stocks'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController(currentAuth, Auth, $log, $state, toastr) {
    var vm = this;

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.createUser = function() {
      vm.message = null;
      vm.error = null;

      toastr.warning('Please uncomment me in SignupController to make me work', 'This should create an Account!');

      // Create a new user
      /*Auth.$createUserWithEmailAndPassword(vm.email, vm.password)
        .then(function(firebaseUser) {
          vm.message = "User created with uid: " + firebaseUser.uid;
          // authenticate so we have permission to write to Firebase
          return Auth.$signInWithEmailAndPassword(vm.email, vm.password);
        })
        .then(function(firebaseUser){
          var ref = firebase.database().ref();

          // create a user profile in our data store
          ref.child('users').child(firebaseUser.uid).set({
            name: vm.name,
            email: vm.email,
            created_at: firebase.database.ServerValue.TIMESTAMP,
            updated_at: firebase.database.ServerValue.TIMESTAMP
          });

          toastr.success('Your Account has been Created', 'Account Created!');
          $state.go('dashboard', {}, {reload: true});
        })
        .catch(function(error) {
          vm.error = error;
          toastr.error(vm.error, 'Creating Account Failed!');
        });*/
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController(firebase, $firebaseObject, toastr) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.settings = $firebaseObject(ref.child('settings'));
    //////////////////////////// *General database variable

    vm.save = function(){
      vm.settings.$save().then(function(){
        toastr.success('Settings has been updated.', 'Settings Saved!');
      });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(firebase, $firebaseObject, currentAuth, Auth, $log, toastr) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var profiles = ref.child('users');
    //////////////////////////// *General database variable

    // Initial model
    vm.user = $firebaseObject(ref.child('users').child(currentAuth.uid));
    /////////////////////// *Initial model

    vm.user.$loaded().then(function(){

      vm.oldEmail = angular.copy(vm.user.email);

    });

    vm.changeEmail = false;
    vm.changePass = false;

    // Submit operation
    vm.save = function() {

      vm.userEntry = {
        avatar: vm.user.avatar,
        name: vm.user.name,
        email: vm.user.email,
        role: vm.user.role,
        address: {
          street: vm.user.address.street,
          city: vm.user.address.city,
          zip: vm.user.address.zip,
          country: vm.user.address.country
        },
        phone: vm.user.phone
      };

      var updateOnSuccess = function() {

        if (vm.user.avatar && vm.user.avatar.size) {
          var file = vm.user.avatar;
          var metadata = {
            'contentType': file.type,
            'contentDisposition': 'inline; filename=' + file.name
          };

          // Push to child path.
          // [START oncomplete]
          storageRef.child('/avatars/' + currentAuth.uid + '/' + file.name).put(file, metadata).then(function(snapshot) {
            var url = snapshot.metadata.downloadURLs[0];
            vm.userEntry.avatar = url;
            $log.log('File available at', url);
            profiles.child(vm.user.$id).update(vm.userEntry);
          }).catch(function(error) {
            // [START onfailure]
            $log.error('Upload failed:', error);
            // [END onfailure]
          });
          // [END oncomplete]
        } else {
          profiles.child(vm.user.$id).update(vm.userEntry);
        }

        toastr.success('Your Personal Informations has been updated', 'Saving success!');
        vm.changeEmail = false;
        vm.changePass = false;
      };

      var changeEmail = vm.changeEmail;
      var changePass = vm.changePass;

      if (changeEmail === true) {
        Auth.$signInWithEmailAndPassword(vm.oldEmail, vm.user.password).then(function(){
          Auth.$updateEmail(vm.user.email).then(function(){
            $log.log("Email changed successfully");
            toastr.success('Email has been changed successfully', 'Email changed!');
            updateOnSuccess();
          }, function(error){
            toastr.error(error.message, 'Error changing email!');
            $log.log("Error changing email:", error);
          });
        });
      } else if (changePass === true) {
        Auth.$signInWithEmailAndPassword(vm.user.email, vm.oldpassword).then(function(){
          Auth.$updatePassword(vm.user.password).then(function(){
            $log.log("Password changed successfully");
            toastr.success('Password has been changed successfully', 'Password changed!');
            updateOnSuccess();
          }, function(error){
            toastr.error(error.message, 'Error changing password!');
            $log.log("Error changing password:", error);
          });
        });
      } else {
        updateOnSuccess();
      }
    };
    /////////////////////// *Submit operation

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ProductsController', ProductsController)
    .controller('NewProductController', NewProductController)
    .controller('EditProductController', EditProductController)
    .controller('ShowProductController', ShowProductController);

  /** @ngInject */
  function ProductsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.products = $firebaseArray(ref.child('products'));
    vm.productsObject = $firebaseObject(ref.child('products'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));
    //////////////////////////// *General database variable

    vm.categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.categories, function (value) {
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (product) {
      if (confirm('Are you sure?')) {
        vm.products.$remove(product).then(function () {
          $log.log('product deleted');
          toastr.success('Product Removed!', 'Product has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.products.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.products, function(value){
          if (value.categoryId && vm.categoriesObject[value.categoryId]) {
            value.categoryName = vm.categoriesObject[value.categoryId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.products
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewProductController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.products = $firebaseArray(ref.child('products'));
    vm.product = {};

    vm.processing = false;

    ref.child('productsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.product.id = $filter('digits')(data+1,6);
        } else {
          vm.product.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.products.$add(vm.product).then(function (productRef) {
          ref.child('productsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('products').child(productRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('Product Added!', 'Product has been created');
          $state.go('products.list', {}, {reload: true});
        });
      }

      if (vm.product.images) {
        storageRef.putFiles(vm.product.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.product.images[key] = {};
            vm.product.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditProductController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.products = $firebaseArray(ref.child('products'));

    vm.editing = true;
    vm.processing = false;

    vm.products.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.product.$save().then(function (productRef) {
            ref.child('products').child(productRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('Product Saved!', 'Product has been saved');
            $state.go('products.list', {}, {reload: true});
          });
        }

        if (vm.form.images.$modelValue[0] && vm.form.images.$modelValue[0].size && vm.form.images.$valid) {
          storageRef.putFiles(vm.product.images).then(function(metadatas) {
            // Get an array of file metadata
            angular.forEach(metadatas, function(meta, key){
              var file = meta.a;
              vm.product.images[key] = {};
              vm.product.images[key].src = file.downloadURLs[0];
            });
            save();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        } else {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowProductController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.productsObject = $firebaseObject(ref.child('products'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ProductsController', ProductsController)
    .controller('NewProductController', NewProductController)
    .controller('EditProductController', EditProductController)
    .controller('ShowProductController', ShowProductController);

  /** @ngInject */
  function ProductsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.products = $firebaseArray(ref.child('products'));
    vm.productsObject = $firebaseObject(ref.child('products'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));
    //////////////////////////// *General database variable

    vm.categories.$loaded().then(function() {
      vm.childCategories = [];
      //extend array
      angular.forEach(vm.categories, function (value) {
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
          vm.childCategories.push(value);
        } else {
          if ($filter('filter')(vm.categories, {parentId: value.$id}).length === 0) {
            vm.childCategories.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (product) {
      if (confirm('Are you sure?')) {
        vm.products.$remove(product).then(function () {
          $log.log('product deleted');
          toastr.success('Product Removed!', 'Product has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.products.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.products, function(value){
          if (value.categoryId && vm.categoriesObject[value.categoryId]) {
            value.categoryName = vm.categoriesObject[value.categoryId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.products
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewProductController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.products = $firebaseArray(ref.child('products'));
    vm.product = {};

    vm.processing = false;

    ref.child('productsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.product.id = $filter('digits')(data+1,6);
        } else {
          vm.product.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.products.$add(vm.product).then(function (productRef) {
          ref.child('productsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('products').child(productRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('Product Added!', 'Product has been created');
          $state.go('products.list', {}, {reload: true});
        });
      }

      if (vm.product.images) {
        storageRef.putFiles(vm.product.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.product.images[key] = {};
            vm.product.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditProductController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/products/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.products = $firebaseArray(ref.child('products'));

    vm.editing = true;
    vm.processing = false;

    vm.products.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.product.$save().then(function (productRef) {
            ref.child('products').child(productRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('Product Saved!', 'Product has been saved');
            $state.go('products.list', {}, {reload: true});
          });
        }

        if (vm.form.images.$modelValue[0] && vm.form.images.$modelValue[0].size && vm.form.images.$valid) {
          storageRef.putFiles(vm.product.images).then(function(metadatas) {
            // Get an array of file metadata
            angular.forEach(metadatas, function(meta, key){
              var file = meta.a;
              vm.product.images[key] = {};
              vm.product.images[key].src = file.downloadURLs[0];
            });
            save();
          }).catch(function(error) {
            // If any task fails, handle this
            vm.processing = false;
            $log.error('Upload failed:', error);
          });
        } else {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowProductController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.product = $firebaseObject(ref.child('products').child(id));
    vm.productsObject = $firebaseObject(ref.child('products'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('OrdersController', OrdersController)
    .controller('ShowOrderController', ShowOrderController);

  /** @ngInject */
  function OrdersController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.orders = $firebaseArray(ref.child('orders'));

    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));

    vm.products = $firebaseArray(ref.child('products'));
    vm.productsObject = $firebaseObject(ref.child('products'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (order) {
      if (confirm('Are you sure?')) {
        vm.orders.$remove(order).then(function () {
          $log.log('order deleted');
          toastr.success('Order Removed!', 'Order has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation

    vm.changeStatus = function (order, status) {
      order.status = status;
      vm.orders.$save(order).then(function () {
        $log.log('status changed');
      });
    };


    // Initialize table
    vm.orders.$loaded().then(function() {


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.orders;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          id: 'asc'
        }
      }, {
        dataset: vm.orders
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function ShowOrderController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.order = $firebaseObject(ref.child('orders').child(id));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('NewsController', NewsController)
    .controller('NewNewsController', NewNewsController)
    .controller('EditNewsController', EditNewsController)
    .controller('ShowNewsController', ShowNewsController);

  /** @ngInject */
  function NewsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.news = $firebaseArray(ref.child('news'));
    vm.newsObject = $firebaseObject(ref.child('news'));

    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
    //////////////////////////// *General database variable

    vm.locations.$loaded().then(function() {
      vm.childLocations = [];
      //extend array
      angular.forEach(vm.locations, function (value) {
        if (value.parentId && vm.locationsObject[value.parentId]) {
          value.parentName = vm.locationsObject[value.parentId].name;
          vm.childLocations.push(value);
        } else {
          if ($filter('filter')(vm.locations, {parentId: value.$id}).length === 0) {
            vm.childLocations.push(value);
          }
        }
      });
    });

    vm.units = {
      pc: "Piece",
      kg: "Kilogram",
      g: "Gram",
      m: "Meter",
      l: "Liter"
    };

    vm.statuses = {
      published: "published",
      notPublished: "not published",
      banned: "banned"
    };

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (news) {
      if (confirm('Are you sure?')) {
        vm.news.$remove(news).then(function () {
          $log.log('news deleted');
          toastr.success('news Removed!', 'news has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.news.$loaded().then(function() {

      //extend array
      function extendArray(){
        angular.forEach(vm.news, function(value){
          if (value.locationId && vm.locationsObject[value.locationId]) {
            value.locationName = vm.locationsObject[value.locationId].name;
          }
        });
      }
      extendArray();
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          extendArray();
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.news
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewNewsController(toastr, $log, firebase, $firebaseArray, $state, $filter){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/news/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var vm = this;
    var ref = firebase.database().ref();
    var storageRef = firebase.storage().ref();

    vm.news = $firebaseArray(ref.child('news'));
    vm.newss = {};

    vm.processing = false;

    ref.child('newsCounter')
      .once('value', function(snapshot){
        var data = snapshot.val();
        if (data) {
          vm.news.id = $filter('digits')(data+1,6);
        } else {
          vm.news.id = '000001';
        }
      });

    // Submit operation
    vm.submit = function() {
      vm.processing = true;

      function save(){
        vm.news.$add(vm.news).then(function (newsRef) {
          ref.child('newsCounter').transaction(function(currentValue) {
            return (currentValue || 0) + 1;
          }, function(err, committed, ss) {
            if( err ) {
              $log.log(err);
            }
            else if(committed) {
              var id = $filter('digits')(ss.val(),6);

              ref.child('news').child(newsRef.key)
                .update({id: id, created_at: firebase.database.ServerValue.TIMESTAMP});
            }
          });
          toastr.success('news Added!', 'news has been created');
          $state.go('news.list', {}, {reload: true});
        });
      }

      if (vm.news.images) {
        storageRef.putFiles(vm.news.images).then(function(metadatas) {
          // Get an array of file metadata
          $log.log(metadatas);
          angular.forEach(metadatas, function(meta, key){
            var file = meta.a;
            vm.news.images[key] = {};
            vm.news.images[key].src = file.downloadURLs[0];
          });
          save();
        }).catch(function(error) {
          // If any task fails, handle this
          vm.processing = false;
          $log.error('Upload failed:', error);
        });
      } else {
        save();
      }

    };
    /////////////////////// *Submit operation
  }

  function EditNewsController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    /* eslint-disable */
    firebase.storage().ref().constructor.prototype.putFiles = function(files) {
      var ref = this;
      return Promise.all(files.map(function(file) {
        var metadata = {
          'contentType': file.type,
          'contentDisposition': 'inline; filename=' + file.name
        };
        return ref.child('/news/' + id + '/' + file.name).put(file, metadata);
      }));
    };
    /* eslint-enable */

    var ref = firebase.database().ref();
   // var storageRef = firebase.storage().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.news = $firebaseObject(ref.child('news').child(id));
    vm.newss = $firebaseArray(ref.child('news'));

    vm.editing = true;
    vm.processing = false;

    vm.news.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        vm.processing = true;

        function save(){
          vm.processing = false;
          vm.news.$save().then(function (newsRef) {
            ref.child('news').child(newsRef.key)
              .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
            toastr.success('news Saved!', 'news has been saved');
            $state.go('news.list', {}, {reload: true});
          });
        }

         {
          save();
        }
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowNewsController(firebase, $firebaseObject, $stateParams){
    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.news = $firebaseObject(ref.child('news').child(id));
    vm.newsObject = $firebaseObject(ref.child('news'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(currentAuth, Auth, $log, $state, toastr) {
    var vm = this;

    toastr.success('please login', 'Welcome!', {progressBar: true, timeOut: '15000'});

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.login = function() {
      vm.error = null;
      Auth.$signInWithEmailAndPassword(vm.email, vm.password)
        .then(function(authData) {
          $log.log("Authenticated successfully with payload:", authData);
          $state.go('dashboard', {}, {reload: true});
        }, function(err) {
          vm.err = err;
          toastr.error(vm.err.message, 'Login Failed!');
          $log.log("Login Failed!", err);
        });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('LocationsController', LocationsController)
    .controller('NewLocationController', NewLocationController)
    .controller('EditLocationController', EditLocationController)
    .controller('ShowLocationController', ShowLocationController);

  /** @ngInject */
  function LocationsController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.locations = $firebaseArray(ref.child('locations'));
    vm.locationsObject = $firebaseObject(ref.child('locations'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (location) {
      if (confirm('Are you sure?')) {
        vm.locations.$remove(location).then(function () {
          $log.log('location deleted');
          toastr.success('location Removed!', 'location has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.locations.$loaded().then(function() {

      //extend array
      angular.forEach(vm.locations, function(value){
        if (value.parentId && vm.locationsObject[value.parentId]) {
          value.parentName = vm.locationsObject[value.parentId].name;
        }
      });
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.locations;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.locations
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewLocationController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.locations = $firebaseArray(ref.child('locations'));

    // Submit operation
    vm.submit = function() {
      if (!vm.location.parentId) {
        vm.location.parent = true;
      } else {
        vm.location.parent = false;
      }
      vm.locations.$add(vm.location).then(function (locationRef) {
        ref.child('locations').child(locationRef.key)
          .update({created_at: firebase.database.ServerValue.TIMESTAMP});
        toastr.success('location Added!', 'location has been created');
        $state.go('locations.list', {}, {reload: true});
      });
    };
    /////////////////////// *Submit operation
  }

  function EditLocationController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.location = $firebaseObject(ref.child('locations').child(id));
    vm.locations = $firebaseArray(ref.child('locations'));

    vm.locations.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        if (!vm.location.parentId) {
          vm.location.parent = true;
        } else {
          vm.location.parent = false;
        }
        vm.location.$save().then(function (locationRef) {
          ref.child('locations').child(locationRef.key)
            .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
          toastr.success('location Saved!', 'location has been saved');
          $state.go('locations.list', {}, {reload: true});
        });
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowLocationController(firebase, $firebaseObject, $stateParams){
     var ref = firebase.database().ref();
      var vm = this;
      var id = $stateParams.id;

      vm.location = $firebaseObject(ref.child('locations').child(id));
      vm.locationsObject = $firebaseObject(ref.child('locations'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('ForgotpassController', ForgotpassController);

  /** @ngInject */
  function ForgotpassController(currentAuth, Auth, $log, $state, toastr) {
    var vm = this;

    vm.currentAuth = currentAuth;

    //redirect if user is logged in
    if (vm.currentAuth) {
      $state.go('dashboard', {}, {reload: true});
    }

    vm.submit = function() {
      Auth.$sendPasswordResetEmail(vm.email)
        .then(function() {
          $log.log("Password reset email sent successfully");
          toastr.success('Your password has been reseted, check your email', 'Password reset!');
          $state.go('core.login', {}, {reload: true});
        }, function(error) {
          $log.log("Error sending password reset email:", error);
          toastr.error(error.code, 'Reset Error!');
        });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('DashboardController', DashboardController)
    .controller('OrdersChartController', OrdersChartController)
    .controller('ProductsChartController', ProductsChartController);

  /** @ngInject */
  function DashboardController(toastr, $firebaseArray, firebase, $filter) {
    var vm = this;

    toastr.success('Welcome to your dashboard! Were still in development :)', 'Hi!', {progressBar: true, timeOut: '30000'});

    // General database variable
    var ref = firebase.database().ref();
    vm.products = $firebaseArray(ref.child('products'));
    vm.orders = $firebaseArray(ref.child('orders'));
    vm.users = $firebaseArray(ref.child('users'));
    vm.categories = $firebaseArray(ref.child('categories'));
    //////////////////////////// *General database variable

    vm.users.$loaded(function(){
      vm.activeUsers = $filter('filter')(vm.users, {blocked: false});
    });

    vm.ordersValue = 0;

    vm.orders.$loaded(function(){
      angular.forEach(vm.orders, function(val) {
        vm.ordersValue += val.subTotal;
      });
    });

  }

  function OrdersChartController($scope, $filter, $firebaseArray, firebase, $log, moment){
    var vm = this;

    var ref = firebase.database().ref();
    vm.orders = $firebaseArray(ref.child('orders'));

    vm.range = '7d';

    vm.labels = [];
    vm.series = ['Orders'];
    vm.data = [[]];
    vm.options = {
      tooltips: {
        titleSpacing: 10,
        titleMarginBottom: 10,
        bodySpacing: 8,
        cornerRadius: 3,
        xPadding: 15,
        yPadding: 15,
        callbacks: {
          label: function(tooltipItem){
            return '$' + tooltipItem.yLabel
          }
        }
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            fontFamily: '"Raleway", "Arial", sans-serif',
            fontSize: 13,
            fontStyle: 'bold',
            fontColor: '#333'
          }
        }],
        yAxes: [{
          gridLines: {
            color: '#eaeaea'
          },
          ticks: {
            fontFamily: '"Raleway", "Arial", sans-serif',
            fontSize: 13,
            fontStyle: 'bold',
            fontColor: '#333'
          }
        }]
      }
    };
    vm.datasetOverride = [{
      backgroundColor: '#45ccce',
      hoverBackgroundColor: '#25aeb0',
      borderWidth: 0
    }];

    function fetchOrders(){
      vm.data = [[]];
      vm.labels = [];

      vm.orders.$ref()
        .orderByChild('created_at')
        .limitToLast(1)
        .once('value', function(snapshot){
          snapshot.forEach(function(data) {

            var lastOrder = data.val();
            var lastDate = moment(lastOrder.created_at).startOf('day').format('x');
            var x;
            var dayDuration = 86400000;

            if (vm.range === '7d') {
              x = 7;
              lastDate -= 6*dayDuration;
            } else if (vm.range === '31d') {
              x = 31;
              lastDate -= 30*dayDuration;
            }

            for(var i = 0; i < x; i++) {
              vm.labels.push($filter('date')(lastDate, 'dd MMM yyyy'));
              lastDate += dayDuration;
            }

            vm.orders.$loaded(function(){
              angular.forEach(vm.labels, function(date){
                var dayValue = 0;
                angular.forEach(vm.orders, function(order){
                  var orderDate = $filter('date')(order.created_at, 'dd MMM yyyy');
                  if (orderDate === date) {
                    dayValue += order.subTotal;
                  }
                });
                vm.data[0].push(dayValue);
              });
            });

          });
        });
    }
    fetchOrders();

    $scope.$watch(function() {
      return vm.range;
    }, function(newVal, oldVal) {
      if (newVal !== oldVal){
        fetchOrders();
      }
    });

  }

  function ProductsChartController(firebase, $firebaseArray, $log, $filter) {
    var vm = this;

    var ref = firebase.database().ref();
    vm.categories = $firebaseArray(ref.child('categories'));
    vm.products = $firebaseArray(ref.child('products'));

    vm.labels = [];
    vm.data = [];

    vm.categories.$loaded(function(){
      vm.products.$loaded(function(){

        var parentCategories = $filter('filter')(vm.categories, {parent: true});
        var childCategories = $filter('filter')(vm.categories, {parent: false});

        angular.forEach(parentCategories, function(val){
          var quantity = 0;

          angular.forEach(childCategories, function(category){
            var x = 0;
            angular.forEach(vm.products, function(product){
              if (product.categoryId === category.$id) {
                x++;
              }
            });
            if (category.parentId === val.$id && x > 0) {
              quantity++;
            }
          });

          vm.labels.push(val.name);
          vm.data.push(quantity);
        });
      });
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('CategoriesController', CategoriesController)
    .controller('NewCategoryController', NewCategoryController)
    .controller('EditCategoryController', EditCategoryController)
    .controller('ShowCategoryController', ShowCategoryController);

  /** @ngInject */
  function CategoriesController($scope, $filter, NgTableParams, toastr, $log, firebase, $firebaseArray, $firebaseObject) {
    var vm = this;

    // General database variable
    var ref = firebase.database().ref();
    vm.categories = $firebaseArray(ref.child('categories'));
    vm.categoriesObject = $firebaseObject(ref.child('categories'));
    //////////////////////////// *General database variable

    //////////////////////////////////////////
    //************ Table Settings **********//
    //////////////////////////////////////////

    // Delete CRUD operation
    vm.delete = function (category) {
      if (confirm('Are you sure?')) {
        vm.categories.$remove(category).then(function () {
          $log.log('category deleted');
          toastr.success('Category Removed!', 'Category has been removed');
        });
      }
    };
    //////////////////////////// *Delete CRUD operation


    // Initialize table
    vm.categories.$loaded().then(function() {

      //extend array
      angular.forEach(vm.categories, function(value){
        if (value.parentId && vm.categoriesObject[value.parentId]) {
          value.parentName = vm.categoriesObject[value.parentId].name;
        }
      });
      ///////////////////////////////////////////// *extend array


      // watch data in scope, if change reload table
      $scope.$watchCollection(function() {
        return vm.categories;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.reload();
        }
      });

      $scope.$watch(function() {
        return vm.searchText;
      }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.tableParams.filter({ $: newVal });
          vm.tableParams.reload();
        }
      });
      ///////////////////////////////////////////// *watch data in scope, if change reload table

      vm.tableParams = new NgTableParams({
        // initial filter
        sorting: {
          name: 'asc'
        }
      }, {
        dataset: vm.categories
      });


    });
    ////////////////////////////////////////// *Initialize table

  }

  function NewCategoryController(toastr, $log, firebase, $firebaseArray, $state){
    var vm = this;
    var ref = firebase.database().ref();

    vm.categories = $firebaseArray(ref.child('categories'));

    // Submit operation
    vm.submit = function() {
      if (!vm.category.parentId) {
        vm.category.parent = true;
      } else {
        vm.category.parent = false;
      }
      vm.categories.$add(vm.category).then(function (categoryRef) {
        ref.child('categories').child(categoryRef.key)
          .update({created_at: firebase.database.ServerValue.TIMESTAMP});
        toastr.success('Category Added!', 'Category has been created');
        $state.go('categories.list', {}, {reload: true});
      });
    };
    /////////////////////// *Submit operation
  }

  function EditCategoryController(toastr, $log, firebase, $firebaseObject, $firebaseArray, $state, $stateParams){

    var ref = firebase.database().ref();
    var vm = this;
    var id = $stateParams.id;

    vm.category = $firebaseObject(ref.child('categories').child(id));
    vm.categories = $firebaseArray(ref.child('categories'));

    vm.categories.$loaded(function(){
      // Submit operation
      vm.submit = function() {
        if (!vm.category.parentId) {
          vm.category.parent = true;
        } else {
          vm.category.parent = false;
        }
        vm.category.$save().then(function (categoryRef) {
          ref.child('categories').child(categoryRef.key)
            .update({updated_at: firebase.database.ServerValue.TIMESTAMP});
          toastr.success('Category Saved!', 'Category has been saved');
          $state.go('categories.list', {}, {reload: true});
        });
      };
      /////////////////////// *Submit operation
    });

  }

  function ShowCategoryController(firebase, $firebaseObject, $stateParams){
     var ref = firebase.database().ref();
      var vm = this;
      var id = $stateParams.id;

      vm.category = $firebaseObject(ref.child('categories').child(id));
      vm.categoriesObject = $firebaseObject(ref.child('categories'));
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .filter('digits', digits);

  /** @ngInject */
  function digits() {
    return function(input, digits) {
      if (digits === 2) {
        if (input < 10) {
          input = '0' + input;
        }
      }
      if (digits === 3) {
        if (input < 10) {
          input = '00' + input;
        } else if (input >= 10 && input < 100) {
          input = '0' + input;
        }
      }
      if (digits === 4) {
        if (input < 10) {
          input = '000' + input;
        } else if (input >= 10 && input < 100) {
          input = '00' + input;
        } else if (input >= 100 && input < 1000) {
          input = '0' + input;
        }
      }
      if (digits === 5) {
        if (input < 10) {
          input = '0000' + input;
        } else if (input >= 10 && input < 100) {
          input = '000' + input;
        } else if (input >= 100 && input < 1000) {
          input = '00' + input;
        } else if (input >= 1000 && input < 10000) {
          input = '0' + input;
        }
      }
      if (digits === 6) {
        if (input < 10) {
          input = '00000' + input;
        } else if (input >= 10 && input < 100) {
          input = '0000' + input;
        } else if (input >= 100 && input < 1000) {
          input = '000' + input;
        } else if (input >= 1000 && input < 10000) {
          input = '00' + input;
        } else if (input >= 10000 && input < 100000) {
          input = '0' + input;
        }
      }

      return input;
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .factory('Auth', Auth);

  /** @ngInject */
  function Auth($firebaseAuth) {
    return $firebaseAuth();
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('vectorMap', vectorMap);

  /** @ngInject */
  function vectorMap() {
    var directive = {
      restrict: 'AE',
      scope: {
        options: '='
      },
      link: function postLink(scope, element) {
        var options = scope.options;
        element.vectorMap(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('validateOnSubmit', validateOnSubmit);

  /** @ngInject */
  function validateOnSubmit() {
    var directive = {
      require: 'form',
      restrict: 'A',
      link: function( scope , element , attributes ){
        var $element = angular.element(element);
        $element.on('submit', function() {
          $element.find('.ng-pristine').removeClass('ng-pristine').addClass('ng-dirty');
          var form = scope[ attributes.name ];
          angular.forEach( form , function ( formElement , fieldName ) {
            if ( fieldName[0] === '$' ) {return;}
            formElement.$pristine = false;
            formElement.$dirty = true;
          },this);
          form.$setDirty();
          scope.$apply();
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('sparkline', sparkline);

  /** @ngInject */
  function sparkline($timeout) {
    var directive = {
      restrict: 'A',
      scope: {
        data: '=',
        options: '='
      },
      link: function($scope, $el) {
        var data = $scope.data,
            options = $scope.options,
            chartResize,
            chartRedraw = function() {
              return $el.sparkline(data, options);
            };

        angular.element(window).resize(function() {
          clearTimeout(chartResize);
          chartResize = $timeout(chartRedraw, 200);
        });

        return chartRedraw();
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('slimscroll', slimscroll);

  /** @ngInject */
  function slimscroll() {
    var directive = {
      restrict: 'A',
      link: function ($scope, $elem, $attr) {
        var off = [];
        var option = {};

        var refresh = function () {
          if ($attr.slimscroll) {
            option = $scope.$eval($attr.slimscroll);
          } else if ($attr.slimscrollOption) {
            option = $scope.$eval($attr.slimscrollOption);
          }

          angular.element($elem).slimScroll({ destroy: true });

          angular.element($elem).slimScroll(option);
        };

        var registerWatch = function () {
          if ($attr.slimscroll && !option.noWatch) {
            off.push($scope.$watchCollection($attr.slimscroll, refresh));
          }

          if ($attr.slimscrollWatch) {
            off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
          }

          if ($attr.slimscrolllistento) {
            off.push($scope.$on($attr.slimscrolllistento, refresh));
          }
        };

        var destructor = function () {
          angular.element($elem).slimScroll({ destroy: true });
          off.forEach(function (unbind) {
            unbind();
          });
          off = null;
        };

        off.push($scope.$on('$destroy', destructor));

        registerWatch();
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('nativeTabs', nativeTabs);

  /** @ngInject */
  function nativeTabs() {
    var directive = {
      restrict: 'EA',
      link: function(scope, element){
        var $element = angular.element(element);
        $element.on('click', function(e) {
          e.preventDefault();
          $element.tab('show');
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('ngMixitup', ngMixitup);

  /** @ngInject */
  function ngMixitup($timeout) {
    var directive = {
      restrict: 'EA',
      link: function(scope, element, attrs){
        /* eslint-disable */
        var options;
        if (attrs.ngMixitup) {
          options = scope.$eval(attrs.ngMixitup);
        }
        $timeout(function(){
          var mixer = mixitup(element, options);
        });
        /* eslint-enable */
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileRefresh', minotaurTileRefresh);

  /** @ngInject */
  function minotaurTileRefresh($timeout, cfpLoadingBar) {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-refresh"></i>Refresh',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          tile.addClass('loading');
          cfpLoadingBar.start();

          $timeout(function(){
            tile.removeClass('loading');
            cfpLoadingBar.complete();
          },3000)
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileMinimize', minotaurTileMinimize);

  /** @ngInject */
  function minotaurTileMinimize() {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-angle-up"></i>Minimize',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){

          if (tile.hasClass('collapsed')) {
            element[0].innerHTML = '<i class="fa fa-angle-up"></i>Minimize'
          } else {
            element[0].innerHTML = '<i class="fa fa-angle-down"></i>Expand'
          }

          tile.toggleClass('collapsed');
          tile.children().not('.tile-header').slideToggle(150);

        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileLightbox', minotaurTileLightbox);

  /** @ngInject */
  function minotaurTileLightbox() {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-magnet"></i>Open in Lightbox',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.magnificPopup({
          items: {
            src: tile[0],
            type: 'inline'
          },
          closeBtnInside: false
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileFullscreen', minotaurTileFullscreen);

  /** @ngInject */
  function minotaurTileFullscreen($log, Fullscreen) {
    var directive = {
      restrict: 'EA',
      template: '<i class="fa fa-expand"></i>Fullscreen',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          if (Fullscreen.isEnabled()) {
            Fullscreen.cancel();
          }
          else {
            Fullscreen.enable(tile[0]);
          }
        });
        Fullscreen.$on('FBFullscreen.change', function(evt, isFullscreenEnabled){
          if (isFullscreenEnabled) {
            tile.addClass('isInFullScreen');
          } else {
            tile.removeClass('isInFullScreen');
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurTileClose', minotaurTileClose);

  /** @ngInject */
  function minotaurTileClose($log, alertify) {
    var directive = {
      restrict: 'E',
      template: '<button class="btn btn-transparent"><i class="fa fa-times"></i></button>',
      link: function (scope, element) {
        var tile = element.parents('.tile');
        element.on('click', function(){
          alertify.confirm("Do you want remove this tile?", function () {
            tile.addClass('closed').fadeOut();
          }, function() {
            // user clicked "cancel"
          });
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurLoading', minotaurLoading);

  /** @ngInject */
  function minotaurLoading($window, $timeout, cfpLoadingBar) {
    var directive = {
      restrict: 'E',
      controller: MinotaurLoadingController,
      controllerAs: 'loading',
      bindToController: true,
      link: function (scope, element) {
        if (!element.hasClass('hide')){
          element.addClass('animate');
        }
        scope.$on('$stateChangeStart', function(event, toState) {
          if (element.hasClass('hide') && toState.specialClass === 'core'){
            element.removeClass('hide');
          }
          cfpLoadingBar.start();
        });
        scope.$on('$stateChangeSuccess', function (event) {
          event.targetScope.$watch('$viewContentLoaded', function () {
            $timeout(function () {
              cfpLoadingBar.complete();
              element.addClass('hide');
            }, 1000);
          });
        });
      }
    };

    return directive;

    /** @ngInject */
    function MinotaurLoadingController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('magnificPopup', magnificPopup);

  /** @ngInject */
  function magnificPopup() {
    var directive = {
      restrict:'A',
      scope: true,
      link: function (scope, element, attrs) {
        var options;
        if (attrs.magnificPopup) {
          options = scope.$eval(attrs.magnificPopup);
        }
        element.magnificPopup(options);
      }
    };

    return directive;

  }

})();

/**!
 * The MIT License
 *
 * Copyright (c) 2013 the angular-leaflet-directive Team, http://tombatossals.github.io/angular-leaflet-directive
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * angular-leaflet-directive
 * https://github.com/tombatossals/angular-leaflet-directive
 *
 * @authors https://github.com/tombatossals/angular-leaflet-directive/graphs/contributors
 */

/* eslint-disable */

/*!
*  angular-leaflet-directive  2015-11-06
*  angular-leaflet-directive - An AngularJS directive to easily interact with Leaflet maps
*  git: https://github.com/tombatossals/angular-leaflet-directive
*/
(function(angular){
'use strict';
angular.module('leaflet-directive', []).directive('leaflet', ["$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletMapEvents", function($q, leafletData, leafletMapDefaults, leafletHelpers, leafletMapEvents) {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      lfCenter: '=',
      defaults: '=',
      maxbounds: '=',
      bounds: '=',
      markers: '=',
      legend: '=',
      geojson: '=',
      paths: '=',
      tiles: '=',
      layers: '=',
      controls: '=',
      decorations: '=',
      eventBroadcast: '=',
      markersWatchOptions: '=',
      geojsonWatchOptions: '=',
    },
    transclude: true,
    template: '<div class="angular-leaflet-map"><div ng-transclude></div></div>',
    controller: ["$scope", function($scope) {
      this._leafletMap = $q.defer();
      this.getMap = function() {
        return this._leafletMap.promise;
      };

      this.getLeafletScope = function() {
        return $scope;
      };
    }],

    link: function(scope, element, attrs, ctrl) {
      var isDefined = leafletHelpers.isDefined;
      var defaults  = leafletMapDefaults.setDefaults(scope.defaults, attrs.id);
      var mapEvents = leafletMapEvents.getAvailableMapEvents();
      var addEvents = leafletMapEvents.addEvents;

      scope.mapId =  attrs.id;
      leafletData.setDirectiveControls({}, attrs.id);

      // Set width and height utility functions
      function updateWidth() {
        if (isNaN(attrs.width)) {
          element.css('width', attrs.width);
        } else {
          element.css('width', attrs.width + 'px');
        }
      }

      function updateHeight() {
        if (isNaN(attrs.height)) {
          element.css('height', attrs.height);
        } else {
          element.css('height', attrs.height + 'px');
        }
      }

      // If the width attribute defined update css
      // Then watch if bound property changes and update css
      if (isDefined(attrs.width)) {
        updateWidth();

        scope.$watch(
          function() {
            return element[0].getAttribute('width');
          },

          function() {
            updateWidth();
            map.invalidateSize();
          });
      }

      // If the height attribute defined update css
      // Then watch if bound property changes and update css
      if (isDefined(attrs.height)) {
        updateHeight();

        scope.$watch(
          function() {
            return element[0].getAttribute('height');
          },

          function() {
            updateHeight();
            map.invalidateSize();
          });
      }

      // Create the Leaflet Map Object with the options
      var map = new L.Map(element[0], leafletMapDefaults.getMapCreationDefaults(attrs.id));
      ctrl._leafletMap.resolve(map);

      if (!isDefined(attrs.center) && !isDefined(attrs.lfCenter)) {
        map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
      }

      // If no layers nor tiles defined, set the default tileLayer
      if (!isDefined(attrs.tiles) && (!isDefined(attrs.layers))) {
        var tileLayerObj = L.tileLayer(defaults.tileLayer, defaults.tileLayerOptions);
        tileLayerObj.addTo(map);
        leafletData.setTiles(tileLayerObj, attrs.id);
      }

      // Set zoom control configuration
      if (isDefined(map.zoomControl) &&
          isDefined(defaults.zoomControlPosition)) {
        map.zoomControl.setPosition(defaults.zoomControlPosition);
      }

      if (isDefined(map.zoomControl) && defaults.zoomControl === false) {
        map.zoomControl.removeFrom(map);
      }

      if (isDefined(map.zoomsliderControl) &&
          isDefined(defaults.zoomsliderControl) &&
          defaults.zoomsliderControl === false) {
        map.zoomsliderControl.removeFrom(map);
      }

      // if no event-broadcast attribute, all events are broadcasted
      if (!isDefined(attrs.eventBroadcast)) {
        var logic = 'broadcast';
        addEvents(map, mapEvents, 'eventName', scope, logic);
      }

      // Resolve the map object to the promises
      map.whenReady(function() {
        leafletData.setMap(map, attrs.id);
      });

      scope.$on('$destroy', function() {
        leafletMapDefaults.reset();
        map.remove();
        leafletData.unresolveMap(attrs.id);
      });

      //Handle request to invalidate the map size
      //Up scope using $scope.$emit('invalidateSize')
      //Down scope using $scope.$broadcast('invalidateSize')
      scope.$on('invalidateSize', function() {
        map.invalidateSize();
      });
    },
  };
}]);

angular.module('leaflet-directive').factory('leafletBoundsHelpers', ["$log", "leafletHelpers", function($log, leafletHelpers) {

  var isArray = leafletHelpers.isArray;
  var isNumber = leafletHelpers.isNumber;
  var isFunction = leafletHelpers.isFunction;
  var isDefined = leafletHelpers.isDefined;

  function _isValidBounds(bounds) {
    return angular.isDefined(bounds) && angular.isDefined(bounds.southWest) &&
           angular.isDefined(bounds.northEast) && angular.isNumber(bounds.southWest.lat) &&
           angular.isNumber(bounds.southWest.lng) && angular.isNumber(bounds.northEast.lat) &&
           angular.isNumber(bounds.northEast.lng);
  }

  return {
    createLeafletBounds: function(bounds) {
      if (_isValidBounds(bounds)) {
        return L.latLngBounds([bounds.southWest.lat, bounds.southWest.lng],
                              [bounds.northEast.lat, bounds.northEast.lng]);
      }
    },

    isValidBounds: _isValidBounds,

    createBoundsFromArray: function(boundsArray) {
      if (!(isArray(boundsArray) && boundsArray.length === 2 &&
            isArray(boundsArray[0]) && isArray(boundsArray[1]) &&
            boundsArray[0].length === 2 && boundsArray[1].length === 2 &&
            isNumber(boundsArray[0][0]) && isNumber(boundsArray[0][1]) &&
            isNumber(boundsArray[1][0]) && isNumber(boundsArray[1][1]))) {
        $log.error('[AngularJS - Leaflet] The bounds array is not valid.');
        return;
      }

      return {
        northEast: {
          lat: boundsArray[0][0],
          lng: boundsArray[0][1],
        },
        southWest: {
          lat: boundsArray[1][0],
          lng: boundsArray[1][1],
        },
      };
    },

    createBoundsFromLeaflet: function(lfBounds) {
      if (!(isDefined(lfBounds) && isFunction(lfBounds.getNorthEast) && isFunction(lfBounds.getSouthWest))) {
        $log.error('[AngularJS - Leaflet] The leaflet bounds is not valid object.');
        return;
      }

      var northEast = lfBounds.getNorthEast();
      var southWest = lfBounds.getSouthWest();

      return {
        northEast: {
          lat: northEast.lat,
          lng: northEast.lng,
        },
        southWest: {
          lat: southWest.lat,
          lng: southWest.lng,
        },
      };
    },
  };
}]);

angular.module('leaflet-directive').factory('leafletControlHelpers', ["$rootScope", "$log", "leafletHelpers", "leafletLayerHelpers", "leafletMapDefaults", function($rootScope, $log, leafletHelpers, leafletLayerHelpers, leafletMapDefaults) {
  var isDefined = leafletHelpers.isDefined;
  var isObject = leafletHelpers.isObject;
  var createLayer = leafletLayerHelpers.createLayer;
  var _controls = {};
  var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';

  var _controlLayersMustBeVisible = function(baselayers, overlays, mapId) {
    var defaults = leafletMapDefaults.getDefaults(mapId);
    if (!defaults.controls.layers.visible) {
      return false;
    }

    var atLeastOneControlItemMustBeShown = false;

    if (isObject(baselayers)) {
      Object.keys(baselayers).forEach(function(key) {
        var layer = baselayers[key];
        if (!isDefined(layer.layerOptions) || layer.layerOptions.showOnSelector !== false) {
          atLeastOneControlItemMustBeShown = true;
        }
      });
    }

    if (isObject(overlays)) {
      Object.keys(overlays).forEach(function(key) {
        var layer = overlays[key];
        if (!isDefined(layer.layerParams) || layer.layerParams.showOnSelector !== false) {
          atLeastOneControlItemMustBeShown = true;
        }
      });
    }

    return atLeastOneControlItemMustBeShown;
  };

  var _createLayersControl = function(mapId) {
    var defaults = leafletMapDefaults.getDefaults(mapId);
    var controlOptions = {
      collapsed: defaults.controls.layers.collapsed,
      position: defaults.controls.layers.position,
      autoZIndex: false,
    };

    angular.extend(controlOptions, defaults.controls.layers.options);

    var control;
    if (defaults.controls.layers && isDefined(defaults.controls.layers.control)) {
      control = defaults.controls.layers.control.apply(this, [[], [], controlOptions]);
    } else {
      control = new L.control.layers([], [], controlOptions);
    }

    return control;
  };

  var controlTypes = {
    draw: {
      isPluginLoaded: function() {
        if (!angular.isDefined(L.Control.Draw)) {
          $log.error(errorHeader + ' Draw plugin is not loaded.');
          return false;
        }

        return true;
      },

      checkValidParams: function(/* params */) {
        return true;
      },

      createControl: function(params) {
        return new L.Control.Draw(params);
      },
    },
    scale: {
      isPluginLoaded: function() {
        return true;
      },

      checkValidParams: function(/* params */) {
        return true;
      },

      createControl: function(params) {
        return new L.control.scale(params);
      },
    },
    fullscreen: {
      isPluginLoaded: function() {
        if (!angular.isDefined(L.Control.Fullscreen)) {
          $log.error(errorHeader + ' Fullscreen plugin is not loaded.');
          return false;
        }

        return true;
      },

      checkValidParams: function(/* params */) {
        return true;
      },

      createControl: function(params) {
        return new L.Control.Fullscreen(params);
      },
    },
    search: {
      isPluginLoaded: function() {
        if (!angular.isDefined(L.Control.Search)) {
          $log.error(errorHeader + ' Search plugin is not loaded.');
          return false;
        }

        return true;
      },

      checkValidParams: function(/* params */) {
        return true;
      },

      createControl: function(params) {
        return new L.Control.Search(params);
      },
    },
    custom: {},
    minimap: {
      isPluginLoaded: function() {
        if (!angular.isDefined(L.Control.MiniMap)) {
          $log.error(errorHeader + ' Minimap plugin is not loaded.');
          return false;
        }

        return true;
      },

      checkValidParams: function(params) {
        if (!isDefined(params.layer)) {
          $log.warn(errorHeader + ' minimap "layer" option should be defined.');
          return false;
        }

        return true;
      },

      createControl: function(params) {
        var layer = createLayer(params.layer);

        if (!isDefined(layer)) {
          $log.warn(errorHeader + ' minimap control "layer" could not be created.');
          return;
        }

        return new L.Control.MiniMap(layer, params);
      },
    },
  };

  return {
    layersControlMustBeVisible: _controlLayersMustBeVisible,

    isValidControlType: function(type) {
      return Object.keys(controlTypes).indexOf(type) !== -1;
    },

    createControl: function(type, params) {
      if (!controlTypes[type].checkValidParams(params)) {
        return;
      }

      return controlTypes[type].createControl(params);
    },

    updateLayersControl: function(map, mapId, loaded, baselayers, overlays, leafletLayers) {
      var i;
      var _layersControl = _controls[mapId];
      var mustBeLoaded = _controlLayersMustBeVisible(baselayers, overlays, mapId);

      if (isDefined(_layersControl) && loaded) {
        for (i in leafletLayers.baselayers) {
          _layersControl.removeLayer(leafletLayers.baselayers[i]);
        }

        for (i in leafletLayers.overlays) {
          _layersControl.removeLayer(leafletLayers.overlays[i]);
        }

        map.removeControl(_layersControl);
        delete _controls[mapId];
      }

      if (mustBeLoaded) {
        _layersControl = _createLayersControl(mapId);
        _controls[mapId] = _layersControl;
        for (i in baselayers) {
          var hideOnSelector = isDefined(baselayers[i].layerOptions) &&
                               baselayers[i].layerOptions.showOnSelector === false;
          if (!hideOnSelector && isDefined(leafletLayers.baselayers[i])) {
            _layersControl.addBaseLayer(leafletLayers.baselayers[i], baselayers[i].name);
          }
        }

        for (i in overlays) {
          var hideOverlayOnSelector = isDefined(overlays[i].layerParams) &&
                      overlays[i].layerParams.showOnSelector === false;
          if (!hideOverlayOnSelector && isDefined(leafletLayers.overlays[i])) {
            _layersControl.addOverlay(leafletLayers.overlays[i], overlays[i].name);
          }
        }

        map.addControl(_layersControl);
      }

      return mustBeLoaded;
    },
  };
}]);

angular.module('leaflet-directive').service('leafletData', ["$log", "$q", "leafletHelpers", function($log, $q, leafletHelpers) {
  var getDefer = leafletHelpers.getDefer,
      getUnresolvedDefer = leafletHelpers.getUnresolvedDefer,
      setResolvedDefer = leafletHelpers.setResolvedDefer;

  var _private = {};
  var self = this;

  var upperFirst = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  var _privateItems = [
      'map',
      'tiles',
      'layers',
      'paths',
      'markers',
      'geoJSON',
      'UTFGrid', //odd ball on naming convention keeping to not break
      'decorations',
      'directiveControls',];

  //init
  _privateItems.forEach(function(itemName) {
    _private[itemName] = {};
  });

  this.unresolveMap = function(scopeId) {
    var id = leafletHelpers.obtainEffectiveMapId(_private.map, scopeId);
    _privateItems.forEach(function(itemName) {
      _private[itemName][id] = undefined;
    });
  };

  //int repetitive stuff (get and sets)
  _privateItems.forEach(function(itemName) {
    var name = upperFirst(itemName);
    self['set' + name] = function(lObject, scopeId) {
      var defer = getUnresolvedDefer(_private[itemName], scopeId);
      defer.resolve(lObject);
      setResolvedDefer(_private[itemName], scopeId);
    };

    self['get' + name] = function(scopeId) {
      var defer = getDefer(_private[itemName], scopeId);
      return defer.promise;
    };
  });
}]);

angular.module('leaflet-directive')
.service('leafletDirectiveControlsHelpers', ["$log", "leafletData", "leafletHelpers", function($log, leafletData, leafletHelpers) {
  var _isDefined = leafletHelpers.isDefined;
  var _isString = leafletHelpers.isString;
  var _isObject = leafletHelpers.isObject;
  var _mainErrorHeader = leafletHelpers.errorHeader;

  var _errorHeader = _mainErrorHeader + '[leafletDirectiveControlsHelpers';

  var _extend = function(id, thingToAddName, createFn, cleanFn) {
    var _fnHeader = _errorHeader + '.extend] ';
    var extender = {};
    if (!_isDefined(thingToAddName)) {
      $log.error(_fnHeader + 'thingToAddName cannot be undefined');
      return;
    }

    if (_isString(thingToAddName) && _isDefined(createFn) && _isDefined(cleanFn)) {
      extender[thingToAddName] = {
        create: createFn,
        clean: cleanFn,
      };
    }    else if (_isObject(thingToAddName) && !_isDefined(createFn) && !_isDefined(cleanFn)) {
      extender = thingToAddName;
    }    else {
      $log.error(_fnHeader + 'incorrect arguments');
      return;
    }

    //add external control to create / destroy markers without a watch
    leafletData.getDirectiveControls().then(function(controls) {
      angular.extend(controls, extender);
      leafletData.setDirectiveControls(controls, id);
    });
  };

  return {
    extend: _extend,
  };
}]);

angular.module('leaflet-directive')
.service('leafletGeoJsonHelpers', ["leafletHelpers", "leafletIterators", function(leafletHelpers, leafletIterators) {
  var lHlp = leafletHelpers;
  var lIt = leafletIterators;
  var Point = function(lat, lng) {
    this.lat = lat;
    this.lng = lng;
    return this;
  };

  var _getLat = function(value) {
    if (Array.isArray(value) && value.length === 2) {
      return value[1];
    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
      return +value.coordinates[1];
    } else {
      return +value.lat;
    }
  };

  var _getLng = function(value) {
    if (Array.isArray(value) && value.length === 2) {
      return value[0];
    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
      return +value.coordinates[0];
    } else {
      return +value.lng;
    }
  };

  var _validateCoords = function(coords) {
    if (lHlp.isUndefined(coords)) {
      return false;
    }

    if (lHlp.isArray(coords)) {
      if (coords.length === 2 && lHlp.isNumber(coords[0]) && lHlp.isNumber(coords[1])) {
        return true;
      }
    } else if (lHlp.isDefined(coords.type)) {
      if (
          coords.type === 'Point' && lHlp.isArray(coords.coordinates) &&
          coords.coordinates.length === 2  &&
          lHlp.isNumber(coords.coordinates[0]) &&
          lHlp.isNumber(coords.coordinates[1])) {
        return true;
      }
    }

    var ret = lIt.all(['lat', 'lng'], function(pos) {
      return lHlp.isDefined(coords[pos]) && lHlp.isNumber(coords[pos]);
    });

    return ret;
  };

  var _getCoords = function(value) {
    if (!value || !_validateCoords(value)) {
      return;
    }

    var p =  null;
    if (Array.isArray(value) && value.length === 2) {
      p = new Point(value[1], value[0]);
    } else if (lHlp.isDefined(value.type) && value.type === 'Point') {
      p = new Point(value.coordinates[1], value.coordinates[0]);
    } else {
      return value;
    }

    //note angular.merge is avail in angular 1.4.X we might want to fill it here
    return angular.extend(value, p);//tap on lat, lng if it doesnt exist
  };

  return {
    getLat: _getLat,
    getLng: _getLng,
    validateCoords: _validateCoords,
    getCoords: _getCoords,
  };
}]);

angular.module('leaflet-directive').service('leafletHelpers', ["$q", "$log", function($q, $log) {
  var _errorHeader = '[AngularJS - Leaflet] ';
  var _copy = angular.copy;
  var _clone = _copy;
  /*
  For parsing paths to a field in an object

  Example:
  var obj = {
      bike:{
       1: 'hi'
       2: 'foo'
      }
  };
  _getObjectValue(obj,"bike.1") returns 'hi'
  this is getPath in ui-gmap
   */
  var _getObjectValue = function(object, pathStr) {
    var obj;
    if (!object || !angular.isObject(object))
        return;

    //if the key is not a sting then we already have the value
    if ((pathStr === null) || !angular.isString(pathStr)) {
      return pathStr;
    }

    obj = object;
    pathStr.split('.').forEach(function(value) {
      if (obj) {
        obj = obj[value];
      }
    });

    return obj;
  };

  /*
   Object Array Notation
   _getObjectArrayPath("bike.one.two")
   returns:
   'bike["one"]["two"]'
   */
  var _getObjectArrayPath = function(pathStr) {
    return pathStr.split('.').reduce(function(previous, current) {
      return previous + '["' + current + '"]';
    });
  };

  /* Object Dot Notation
   _getObjectPath(["bike","one","two"])
   returns:
   "bike.one.two"
   */
  var _getObjectDotPath = function(arrayOfStrings) {
    return arrayOfStrings.reduce(function(previous, current) {
      return previous + '.' + current;
    });
  };

  function _obtainEffectiveMapId(d, mapId) {
    var id;
    var i;
    if (!angular.isDefined(mapId)) {
      if (Object.keys(d).length === 0) {
        id = 'main';
      } else if (Object.keys(d).length >= 1) {
        for (i in d) {
          if (d.hasOwnProperty(i)) {
            id = i;
          }
        }
      } else {
        $log.error(_errorHeader + '- You have more than 1 map on the DOM, you must provide the map ID to the leafletData.getXXX call');
      }
    } else {
      id = mapId;
    }

    return id;
  }

  function _getUnresolvedDefer(d, mapId) {
    var id = _obtainEffectiveMapId(d, mapId);
    var defer;

    if (!angular.isDefined(d[id]) || d[id].resolvedDefer === true) {
      defer = $q.defer();
      d[id] = {
        defer: defer,
        resolvedDefer: false,
      };
    } else {
      defer = d[id].defer;
    }

    return defer;
  }

  var _isDefined = function(value) {
    return angular.isDefined(value) && value !== null;
  };

  var _isUndefined = function(value) {
    return !_isDefined(value);
  };

  // BEGIN DIRECT PORT FROM AngularJS code base

  var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;

  var MOZ_HACK_REGEXP = /^moz([A-Z])/;

  var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;

  /**
  Converts snake_case to camelCase.
  Also there is special case for Moz prefix starting with upper case letter.
  @param name Name to normalize
   */

  var camelCase = function(name) {
      return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
        if (offset) {
          return letter.toUpperCase();
        } else {
          return letter;
        }
      }).replace(MOZ_HACK_REGEXP, 'Moz$1');
    };

  /**
  Converts all accepted directives format into proper directive name.
  @param name Name to normalize
   */

  var directiveNormalize = function(name) {
      return camelCase(name.replace(PREFIX_REGEXP, ''));
    };

  // END AngularJS port

  return {
    camelCase: camelCase,
    directiveNormalize: directiveNormalize,
    copy:_copy,
    clone:_clone,
    errorHeader: _errorHeader,
    getObjectValue: _getObjectValue,
    getObjectArrayPath:_getObjectArrayPath,
    getObjectDotPath: _getObjectDotPath,
    defaultTo: function(val, _default) {
      return _isDefined(val) ? val : _default;
    },

    //mainly for checking attributes of directives lets keep this minimal (on what we accept)
    isTruthy: function(val) {
      return val === 'true' || val === true;
    },

    //Determine if a reference is {}
    isEmpty: function(value) {
      return Object.keys(value).length === 0;
    },

    //Determine if a reference is undefined or {}
    isUndefinedOrEmpty: function(value) {
      return (angular.isUndefined(value) || value === null) || Object.keys(value).length === 0;
    },

    // Determine if a reference is defined
    isDefined: _isDefined,
    isUndefined:_isUndefined,
    isNumber: angular.isNumber,
    isString: angular.isString,
    isArray: angular.isArray,
    isObject: angular.isObject,
    isFunction: angular.isFunction,
    equals: angular.equals,

    isValidCenter: function(center) {
      return angular.isDefined(center) && angular.isNumber(center.lat) &&
             angular.isNumber(center.lng) && angular.isNumber(center.zoom);
    },

    isValidPoint: function(point) {
      if (!angular.isDefined(point)) {
        return false;
      }

      if (angular.isArray(point)) {
        return point.length === 2 && angular.isNumber(point[0]) && angular.isNumber(point[1]);
      }

      return angular.isNumber(point.lat) && angular.isNumber(point.lng);
    },

    isSameCenterOnMap: function(centerModel, map) {
      var mapCenter = map.getCenter();
      var zoom = map.getZoom();
      if (centerModel.lat && centerModel.lng &&
          mapCenter.lat.toFixed(4) === centerModel.lat.toFixed(4) &&
          mapCenter.lng.toFixed(4) === centerModel.lng.toFixed(4) &&
          zoom === centerModel.zoom) {
        return true;
      }

      return false;
    },

    safeApply: function($scope, fn) {
      var phase = $scope.$root.$$phase;
      if (phase === '$apply' || phase === '$digest') {
        $scope.$eval(fn);
      } else {
        $scope.$evalAsync(fn);
      }
    },

    obtainEffectiveMapId: _obtainEffectiveMapId,

    getDefer: function(d, mapId) {
      var id = _obtainEffectiveMapId(d, mapId);
      var defer;
      if (!angular.isDefined(d[id]) || d[id].resolvedDefer === false) {
        defer = _getUnresolvedDefer(d, mapId);
      } else {
        defer = d[id].defer;
      }

      return defer;
    },

    getUnresolvedDefer: _getUnresolvedDefer,

    setResolvedDefer: function(d, mapId) {
      var id = _obtainEffectiveMapId(d, mapId);
      d[id].resolvedDefer = true;
    },

    rangeIsSupported: function() {
      var testrange = document.createElement('input');
      testrange.setAttribute('type', 'range');
      return testrange.type === 'range';
    },

    FullScreenControlPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.Control.Fullscreen);
      },
    },

    MiniMapControlPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.Control.MiniMap);
      },
    },

    AwesomeMarkersPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.AwesomeMarkers) && angular.isDefined(L.AwesomeMarkers.Icon);
      },

      is: function(icon) {
        if (this.isLoaded()) {
          return icon instanceof L.AwesomeMarkers.Icon;
        } else {
          return false;
        }
      },

      equal: function(iconA, iconB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(iconA)) {
          return angular.equals(iconA, iconB);
        } else {
          return false;
        }
      },
    },

    VectorMarkersPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.VectorMarkers) && angular.isDefined(L.VectorMarkers.Icon);
      },

      is: function(icon) {
        if (this.isLoaded()) {
          return icon instanceof L.VectorMarkers.Icon;
        } else {
          return false;
        }
      },

      equal: function(iconA, iconB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(iconA)) {
          return angular.equals(iconA, iconB);
        } else {
          return false;
        }
      },
    },

    DomMarkersPlugin: {
      isLoaded: function() {
        if (angular.isDefined(L.DomMarkers) && angular.isDefined(L.DomMarkers.Icon)) {
          return true;
        } else {
          return false;
        }
      },

      is: function(icon) {
        if (this.isLoaded()) {
          return icon instanceof L.DomMarkers.Icon;
        } else {
          return false;
        }
      },

      equal: function(iconA, iconB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(iconA)) {
          return angular.equals(iconA, iconB);
        } else {
          return false;
        }
      },
    },

    PolylineDecoratorPlugin: {
      isLoaded: function() {
        if (angular.isDefined(L.PolylineDecorator)) {
          return true;
        } else {
          return false;
        }
      },

      is: function(decoration) {
        if (this.isLoaded()) {
          return decoration instanceof L.PolylineDecorator;
        } else {
          return false;
        }
      },

      equal: function(decorationA, decorationB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(decorationA)) {
          return angular.equals(decorationA, decorationB);
        } else {
          return false;
        }
      },
    },

    MakiMarkersPlugin: {
      isLoaded: function() {
        if (angular.isDefined(L.MakiMarkers) && angular.isDefined(L.MakiMarkers.Icon)) {
          return true;
        } else {
          return false;
        }
      },

      is: function(icon) {
        if (this.isLoaded()) {
          return icon instanceof L.MakiMarkers.Icon;
        } else {
          return false;
        }
      },

      equal: function(iconA, iconB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(iconA)) {
          return angular.equals(iconA, iconB);
        } else {
          return false;
        }
      },
    },
    ExtraMarkersPlugin: {
      isLoaded: function() {
        if (angular.isDefined(L.ExtraMarkers) && angular.isDefined(L.ExtraMarkers.Icon)) {
          return true;
        } else {
          return false;
        }
      },

      is: function(icon) {
        if (this.isLoaded()) {
          return icon instanceof L.ExtraMarkers.Icon;
        } else {
          return false;
        }
      },

      equal: function(iconA, iconB) {
        if (!this.isLoaded()) {
          return false;
        }

        if (this.is(iconA)) {
          return angular.equals(iconA, iconB);
        } else {
          return false;
        }
      },
    },
    LabelPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.Label);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.MarkerClusterGroup;
        } else {
          return false;
        }
      },
    },
    MarkerClusterPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.MarkerClusterGroup);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.MarkerClusterGroup;
        } else {
          return false;
        }
      },
    },
    GoogleLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.Google);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.Google;
        } else {
          return false;
        }
      },
    },
    LeafletProviderPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.TileLayer.Provider);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.TileLayer.Provider;
        } else {
          return false;
        }
      },
    },
    ChinaLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.tileLayer.chinaProvider);
      },
    },
    HeatLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.heatLayer);
      },
    },
    WebGLHeatMapLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.TileLayer.WebGLHeatMap);
      },
    },
    BingLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.BingLayer);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.BingLayer;
        } else {
          return false;
        }
      },
    },
    WFSLayerPlugin: {
      isLoaded: function() {
        return L.GeoJSON.WFS !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.GeoJSON.WFS;
        } else {
          return false;
        }
      },
    },
    AGSBaseLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.basemapLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.basemapLayer;
        } else {
          return false;
        }
      },
    },
    AGSLayerPlugin: {
      isLoaded: function() {
        return lvector !== undefined && lvector.AGS !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof lvector.AGS;
        } else {
          return false;
        }
      },
    },
    AGSFeatureLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.featureLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.featureLayer;
        } else {
          return false;
        }
      },
    },
    AGSTiledMapLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.tiledMapLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.tiledMapLayer;
        } else {
          return false;
        }
      },
    },
    AGSDynamicMapLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.dynamicMapLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.dynamicMapLayer;
        } else {
          return false;
        }
      },
    },
    AGSImageMapLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.imageMapLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.imageMapLayer;
        } else {
          return false;
        }
      },
    },
    AGSClusteredLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.clusteredFeatureLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.clusteredFeatureLayer;
        } else {
          return false;
        }
      },
    },
    AGSHeatmapLayerPlugin: {
      isLoaded: function() {
        return L.esri !== undefined && L.esri.heatmapFeatureLayer !== undefined;
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.esri.heatmapFeatureLayer;
        } else {
          return false;
        }
      },
    },
    YandexLayerPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.Yandex);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.Yandex;
        } else {
          return false;
        }
      },
    },
    GeoJSONPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.TileLayer.GeoJSON);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.TileLayer.GeoJSON;
        } else {
          return false;
        }
      },
    },
    UTFGridPlugin: {
      isLoaded: function() {
        return angular.isDefined(L.UtfGrid);
      },

      is: function(layer) {
        if (this.isLoaded()) {
          return layer instanceof L.UtfGrid;
        } else {
          $log.error('[AngularJS - Leaflet] No UtfGrid plugin found.');
          return false;
        }
      },
    },
    CartoDB: {
      isLoaded: function() {
        return cartodb;
      },

      is: function(/*layer*/) {
        return true;
        /*
        if (this.isLoaded()) {
            return layer instanceof L.TileLayer.GeoJSON;
        } else {
            return false;
        }*/
      },
    },
    Leaflet: {
      DivIcon: {
        is: function(icon) {
          return icon instanceof L.DivIcon;
        },

        equal: function(iconA, iconB) {
          if (this.is(iconA)) {
            return angular.equals(iconA, iconB);
          } else {
            return false;
          }
        },
      },
      Icon: {
        is: function(icon) {
          return icon instanceof L.Icon;
        },

        equal: function(iconA, iconB) {
          if (this.is(iconA)) {
            return angular.equals(iconA, iconB);
          } else {
            return false;
          }
        },
      },
    },
    /*
     watchOptions - object to set deep nested watches and turn off watches all together
     (rely on control / functional updates)
     watchOptions - Object
         doWatch:boolean
         isDeep:boolean (sets $watch(function,isDeep))
         individual
             doWatch:boolean
             isDeep:boolean
     */

    //legacy defaults
    watchOptions: {
      doWatch:true,
      isDeep: true,
      individual:{
        doWatch:true,
        isDeep: true,
      },
    },
  };
}]);

angular.module('leaflet-directive').service('leafletIterators', ["$log", "leafletHelpers", function($log, leafletHelpers) {

  var lHlp = leafletHelpers;
  var errorHeader = leafletHelpers.errorHeader + 'leafletIterators: ';

  //BEGIN COPY from underscore
  var _keys = Object.keys;
  var _isFunction = lHlp.isFunction;
  var _isObject = lHlp.isObject;

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  var _isArrayLike = function(collection) {
    var length = collection !== null && collection.length;
    return lHlp.isNumber(length) && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Keep the identity function around for default iteratees.
  var _identity = function(value) {
    return value;
  };

  var _property = function(key) {
    return function(obj) {
      return obj === null ? void 0 : obj[key];
    };
  };

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount === null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };

      case 2: return function(value, other) {
        return func.call(context, value, other);
      };

      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };

      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj === null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index];
        var keys = keysFunc(source);
        var l = keys.length;

        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }

      return obj;
    };
  };

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var _extendOwn;
  var _assign = null;
  _extendOwn = _assign = createAssigner(_keys);

  // Returns whether an object has a given set of `key:value` pairs.
  var _isMatch = function(object, attrs) {
    var keys = _keys(attrs);
    var length = keys.length;
    if (object === null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }

    return true;
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  var _matcher;
  var _matches = null;
  _matcher = _matches = function(attrs) {
    attrs = _extendOwn({}, attrs);
    return function(obj) {
      return _isMatch(obj, attrs);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value === null) return _identity;
    if (_isFunction(value)) return optimizeCb(value, context, argCount);
    if (_isObject(value)) return _matcher(value);
    return _property(value);
  };

  var _every;
  var _all = null;
  _every = _all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !_isArrayLike(obj) && _keys(obj);
    var length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }

    return true;
  };

  //END COPY fron underscore

  var _hasErrors = function(collection, cb, ignoreCollection, cbName) {
    if (!ignoreCollection) {
      if (!lHlp.isDefined(collection) || !lHlp.isDefined(cb)) {
        return true;
      }
    }

    if (!lHlp.isFunction(cb)) {
      cbName = lHlp.defaultTo(cb, 'cb');
      $log.error(errorHeader + cbName + ' is not a function');
      return true;
    }

    return false;
  };

  var _iterate = function(collection, externalCb, internalCb) {
    if (_hasErrors(undefined, internalCb, true, 'internalCb')) {
      return;
    }

    if (!_hasErrors(collection, externalCb)) {
      for (var key in collection) {
        if (collection.hasOwnProperty(key)) {
          internalCb(collection[key], key);
        }
      }
    }
  };

  //see http://jsperf.com/iterators/3
  //utilizing for in is way faster
  var _each = function(collection, cb) {
    _iterate(collection, cb, function(val, key) {
      cb(val, key);
    });
  };

  return {
    each:_each,
    forEach: _each,
    every: _every,
    all: _all,
  };
}]);

angular.module('leaflet-directive')
.factory('leafletLayerHelpers', ["$rootScope", "$log", "$q", "leafletHelpers", "leafletIterators", function($rootScope, $log, $q, leafletHelpers, leafletIterators) {
  var Helpers = leafletHelpers;
  var isString = leafletHelpers.isString;
  var isObject = leafletHelpers.isObject;
  var isArray = leafletHelpers.isArray;
  var isDefined = leafletHelpers.isDefined;
  var errorHeader = leafletHelpers.errorHeader;
  var $it = leafletIterators;

  var utfGridCreateLayer = function(params) {
    if (!Helpers.UTFGridPlugin.isLoaded()) {
      $log.error('[AngularJS - Leaflet] The UTFGrid plugin is not loaded.');
      return;
    }

    var utfgrid = new L.UtfGrid(params.url, params.pluginOptions);

    utfgrid.on('mouseover', function(e) {
      $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseover', e);
    });

    utfgrid.on('mouseout', function(e) {
      $rootScope.$broadcast('leafletDirectiveMap.utfgridMouseout', e);
    });

    utfgrid.on('click', function(e) {
      $rootScope.$broadcast('leafletDirectiveMap.utfgridClick', e);
    });

    utfgrid.on('mousemove', function(e) {
      $rootScope.$broadcast('leafletDirectiveMap.utfgridMousemove', e);
    });

    return utfgrid;
  };

  var layerTypes = {
    xyz: {
      mustHaveUrl: true,
      createLayer: function(params) {
        return L.tileLayer(params.url, params.options);
      },
    },
    mapbox: {
      mustHaveKey: true,
      createLayer: function(params) {
        var version = 3;
        if (isDefined(params.options.version) && params.options.version === 4) {
          version = params.options.version;
        }

        var url = version === 3 ?
            '//{s}.tiles.mapbox.com/v3/' + params.key + '/{z}/{x}/{y}.png' :
            '//api.tiles.mapbox.com/v4/' + params.key + '/{z}/{x}/{y}.png?access_token=' + params.apiKey;
        return L.tileLayer(url, params.options);
      },
    },
    geoJSON: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.GeoJSONPlugin.isLoaded()) {
          return;
        }

        return new L.TileLayer.GeoJSON(params.url, params.pluginOptions, params.options);
      },
    },
    geoJSONShape: {
      mustHaveUrl: false,
      createLayer: function(params) {
        return new L.GeoJSON(params.data,
            params.options);
      },
    },
    geoJSONAwesomeMarker: {
      mustHaveUrl: false,
      createLayer: function(params) {
        return new L.geoJson(params.data, {
          pointToLayer: function(feature, latlng) {
            return L.marker(latlng, {icon: L.AwesomeMarkers.icon(params.icon)});
          },
        });
      },
    },
    geoJSONVectorMarker: {
      mustHaveUrl: false,
      createLayer: function(params) {
        return new L.geoJson(params.data, {
          pointToLayer: function(feature, latlng) {
            return L.marker(latlng, {icon: L.VectorMarkers.icon(params.icon)});
          },
        });
      },
    },
    utfGrid: {
      mustHaveUrl: true,
      createLayer: utfGridCreateLayer,
    },
    cartodbTiles: {
      mustHaveKey: true,
      createLayer: function(params) {
        var url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
        return L.tileLayer(url, params.options);
      },
    },
    cartodbUTFGrid: {
      mustHaveKey: true,
      mustHaveLayer: true,
      createLayer: function(params) {
        params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
        return utfGridCreateLayer(params);
      },
    },
    cartodbInteractive: {
      mustHaveKey: true,
      mustHaveLayer: true,
      createLayer: function(params) {
        var tilesURL = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/{z}/{x}/{y}.png';
        var tileLayer = L.tileLayer(tilesURL, params.options);
        params.url = '//' + params.user + '.cartodb.com/api/v1/map/' + params.key + '/' + params.layer + '/{z}/{x}/{y}.grid.json';
        var utfLayer = utfGridCreateLayer(params);
        return L.layerGroup([tileLayer, utfLayer]);
      },
    },
    wms: {
      mustHaveUrl: true,
      createLayer: function(params) {
        return L.tileLayer.wms(params.url, params.options);
      },
    },
    wmts: {
      mustHaveUrl: true,
      createLayer: function(params) {
        return L.tileLayer.wmts(params.url, params.options);
      },
    },
    wfs: {
      mustHaveUrl: true,
      mustHaveLayer: true,
      createLayer: function(params) {
        if (!Helpers.WFSLayerPlugin.isLoaded()) {
          return;
        }

        var options = angular.copy(params.options);
        if (options.crs && typeof options.crs === 'string') {
          /*jshint -W061 */
          options.crs = eval(options.crs);
        }

        return new L.GeoJSON.WFS(params.url, params.layer, options);
      },
    },
    group: {
      mustHaveUrl: false,
      createLayer: function(params) {
        var lyrs = [];
        $it.each(params.options.layers, function(l) {
                  lyrs.push(createLayer(l));
                });

        params.options.loadedDefer = function() {
          var defers = [];
          if (isDefined(params.options.layers)) {
            for (var i = 0; i < params.options.layers.length; i++) {
              var d = params.options.layers[i].layerOptions.loadedDefer;
              if (isDefined(d)) {
                defers.push(d);
              }
            }
          }

          return defers;
        };

        return L.layerGroup(lyrs);
      },
    },
    featureGroup: {
      mustHaveUrl: false,
      createLayer: function() {
        return L.featureGroup();
      },
    },
    google: {
      mustHaveUrl: false,
      createLayer: function(params) {
        var type = params.type || 'SATELLITE';
        if (!Helpers.GoogleLayerPlugin.isLoaded()) {
          return;
        }

        return new L.Google(type, params.options);
      },
    },
    here: {
      mustHaveUrl: false,
      createLayer: function(params) {
        var provider = params.provider || 'HERE.terrainDay';
        if (!Helpers.LeafletProviderPlugin.isLoaded()) {
          return;
        }

        return new L.TileLayer.Provider(provider, params.options);
      },
    },
    china:{
      mustHaveUrl:false,
      createLayer:function(params) {
        var type = params.type || '';
        if (!Helpers.ChinaLayerPlugin.isLoaded()) {
          return;
        }

        return L.tileLayer.chinaProvider(type, params.options);
      },
    },
    agsBase: {
      mustHaveLayer: true,
      createLayer: function(params) {
        if (!Helpers.AGSBaseLayerPlugin.isLoaded()) {
          return;
        }

        return L.esri.basemapLayer(params.layer, params.options);
      },
    },
    ags: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSLayerPlugin.isLoaded()) {
          return;
        }

        var options = angular.copy(params.options);
        angular.extend(options, {
          url: params.url,
        });
        var layer = new lvector.AGS(options);
        layer.onAdd = function(map) {
          this.setMap(map);
        };

        layer.onRemove = function() {
          this.setMap(null);
        };

        return layer;
      },
    },
    agsFeature: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSFeatureLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri plugin is not loaded.');
          return;
        }

        params.options.url = params.url;

        var layer = L.esri.featureLayer(params.options);
        var load = function() {
          if (isDefined(params.options.loadedDefer)) {
            params.options.loadedDefer.resolve();
          }
        };

        layer.on('loading', function() {
          params.options.loadedDefer = $q.defer();
          layer.off('load', load);
          layer.on('load', load);
        });

        return layer;
      },
    },
    agsTiled: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSTiledMapLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri plugin is not loaded.');
          return;
        }

        params.options.url = params.url;

        return L.esri.tiledMapLayer(params.options);
      },
    },
    agsDynamic: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSDynamicMapLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri plugin is not loaded.');
          return;
        }

        params.options.url = params.url;

        return L.esri.dynamicMapLayer(params.options);
      },
    },
    agsImage: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSImageMapLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri plugin is not loaded.');
          return;
        }

        params.options.url = params.url;

        return L.esri.imageMapLayer(params.options);
      },
    },
    agsClustered: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSClusteredLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri clustered layer plugin is not loaded.');
          return;
        }

        if (!Helpers.MarkerClusterPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
          return;
        }

        return L.esri.clusteredFeatureLayer(params.url, params.options);
      },
    },
    agsHeatmap: {
      mustHaveUrl: true,
      createLayer: function(params) {
        if (!Helpers.AGSHeatmapLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The esri heatmap layer plugin is not loaded.');
          return;
        }

        if (!Helpers.HeatLayerPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The heatlayer plugin is not loaded.');
          return;
        }

        return L.esri.heatmapFeatureLayer(params.url, params.options);
      },
    },
    markercluster: {
      mustHaveUrl: false,
      createLayer: function(params) {
        if (!Helpers.MarkerClusterPlugin.isLoaded()) {
          $log.warn(errorHeader + ' The markercluster plugin is not loaded.');
          return;
        }

        return new L.MarkerClusterGroup(params.options);
      },
    },
    bing: {
      mustHaveUrl: false,
      createLayer: function(params) {
        if (!Helpers.BingLayerPlugin.isLoaded()) {
          return;
        }

        return new L.BingLayer(params.key, params.options);
      },
    },
    webGLHeatmap: {
      mustHaveUrl: false,
      mustHaveData: true,
      createLayer: function(params) {
        if (!Helpers.WebGLHeatMapLayerPlugin.isLoaded()) {
          return;
        }

        var layer = new L.TileLayer.WebGLHeatMap(params.options);
        if (isDefined(params.data)) {
          layer.setData(params.data);
        }

        return layer;
      },
    },
    heat: {
      mustHaveUrl: false,
      mustHaveData: true,
      createLayer: function(params) {
        if (!Helpers.HeatLayerPlugin.isLoaded()) {
          return;
        }

        var layer = new L.heatLayer();

        if (isArray(params.data)) {
          layer.setLatLngs(params.data);
        }

        if (isObject(params.options)) {
          layer.setOptions(params.options);
        }

        return layer;
      },
    },
    yandex: {
      mustHaveUrl: false,
      createLayer: function(params) {
        var type = params.type || 'map';
        if (!Helpers.YandexLayerPlugin.isLoaded()) {
          return;
        }

        return new L.Yandex(type, params.options);
      },
    },
    imageOverlay: {
      mustHaveUrl: true,
      mustHaveBounds: true,
      createLayer: function(params) {
        return L.imageOverlay(params.url, params.bounds, params.options);
      },
    },
    iip: {
      mustHaveUrl: true,
      createLayer: function(params) {
        return L.tileLayer.iip(params.url, params.options);
      },
    },

    // This "custom" type is used to accept every layer that user want to define himself.
    // We can wrap these custom layers like heatmap or yandex, but it means a lot of work/code to wrap the world,
    // so we let user to define their own layer outside the directive,
    // and pass it on "createLayer" result for next processes
    custom: {
      createLayer: function(params) {
        if (params.layer instanceof L.Class) {
          return angular.copy(params.layer);
        }        else {
          $log.error('[AngularJS - Leaflet] A custom layer must be a leaflet Class');
        }
      },
    },
    cartodb: {
      mustHaveUrl: true,
      createLayer: function(params) {
        return cartodb.createLayer(params.map, params.url);
      },
    },
  };

  function isValidLayerType(layerDefinition) {
    // Check if the baselayer has a valid type
    if (!isString(layerDefinition.type)) {
      $log.error('[AngularJS - Leaflet] A layer must have a valid type defined.');
      return false;
    }

    if (Object.keys(layerTypes).indexOf(layerDefinition.type) === -1) {
      $log.error('[AngularJS - Leaflet] A layer must have a valid type: ' + Object.keys(layerTypes));
      return false;
    }

    // Check if the layer must have an URL
    if (layerTypes[layerDefinition.type].mustHaveUrl && !isString(layerDefinition.url)) {
      $log.error('[AngularJS - Leaflet] A base layer must have an url');
      return false;
    }

    if (layerTypes[layerDefinition.type].mustHaveData && !isDefined(layerDefinition.data)) {
      $log.error('[AngularJS - Leaflet] The base layer must have a "data" array attribute');
      return false;
    }

    if (layerTypes[layerDefinition.type].mustHaveLayer && !isDefined(layerDefinition.layer)) {
      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have an layer defined');
      return false;
    }

    if (layerTypes[layerDefinition.type].mustHaveBounds && !isDefined(layerDefinition.bounds)) {
      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have bounds defined');
      return false;
    }

    if (layerTypes[layerDefinition.type].mustHaveKey && !isDefined(layerDefinition.key)) {
      $log.error('[AngularJS - Leaflet] The type of layer ' + layerDefinition.type + ' must have key defined');
      return false;
    }

    return true;
  }

  function createLayer(layerDefinition) {
    if (!isValidLayerType(layerDefinition)) {
      return;
    }

    if (!isString(layerDefinition.name)) {
      $log.error('[AngularJS - Leaflet] A base layer must have a name');
      return;
    }

    if (!isObject(layerDefinition.layerParams)) {
      layerDefinition.layerParams = {};
    }

    if (!isObject(layerDefinition.layerOptions)) {
      layerDefinition.layerOptions = {};
    }

    // Mix the layer specific parameters with the general Leaflet options. Although this is an overhead
    // the definition of a base layers is more 'clean' if the two types of parameters are differentiated
    for (var attrname in layerDefinition.layerParams) {
      layerDefinition.layerOptions[attrname] = layerDefinition.layerParams[attrname];
    }

    var params = {
      url: layerDefinition.url,
      data: layerDefinition.data,
      options: layerDefinition.layerOptions,
      layer: layerDefinition.layer,
      icon: layerDefinition.icon,
      type: layerDefinition.layerType,
      bounds: layerDefinition.bounds,
      key: layerDefinition.key,
      apiKey: layerDefinition.apiKey,
      pluginOptions: layerDefinition.pluginOptions,
      user: layerDefinition.user,
    };

    //TODO Add $watch to the layer properties
    return layerTypes[layerDefinition.type].createLayer(params);
  }

  function safeAddLayer(map, layer) {
    if (layer && typeof layer.addTo === 'function') {
      layer.addTo(map);
    } else {
      map.addLayer(layer);
    }
  }

  function safeRemoveLayer(map, layer, layerOptions) {
    if (isDefined(layerOptions) && isDefined(layerOptions.loadedDefer)) {
      if (angular.isFunction(layerOptions.loadedDefer)) {
        var defers = layerOptions.loadedDefer();
        $log.debug('Loaded Deferred', defers);
        var count = defers.length;
        if (count > 0) {
          var resolve = function() {
            count--;
            if (count === 0) {
              map.removeLayer(layer);
            }
          };

          for (var i = 0; i < defers.length; i++) {
            defers[i].promise.then(resolve);
          }
        } else {
          map.removeLayer(layer);
        }
      } else {
        layerOptions.loadedDefer.promise.then(function() {
          map.removeLayer(layer);
        });
      }
    } else {
      map.removeLayer(layer);
    }
  }

  return {
    createLayer: createLayer,
    safeAddLayer: safeAddLayer,
    safeRemoveLayer: safeRemoveLayer,
  };
}]);

angular.module('leaflet-directive').factory('leafletLegendHelpers', function() {
  var _updateLegend = function(div, legendData, type, url) {
    div.innerHTML = '';
    if (legendData.error) {
      div.innerHTML += '<div class="info-title alert alert-danger">' + legendData.error.message + '</div>';
    } else {
      if (type === 'arcgis') {
        for (var i = 0; i < legendData.layers.length; i++) {
          var layer = legendData.layers[i];
          div.innerHTML += '<div class="info-title" data-layerid="' + layer.layerId + '">' + layer.layerName + '</div>';
          for (var j = 0; j < layer.legend.length; j++) {
            var leg = layer.legend[j];
            div.innerHTML +=
            '<div class="inline" data-layerid="' + layer.layerId + '"><img src="data:' + leg.contentType + ';base64,' + leg.imageData + '" /></div>' +
            '<div class="info-label" data-layerid="' + layer.layerId + '">' + leg.label + '</div>';
          }
        }
      }      else if (type === 'image') {
        div.innerHTML = '<img src="' + url + '"/>';
      }
    }
  };

  var _getOnAddLegend = function(legendData, legendClass, type, url) {
    return function(/*map*/) {
      var div = L.DomUtil.create('div', legendClass);

      if (!L.Browser.touch) {
        L.DomEvent.disableClickPropagation(div);
        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
      } else {
        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
      }

      _updateLegend(div, legendData, type, url);
      return div;
    };
  };

  var _getOnAddArrayLegend = function(legend, legendClass) {
    return function(/*map*/) {
      var div = L.DomUtil.create('div', legendClass);
      for (var i = 0; i < legend.colors.length; i++) {
        div.innerHTML +=
            '<div class="outline"><i style="background:' + legend.colors[i] + '"></i></div>' +
            '<div class="info-label">' + legend.labels[i] + '</div>';
      }

      if (!L.Browser.touch) {
        L.DomEvent.disableClickPropagation(div);
        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
      } else {
        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
      }

      return div;
    };
  };

  return {
    getOnAddLegend: _getOnAddLegend,
    getOnAddArrayLegend: _getOnAddArrayLegend,
    updateLegend: _updateLegend,
  };
});

angular.module('leaflet-directive').factory('leafletMapDefaults', ["$q", "leafletHelpers", function($q, leafletHelpers) {
  function _getDefaults() {
    return {
      keyboard: true,
      dragging: true,
      worldCopyJump: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      tap: true,
      touchZoom: true,
      zoomControl: true,
      zoomsliderControl: false,
      zoomControlPosition: 'topleft',
      attributionControl: true,
      controls: {
        layers: {
          visible: true,
          position: 'topright',
          collapsed: true,
        },
      },
      nominatim: {
        server: ' http://nominatim.openstreetmap.org/search',
      },
      crs: L.CRS.EPSG3857,
      tileLayer: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      tileLayerOptions: {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
      path: {
        weight: 10,
        opacity: 1,
        color: '#0000ff',
      },
      center: {
        lat: 0,
        lng: 0,
        zoom: 1,
      },
    };
  }

  var isDefined = leafletHelpers.isDefined;
  var isObject = leafletHelpers.isObject;
  var obtainEffectiveMapId = leafletHelpers.obtainEffectiveMapId;
  var defaults = {};

  // Get the _defaults dictionary, and override the properties defined by the user
  return {
    reset: function() {
      defaults = {};
    },

    getDefaults: function(scopeId) {
      var mapId = obtainEffectiveMapId(defaults, scopeId);
      return defaults[mapId];
    },

    getMapCreationDefaults: function(scopeId) {
      var mapId = obtainEffectiveMapId(defaults, scopeId);
      var d = defaults[mapId];

      var mapDefaults = {
        maxZoom: d.maxZoom,
        keyboard: d.keyboard,
        dragging: d.dragging,
        zoomControl: d.zoomControl,
        doubleClickZoom: d.doubleClickZoom,
        scrollWheelZoom: d.scrollWheelZoom,
        tap: d.tap,
        touchZoom: d.touchZoom,
        attributionControl: d.attributionControl,
        worldCopyJump: d.worldCopyJump,
        crs: d.crs,
      };

      if (isDefined(d.minZoom)) {
        mapDefaults.minZoom = d.minZoom;
      }

      if (isDefined(d.zoomAnimation)) {
        mapDefaults.zoomAnimation = d.zoomAnimation;
      }

      if (isDefined(d.fadeAnimation)) {
        mapDefaults.fadeAnimation = d.fadeAnimation;
      }

      if (isDefined(d.markerZoomAnimation)) {
        mapDefaults.markerZoomAnimation = d.markerZoomAnimation;
      }

      if (d.map) {
        for (var option in d.map) {
          mapDefaults[option] = d.map[option];
        }
      }

      return mapDefaults;
    },

    setDefaults: function(userDefaults, scopeId) {
      var newDefaults = _getDefaults();

      if (isDefined(userDefaults)) {
        newDefaults.doubleClickZoom = isDefined(userDefaults.doubleClickZoom) ? userDefaults.doubleClickZoom : newDefaults.doubleClickZoom;
        newDefaults.scrollWheelZoom = isDefined(userDefaults.scrollWheelZoom) ? userDefaults.scrollWheelZoom : newDefaults.doubleClickZoom;
        newDefaults.tap = isDefined(userDefaults.tap) ? userDefaults.tap : newDefaults.tap;
        newDefaults.touchZoom = isDefined(userDefaults.touchZoom) ? userDefaults.touchZoom : newDefaults.doubleClickZoom;
        newDefaults.zoomControl = isDefined(userDefaults.zoomControl) ? userDefaults.zoomControl : newDefaults.zoomControl;
        newDefaults.zoomsliderControl = isDefined(userDefaults.zoomsliderControl) ? userDefaults.zoomsliderControl : newDefaults.zoomsliderControl;
        newDefaults.attributionControl = isDefined(userDefaults.attributionControl) ? userDefaults.attributionControl : newDefaults.attributionControl;
        newDefaults.tileLayer = isDefined(userDefaults.tileLayer) ? userDefaults.tileLayer : newDefaults.tileLayer;
        newDefaults.zoomControlPosition = isDefined(userDefaults.zoomControlPosition) ? userDefaults.zoomControlPosition : newDefaults.zoomControlPosition;
        newDefaults.keyboard = isDefined(userDefaults.keyboard) ? userDefaults.keyboard : newDefaults.keyboard;
        newDefaults.dragging = isDefined(userDefaults.dragging) ? userDefaults.dragging : newDefaults.dragging;

        if (isDefined(userDefaults.controls)) {
          angular.extend(newDefaults.controls, userDefaults.controls);
        }

        if (isObject(userDefaults.crs)) {
          newDefaults.crs = userDefaults.crs;
        } else if (isDefined(L.CRS[userDefaults.crs])) {
          newDefaults.crs = L.CRS[userDefaults.crs];
        }

        if (isDefined(userDefaults.center)) {
          angular.copy(userDefaults.center, newDefaults.center);
        }

        if (isDefined(userDefaults.tileLayerOptions)) {
          angular.copy(userDefaults.tileLayerOptions, newDefaults.tileLayerOptions);
        }

        if (isDefined(userDefaults.maxZoom)) {
          newDefaults.maxZoom = userDefaults.maxZoom;
        }

        if (isDefined(userDefaults.minZoom)) {
          newDefaults.minZoom = userDefaults.minZoom;
        }

        if (isDefined(userDefaults.zoomAnimation)) {
          newDefaults.zoomAnimation = userDefaults.zoomAnimation;
        }

        if (isDefined(userDefaults.fadeAnimation)) {
          newDefaults.fadeAnimation = userDefaults.fadeAnimation;
        }

        if (isDefined(userDefaults.markerZoomAnimation)) {
          newDefaults.markerZoomAnimation = userDefaults.markerZoomAnimation;
        }

        if (isDefined(userDefaults.worldCopyJump)) {
          newDefaults.worldCopyJump = userDefaults.worldCopyJump;
        }

        if (isDefined(userDefaults.map)) {
          newDefaults.map = userDefaults.map;
        }

        if (isDefined(userDefaults.path)) {
          newDefaults.path = userDefaults.path;
        }
      }

      var mapId = obtainEffectiveMapId(defaults, scopeId);
      defaults[mapId] = newDefaults;
      return newDefaults;
    },
  };
}]);

angular.module('leaflet-directive').service('leafletMarkersHelpers', ["$rootScope", "$timeout", "leafletHelpers", "$log", "$compile", "leafletGeoJsonHelpers", function($rootScope, $timeout, leafletHelpers, $log, $compile, leafletGeoJsonHelpers) {
  var isDefined = leafletHelpers.isDefined;
  var defaultTo = leafletHelpers.defaultTo;
  var MarkerClusterPlugin = leafletHelpers.MarkerClusterPlugin;
  var AwesomeMarkersPlugin = leafletHelpers.AwesomeMarkersPlugin;
  var VectorMarkersPlugin = leafletHelpers.VectorMarkersPlugin;
  var MakiMarkersPlugin = leafletHelpers.MakiMarkersPlugin;
  var ExtraMarkersPlugin = leafletHelpers.ExtraMarkersPlugin;
  var DomMarkersPlugin = leafletHelpers.DomMarkersPlugin;
  var safeApply = leafletHelpers.safeApply;
  var Helpers = leafletHelpers;
  var isString = leafletHelpers.isString;
  var isNumber = leafletHelpers.isNumber;
  var isObject = leafletHelpers.isObject;
  var groups = {};
  var geoHlp = leafletGeoJsonHelpers;
  var errorHeader = leafletHelpers.errorHeader;

  var _string = function(marker) {
    //this exists since JSON.stringify barfs on cyclic
    var retStr = '';
    ['_icon', '_latlng', '_leaflet_id', '_map', '_shadow'].forEach(function(prop) {
      retStr += prop + ': ' + defaultTo(marker[prop], 'undefined') + ' \n';
    });

    return '[leafletMarker] : \n' + retStr;
  };

  var _log = function(marker, useConsole) {
    var logger = useConsole ? console : $log;
    logger.debug(_string(marker));
  };

  var createLeafletIcon = function(iconData) {
    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'awesomeMarker') {
      if (!AwesomeMarkersPlugin.isLoaded()) {
        $log.error(errorHeader + ' The AwesomeMarkers Plugin is not loaded.');
      }

      return new L.AwesomeMarkers.icon(iconData);
    }

    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'vectorMarker') {
      if (!VectorMarkersPlugin.isLoaded()) {
        $log.error(errorHeader + ' The VectorMarkers Plugin is not loaded.');
      }

      return new L.VectorMarkers.icon(iconData);
    }

    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'makiMarker') {
      if (!MakiMarkersPlugin.isLoaded()) {
        $log.error(errorHeader + 'The MakiMarkers Plugin is not loaded.');
      }

      return new L.MakiMarkers.icon(iconData);
    }

    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'extraMarker') {
      if (!ExtraMarkersPlugin.isLoaded()) {
        $log.error(errorHeader + 'The ExtraMarkers Plugin is not loaded.');
      }

      return new L.ExtraMarkers.icon(iconData);
    }

    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'div') {
      return new L.divIcon(iconData);
    }

    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'dom') {
      if (!DomMarkersPlugin.isLoaded()) {
        $log.error(errorHeader + 'The DomMarkers Plugin is not loaded.');
      }

      var markerScope = angular.isFunction(iconData.getMarkerScope) ? iconData.getMarkerScope() : $rootScope;
      var template = $compile(iconData.template)(markerScope);
      var iconDataCopy = angular.copy(iconData);
      iconDataCopy.element = template[0];
      return new L.DomMarkers.icon(iconDataCopy);
    }

    // allow for any custom icon to be used... assumes the icon has already been initialized
    if (isDefined(iconData) && isDefined(iconData.type) && iconData.type === 'icon') {
      return iconData.icon;
    }

    var base64icon = 'data:image/png;base64,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';
    var base64shadow = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII=';

    if (!isDefined(iconData) || !isDefined(iconData.iconUrl)) {
      return new L.Icon.Default({
        iconUrl: base64icon,
        shadowUrl: base64shadow,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
    }

    return new L.Icon(iconData);
  };

  var _resetMarkerGroup = function(groupName) {
    if (isDefined(groups[groupName])) {
      groups.splice(groupName, 1);
    }
  };

  var _resetMarkerGroups = function() {
    groups = {};
  };

  var _deleteMarker = function(marker, map, layers) {
    marker.closePopup();

    // There is no easy way to know if a marker is added to a layer, so we search for it
    // if there are overlays
    if (isDefined(layers) && isDefined(layers.overlays)) {
      for (var key in layers.overlays) {
        if (layers.overlays[key] instanceof L.LayerGroup || layers.overlays[key] instanceof L.FeatureGroup) {
          if (layers.overlays[key].hasLayer(marker)) {
            layers.overlays[key].removeLayer(marker);
            return;
          }
        }
      }
    }

    if (isDefined(groups)) {
      for (var groupKey in groups) {
        if (groups[groupKey].hasLayer(marker)) {
          groups[groupKey].removeLayer(marker);
        }
      }
    }

    if (map.hasLayer(marker)) {
      map.removeLayer(marker);
    }
  };

  var adjustPopupPan = function(marker, map) {
    var containerHeight = marker._popup._container.offsetHeight;
    var layerPos = new L.Point(marker._popup._containerLeft, -containerHeight - marker._popup._containerBottom);
    var containerPos = map.layerPointToContainerPoint(layerPos);
    if (containerPos !== null) {
      marker._popup._adjustPan();
    }
  };

  var compilePopup = function(marker, markerScope) {
    $compile(marker._popup._contentNode)(markerScope);
  };

  var updatePopup = function(marker, markerScope, map) {
    //The innerText should be more than 1 once angular has compiled.
    //We need to keep trying until angular has compiled before we _updateLayout and _updatePosition
    //This should take care of any scenario , eg ngincludes, whatever.
    //Is there a better way to check for this?
    var innerText = marker._popup._contentNode.innerText || marker._popup._contentNode.textContent;
    if (innerText.length < 1) {
      $timeout(function() {
        updatePopup(marker, markerScope, map);
      });
    }

    //cause a reflow - this is also very important - if we don't do this then the widths are from before $compile
    var reflow = marker._popup._contentNode.offsetWidth;

    marker._popup._updateLayout();
    marker._popup._updatePosition();

    if (marker._popup.options.autoPan) {
      adjustPopupPan(marker, map);
    }

    //using / returning reflow so jshint doesn't moan
    return reflow;
  };

  var _manageOpenPopup = function(marker, markerData, map) {
    // The marker may provide a scope returning function used to compile the message
    // default to $rootScope otherwise
    var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
    var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;

    if (compileMessage) {
      if (!isDefined(marker._popup) || !isDefined(marker._popup._contentNode)) {
        $log.error(errorHeader + 'Popup is invalid or does not have any content.');
        return false;
      }

      compilePopup(marker, markerScope);
      updatePopup(marker, markerData, map);
    }
  };

  var _manageOpenLabel = function(marker, markerData) {
    var markerScope = angular.isFunction(markerData.getMessageScope) ? markerData.getMessageScope() : $rootScope;
    var labelScope = angular.isFunction(markerData.getLabelScope) ? markerData.getLabelScope() : markerScope;
    var compileMessage = isDefined(markerData.compileMessage) ? markerData.compileMessage : true;

    if (Helpers.LabelPlugin.isLoaded() && isDefined(markerData.label)) {
      if (isDefined(markerData.label.options) && markerData.label.options.noHide === true) {
        marker.showLabel();
      }

      if (compileMessage && isDefined(marker.label)) {
        $compile(marker.label._container)(labelScope);
      }
    }
  };

  var _updateMarker = function(markerData, oldMarkerData, marker, name, leafletScope, layers, map) {
    if (!isDefined(oldMarkerData)) {
      return;
    }

    // Update the lat-lng property (always present in marker properties)
    if (!geoHlp.validateCoords(markerData)) {
      $log.warn('There are problems with lat-lng data, please verify your marker model');
      _deleteMarker(marker, map, layers);
      return;
    }

    // watch is being initialized if old and new object is the same
    var isInitializing = markerData === oldMarkerData;

    // Update marker rotation
    if (isDefined(markerData.iconAngle) && oldMarkerData.iconAngle !== markerData.iconAngle) {
      marker.setIconAngle(markerData.iconAngle);
    }

    // It is possible that the layer has been removed or the layer marker does not exist
    // Update the layer group if present or move it to the map if not
    if (!isString(markerData.layer)) {
      // There is no layer information, we move the marker to the map if it was in a layer group
      if (isString(oldMarkerData.layer)) {
        // Remove from the layer group that is supposed to be
        if (isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
          layers.overlays[oldMarkerData.layer].removeLayer(marker);
          marker.closePopup();
        }

        // Test if it is not on the map and add it
        if (!map.hasLayer(marker)) {
          map.addLayer(marker);
        }
      }
    }

    if ((isNumber(markerData.opacity) || isNumber(parseFloat(markerData.opacity))) && markerData.opacity !== oldMarkerData.opacity) {
      // There was a different opacity so we update it
      marker.setOpacity(markerData.opacity);
    }

    if (isString(markerData.layer) && oldMarkerData.layer !== markerData.layer) {
      // If it was on a layer group we have to remove it
      if (isString(oldMarkerData.layer) && isDefined(layers.overlays[oldMarkerData.layer]) && layers.overlays[oldMarkerData.layer].hasLayer(marker)) {
        layers.overlays[oldMarkerData.layer].removeLayer(marker);
      }

      marker.closePopup();

      // Remove it from the map in case the new layer is hidden or there is an error in the new layer
      if (map.hasLayer(marker)) {
        map.removeLayer(marker);
      }

      // The markerData.layer is defined so we add the marker to the layer if it is different from the old data
      if (!isDefined(layers.overlays[markerData.layer])) {
        $log.error(errorHeader + 'You must use a name of an existing layer');
        return;
      }

      // Is a group layer?
      var layerGroup = layers.overlays[markerData.layer];
      if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
        $log.error(errorHeader + 'A marker can only be added to a layer of type "group" or "featureGroup"');
        return;
      }

      // The marker goes to a correct layer group, so first of all we add it
      layerGroup.addLayer(marker);

      // The marker is automatically added to the map depending on the visibility
      // of the layer, so we only have to open the popup if the marker is in the map
      if (map.hasLayer(marker) && markerData.focus === true) {
        marker.openPopup();
      }
    }

    // Update the draggable property
    if (markerData.draggable !== true && oldMarkerData.draggable === true && (isDefined(marker.dragging))) {
      marker.dragging.disable();
    }

    if (markerData.draggable === true && oldMarkerData.draggable !== true) {
      // The markerData.draggable property must be true so we update if there wasn't a previous value or it wasn't true
      if (marker.dragging) {
        marker.dragging.enable();
      } else {
        if (L.Handler.MarkerDrag) {
          marker.dragging = new L.Handler.MarkerDrag(marker);
          marker.options.draggable = true;
          marker.dragging.enable();
        }
      }
    }

    // Update the icon property
    if (!isObject(markerData.icon)) {
      // If there is no icon property or it's not an object
      if (isObject(oldMarkerData.icon)) {
        // If there was an icon before restore to the default
        marker.setIcon(createLeafletIcon());
        marker.closePopup();
        marker.unbindPopup();
        if (isString(markerData.message)) {
          marker.bindPopup(markerData.message, markerData.popupOptions);
        }
      }
    }

    if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
      var dragG = false;
      if (marker.dragging) {
        dragG = marker.dragging.enabled();
      }

      marker.setIcon(createLeafletIcon(markerData.icon));
      if (dragG) {
        marker.dragging.enable();
      }

      marker.closePopup();
      marker.unbindPopup();
      if (isString(markerData.message)) {
        marker.bindPopup(markerData.message, markerData.popupOptions);

        // if marker has been already focused, reopen popup
        if (map.hasLayer(marker) && markerData.focus === true) {
          marker.openPopup();
        }
      }
    }

    // Update the Popup message property
    if (!isString(markerData.message) && isString(oldMarkerData.message)) {
      marker.closePopup();
      marker.unbindPopup();
    }

    // Update the label content or bind a new label if the old one has been removed.
    if (Helpers.LabelPlugin.isLoaded()) {
      if (isDefined(markerData.label) && isDefined(markerData.label.message)) {
        if ('label' in oldMarkerData && 'message' in oldMarkerData.label && !angular.equals(markerData.label.message, oldMarkerData.label.message)) {
          marker.updateLabelContent(markerData.label.message);
        } else if (!angular.isFunction(marker.getLabel) || angular.isFunction(marker.getLabel) && !isDefined(marker.getLabel())) {
          marker.bindLabel(markerData.label.message, markerData.label.options);
          _manageOpenLabel(marker, markerData);
        } else {
          _manageOpenLabel(marker, markerData);
        }
      } else if (!('label' in markerData && !('message' in markerData.label))) {
        if (angular.isFunction(marker.unbindLabel)) {
          marker.unbindLabel();
        }
      }
    }

    // There is some text in the popup, so we must show the text or update existing
    if (isString(markerData.message) && !isString(oldMarkerData.message)) {
      // There was no message before so we create it
      marker.bindPopup(markerData.message, markerData.popupOptions);
    }

    if (isString(markerData.message) && isString(oldMarkerData.message) && markerData.message !== oldMarkerData.message) {
      // There was a different previous message so we update it
      marker.setPopupContent(markerData.message);
    }

    // Update the focus property
    var updatedFocus = false;
    if (markerData.focus !== true && oldMarkerData.focus === true) {
      // If there was a focus property and was true we turn it off
      marker.closePopup();
      updatedFocus = true;
    }

    // The markerData.focus property must be true so we update if there wasn't a previous value or it wasn't true
    if (markerData.focus === true && (!isDefined(oldMarkerData.focus) || oldMarkerData.focus === false) || (isInitializing && markerData.focus === true)) {
      // Reopen the popup when focus is still true
      marker.openPopup();
      updatedFocus = true;
    }

    // zIndexOffset adjustment
    if (oldMarkerData.zIndexOffset !== markerData.zIndexOffset) {
      marker.setZIndexOffset(markerData.zIndexOffset);
    }

    var markerLatLng = marker.getLatLng();
    var isCluster = (isString(markerData.layer) && Helpers.MarkerClusterPlugin.is(layers.overlays[markerData.layer]));

    // If the marker is in a cluster it has to be removed and added to the layer when the location is changed
    if (isCluster) {
      // The focus has changed even by a user click or programatically
      if (updatedFocus) {
        // We only have to update the location if it was changed programatically, because it was
        // changed by a user drag the marker data has already been updated by the internal event
        // listened by the directive
        if ((markerData.lat !== oldMarkerData.lat) || (markerData.lng !== oldMarkerData.lng)) {
          layers.overlays[markerData.layer].removeLayer(marker);
          marker.setLatLng([markerData.lat, markerData.lng]);
          layers.overlays[markerData.layer].addLayer(marker);
        }
      } else {
        // The marker has possibly moved. It can be moved by a user drag (marker location and data are equal but old
        // data is diferent) or programatically (marker location and data are diferent)
        if ((markerLatLng.lat !== markerData.lat) || (markerLatLng.lng !== markerData.lng)) {
          // The marker was moved by a user drag
          layers.overlays[markerData.layer].removeLayer(marker);
          marker.setLatLng([markerData.lat, markerData.lng]);
          layers.overlays[markerData.layer].addLayer(marker);
        } else if ((markerData.lat !== oldMarkerData.lat) || (markerData.lng !== oldMarkerData.lng)) {
          // The marker was moved programatically
          layers.overlays[markerData.layer].removeLayer(marker);
          marker.setLatLng([markerData.lat, markerData.lng]);
          layers.overlays[markerData.layer].addLayer(marker);
        } else if (isObject(markerData.icon) && isObject(oldMarkerData.icon) && !angular.equals(markerData.icon, oldMarkerData.icon)) {
          layers.overlays[markerData.layer].removeLayer(marker);
          layers.overlays[markerData.layer].addLayer(marker);
        }
      }
    } else if (markerLatLng.lat !== markerData.lat || markerLatLng.lng !== markerData.lng) {
      marker.setLatLng([markerData.lat, markerData.lng]);
    }
  };

  return {
    resetMarkerGroup: _resetMarkerGroup,

    resetMarkerGroups: _resetMarkerGroups,

    deleteMarker: _deleteMarker,

    manageOpenPopup: _manageOpenPopup,

    manageOpenLabel: _manageOpenLabel,

    createMarker: function(markerData) {
      if (!isDefined(markerData) || !geoHlp.validateCoords(markerData)) {
        $log.error(errorHeader + 'The marker definition is not valid.');
        return;
      }

      var coords = geoHlp.getCoords(markerData);

      if (!isDefined(coords)) {
        $log.error(errorHeader + 'Unable to get coordinates from markerData.');
        return;
      }

      var markerOptions = {
        icon: createLeafletIcon(markerData.icon),
        title: isDefined(markerData.title) ? markerData.title : '',
        draggable: isDefined(markerData.draggable) ? markerData.draggable : false,
        clickable: isDefined(markerData.clickable) ? markerData.clickable : true,
        riseOnHover: isDefined(markerData.riseOnHover) ? markerData.riseOnHover : false,
        zIndexOffset: isDefined(markerData.zIndexOffset) ? markerData.zIndexOffset : 0,
        iconAngle: isDefined(markerData.iconAngle) ? markerData.iconAngle : 0,
      };

      // Add any other options not added above to markerOptions
      for (var markerDatum in markerData) {
        if (markerData.hasOwnProperty(markerDatum) && !markerOptions.hasOwnProperty(markerDatum)) {
          markerOptions[markerDatum] = markerData[markerDatum];
        }
      }

      var marker = new L.marker(coords, markerOptions);

      if (!isString(markerData.message)) {
        marker.unbindPopup();
      }

      return marker;
    },

    addMarkerToGroup: function(marker, groupName, groupOptions, map) {
      if (!isString(groupName)) {
        $log.error(errorHeader + 'The marker group you have specified is invalid.');
        return;
      }

      if (!MarkerClusterPlugin.isLoaded()) {
        $log.error(errorHeader + 'The MarkerCluster plugin is not loaded.');
        return;
      }

      if (!isDefined(groups[groupName])) {
        groups[groupName] = new L.MarkerClusterGroup(groupOptions);
        map.addLayer(groups[groupName]);
      }

      groups[groupName].addLayer(marker);
    },

    listenMarkerEvents: function(marker, markerData, leafletScope, doWatch, map) {
      marker.on('popupopen', function(/* event */) {
        safeApply(leafletScope, function() {
          if (isDefined(marker._popup) || isDefined(marker._popup._contentNode)) {
            markerData.focus = true;
            _manageOpenPopup(marker, markerData, map);//needed since markerData is now a copy
          }
        });
      });

      marker.on('popupclose', function(/* event */) {
        safeApply(leafletScope, function() {
          markerData.focus = false;
        });
      });

      marker.on('add', function(/* event */) {
        safeApply(leafletScope, function() {
          if ('label' in markerData)
              _manageOpenLabel(marker, markerData);
        });
      });
    },

    updateMarker: _updateMarker,

    addMarkerWatcher: function(marker, name, leafletScope, layers, map, isDeepWatch) {
      var markerWatchPath = Helpers.getObjectArrayPath('markers.' + name);
      isDeepWatch = defaultTo(isDeepWatch, true);

      var clearWatch = leafletScope.$watch(markerWatchPath, function(markerData, oldMarkerData) {
        if (!isDefined(markerData)) {
          _deleteMarker(marker, map, layers);
          clearWatch();
          return;
        }

        _updateMarker(markerData, oldMarkerData, marker, name, leafletScope, layers, map);
      }, isDeepWatch);
    },

    string: _string,
    log: _log,
  };
}]);

angular.module('leaflet-directive').factory('leafletPathsHelpers', ["$rootScope", "$log", "leafletHelpers", function($rootScope, $log, leafletHelpers) {
  var isDefined = leafletHelpers.isDefined;
  var isArray = leafletHelpers.isArray;
  var isNumber = leafletHelpers.isNumber;
  var isValidPoint = leafletHelpers.isValidPoint;

  var availableOptions = [

      // Path options
      'stroke', 'weight', 'color', 'opacity',
      'fill', 'fillColor', 'fillOpacity',
      'dashArray', 'lineCap', 'lineJoin', 'clickable',
      'pointerEvents', 'className',

      // Polyline options
      'smoothFactor', 'noClip',
  ];
  function _convertToLeafletLatLngs(latlngs) {
    return latlngs.filter(function(latlng) {
      return isValidPoint(latlng);
    }).map(function(latlng) {
      return _convertToLeafletLatLng(latlng);
    });
  }

  function _convertToLeafletLatLng(latlng) {
    if (isArray(latlng)) {
      return new L.LatLng(latlng[0], latlng[1]);
    } else {
      return new L.LatLng(latlng.lat, latlng.lng);
    }
  }

  function _convertToLeafletMultiLatLngs(paths) {
    return paths.map(function(latlngs) {
      return _convertToLeafletLatLngs(latlngs);
    });
  }

  function _getOptions(path, defaults) {
    var options = {};
    for (var i = 0; i < availableOptions.length; i++) {
      var optionName = availableOptions[i];

      if (isDefined(path[optionName])) {
        options[optionName] = path[optionName];
      } else if (isDefined(defaults.path[optionName])) {
        options[optionName] = defaults.path[optionName];
      }
    }

    return options;
  }

  var _updatePathOptions = function(path, data) {
    var updatedStyle = {};
    for (var i = 0; i < availableOptions.length; i++) {
      var optionName = availableOptions[i];
      if (isDefined(data[optionName])) {
        updatedStyle[optionName] = data[optionName];
      }
    }

    path.setStyle(data);
  };

  var _isValidPolyline = function(latlngs) {
    if (!isArray(latlngs)) {
      return false;
    }

    for (var i = 0; i < latlngs.length; i++) {
      var point = latlngs[i];
      if (!isValidPoint(point)) {
        return false;
      }
    }

    return true;
  };

  var pathTypes = {
    polyline: {
      isValid: function(pathData) {
        var latlngs = pathData.latlngs;
        return _isValidPolyline(latlngs);
      },

      createPath: function(options) {
        return new L.Polyline([], options);
      },

      setPath: function(path, data) {
        path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
        _updatePathOptions(path, data);
        return;
      },
    },
    multiPolyline: {
      isValid: function(pathData) {
        var latlngs = pathData.latlngs;
        if (!isArray(latlngs)) {
          return false;
        }

        for (var i in latlngs) {
          var polyline = latlngs[i];
          if (!_isValidPolyline(polyline)) {
            return false;
          }
        }

        return true;
      },

      createPath: function(options) {
        return new L.multiPolyline([[[0, 0], [1, 1]]], options);
      },

      setPath: function(path, data) {
        path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
        _updatePathOptions(path, data);
        return;
      },
    },
    polygon: {
      isValid: function(pathData) {
        var latlngs = pathData.latlngs;
        return _isValidPolyline(latlngs);
      },

      createPath: function(options) {
        return new L.Polygon([], options);
      },

      setPath: function(path, data) {
        path.setLatLngs(_convertToLeafletLatLngs(data.latlngs));
        _updatePathOptions(path, data);
        return;
      },
    },
    multiPolygon: {
      isValid: function(pathData) {
        var latlngs = pathData.latlngs;

        if (!isArray(latlngs)) {
          return false;
        }

        for (var i in latlngs) {
          var polyline = latlngs[i];
          if (!_isValidPolyline(polyline)) {
            return false;
          }
        }

        return true;
      },

      createPath: function(options) {
        return new L.MultiPolygon([[[0, 0], [1, 1], [0, 1]]], options);
      },

      setPath: function(path, data) {
        path.setLatLngs(_convertToLeafletMultiLatLngs(data.latlngs));
        _updatePathOptions(path, data);
        return;
      },
    },
    rectangle: {
      isValid: function(pathData) {
        var latlngs = pathData.latlngs;

        if (!isArray(latlngs) || latlngs.length !== 2) {
          return false;
        }

        for (var i in latlngs) {
          var point = latlngs[i];
          if (!isValidPoint(point)) {
            return false;
          }
        }

        return true;
      },

      createPath: function(options) {
        return new L.Rectangle([[0, 0], [1, 1]], options);
      },

      setPath: function(path, data) {
        path.setBounds(new L.LatLngBounds(_convertToLeafletLatLngs(data.latlngs)));
        _updatePathOptions(path, data);
      },
    },
    circle: {
      isValid: function(pathData) {
        var point = pathData.latlngs;
        return isValidPoint(point) && isNumber(pathData.radius);
      },

      createPath: function(options) {
        return new L.Circle([0, 0], 1, options);
      },

      setPath: function(path, data) {
        path.setLatLng(_convertToLeafletLatLng(data.latlngs));
        if (isDefined(data.radius)) {
          path.setRadius(data.radius);
        }

        _updatePathOptions(path, data);
      },
    },
    circleMarker: {
      isValid: function(pathData) {
        var point = pathData.latlngs;
        return isValidPoint(point) && isNumber(pathData.radius);
      },

      createPath: function(options) {
        return new L.CircleMarker([0, 0], options);
      },

      setPath: function(path, data) {
        path.setLatLng(_convertToLeafletLatLng(data.latlngs));
        if (isDefined(data.radius)) {
          path.setRadius(data.radius);
        }

        _updatePathOptions(path, data);
      },
    },
  };

  var _getPathData = function(path) {
    var pathData = {};
    if (path.latlngs) {
      pathData.latlngs = path.latlngs;
    }

    if (path.radius) {
      pathData.radius = path.radius;
    }

    return pathData;
  };

  return {
    setPathOptions: function(leafletPath, pathType, data) {
      if (!isDefined(pathType)) {
        pathType = 'polyline';
      }

      pathTypes[pathType].setPath(leafletPath, data);
    },

    createPath: function(name, path, defaults) {
      if (!isDefined(path.type)) {
        path.type = 'polyline';
      }

      var options = _getOptions(path, defaults);
      var pathData = _getPathData(path);

      if (!pathTypes[path.type].isValid(pathData)) {
        $log.error('[AngularJS - Leaflet] Invalid data passed to the ' + path.type + ' path');
        return;
      }

      return pathTypes[path.type].createPath(options);
    },
  };
}]);

angular.module('leaflet-directive')
.service('leafletWatchHelpers', function() {

  var _maybe = function(scope, watchFunctionName, thingToWatchStr, watchOptions, initCb) {
    //watchOptions.isDeep is/should be ignored in $watchCollection
    var unWatch = scope[watchFunctionName](thingToWatchStr, function(newValue, oldValue) {
      initCb(newValue, oldValue);
      if (!watchOptions.doWatch)
          unWatch();
    }, watchOptions.isDeep);

    return unWatch;
  };

  /*
  @name: maybeWatch
  @description: Utility to watch something once or forever.
  @returns unWatch function
  @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
  to set watching to once and its watch depth.
  */
  var _maybeWatch = function(scope, thingToWatchStr, watchOptions, initCb) {
    return _maybe(scope, '$watch', thingToWatchStr, watchOptions, initCb);
  };

  /*
  @name: _maybeWatchCollection
  @description: Utility to watch something once or forever.
  @returns unWatch function
  @param watchOptions - see markersWatchOptions and or derrivatives. This object is used
  to set watching to once and its watch depth.
  */
  var _maybeWatchCollection = function(scope, thingToWatchStr, watchOptions, initCb) {
    return _maybe(scope, '$watchCollection', thingToWatchStr, watchOptions, initCb);
  };

  return {
    maybeWatch: _maybeWatch,
    maybeWatchCollection: _maybeWatchCollection,
  };
});

angular.module('leaflet-directive').factory('nominatimService', ["$q", "$http", "leafletHelpers", "leafletMapDefaults", function($q, $http, leafletHelpers, leafletMapDefaults) {
  var isDefined = leafletHelpers.isDefined;

  return {
    query: function(address, mapId) {
      var defaults = leafletMapDefaults.getDefaults(mapId);
      var url = defaults.nominatim.server;
      var df = $q.defer();

      $http.get(url, { params: { format: 'json', limit: 1, q: address } }).success(function(data) {
        if (data.length > 0 && isDefined(data[0].boundingbox)) {
          df.resolve(data[0]);
        } else {
          df.reject('[Nominatim] Invalid address');
        }
      });

      return df.promise;
    },
  };
}]);

angular.module('leaflet-directive').directive('bounds', ["$log", "$timeout", "$http", "leafletHelpers", "nominatimService", "leafletBoundsHelpers", function($log, $timeout, $http, leafletHelpers, nominatimService, leafletBoundsHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: ['leaflet'],

    link: function(scope, element, attrs, controller) {
      var isDefined = leafletHelpers.isDefined;
      var createLeafletBounds = leafletBoundsHelpers.createLeafletBounds;
      var leafletScope = controller[0].getLeafletScope();
      var mapController = controller[0];
      var errorHeader = leafletHelpers.errorHeader + ' [Bounds] ';

      var emptyBounds = function(bounds) {
        return (bounds._southWest.lat === 0 && bounds._southWest.lng === 0 &&
                bounds._northEast.lat === 0 && bounds._northEast.lng === 0);
      };

      mapController.getMap().then(function(map) {
        leafletScope.$on('boundsChanged', function(event) {
          var scope = event.currentScope;
          var bounds = map.getBounds();

          if (emptyBounds(bounds) || scope.settingBoundsFromScope) {
            return;
          }

          scope.settingBoundsFromLeaflet = true;
          var newScopeBounds = {
            northEast: {
              lat: bounds._northEast.lat,
              lng: bounds._northEast.lng,
            },
            southWest: {
              lat: bounds._southWest.lat,
              lng: bounds._southWest.lng,
            },
            options: bounds.options,
          };
          if (!angular.equals(scope.bounds, newScopeBounds)) {
            scope.bounds = newScopeBounds;
          }

          $timeout(function() {
            scope.settingBoundsFromLeaflet = false;
          });
        });

        var lastNominatimQuery;
        leafletScope.$watch('bounds', function(bounds) {
          if (scope.settingBoundsFromLeaflet)
              return;
          if (isDefined(bounds.address) && bounds.address !== lastNominatimQuery) {
            scope.settingBoundsFromScope = true;
            nominatimService.query(bounds.address, attrs.id).then(function(data) {
              var b = data.boundingbox;
              var newBounds = [[b[0], b[2]], [b[1], b[3]]];
              map.fitBounds(newBounds);
            }, function(errMsg) {

              $log.error(errorHeader + ' ' + errMsg + '.');
            });

            lastNominatimQuery = bounds.address;
            $timeout(function() {
              scope.settingBoundsFromScope = false;
            });

            return;
          }

          var leafletBounds = createLeafletBounds(bounds);
          if (leafletBounds && !map.getBounds().equals(leafletBounds)) {
            scope.settingBoundsFromScope = true;
            map.fitBounds(leafletBounds, bounds.options);
            $timeout(function() {
              scope.settingBoundsFromScope = false;
            });
          }
        }, true);
      });
    },
  };
}]);

var centerDirectiveTypes = ['lfCenter'];
var centerDirectives = {};

centerDirectiveTypes.forEach(function(directiveName) {
  centerDirectives[directiveName] = ['$log', '$q', '$location', '$timeout', 'leafletMapDefaults', 'leafletHelpers',
      'leafletBoundsHelpers', 'leafletMapEvents',
        function($log, $q, $location, $timeout, leafletMapDefaults, leafletHelpers,
      leafletBoundsHelpers, leafletMapEvents) {

      var isDefined = leafletHelpers.isDefined;
      var isNumber = leafletHelpers.isNumber;
      var isSameCenterOnMap = leafletHelpers.isSameCenterOnMap;
      var safeApply = leafletHelpers.safeApply;
      var isValidCenter = leafletHelpers.isValidCenter;
      var isValidBounds = leafletBoundsHelpers.isValidBounds;
      var isUndefinedOrEmpty = leafletHelpers.isUndefinedOrEmpty;
      var errorHeader = leafletHelpers.errorHeader;

      var shouldInitializeMapWithBounds = function(bounds, center) {
        return isDefined(bounds) && isValidBounds(bounds) && isUndefinedOrEmpty(center);
      };

      var _leafletCenter;
      return {
        restrict: 'A',
        scope: false,
        replace: false,
        require: 'leaflet',
        controller: function() {
          _leafletCenter = $q.defer();
          this.getCenter = function() {
            return _leafletCenter.promise;
          };
        },

        link: function(scope, element, attrs, controller) {
          var leafletScope = controller.getLeafletScope();
          var centerModel = leafletScope[directiveName];

          controller.getMap().then(function(map) {
            var defaults = leafletMapDefaults.getDefaults(attrs.id);

            if (attrs[directiveName].search('-') !== -1) {
              $log.error(errorHeader + ' The "center" variable can\'t use a "-" on its key name: "' + attrs[directiveName] + '".');
              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
              return;
            } else if (shouldInitializeMapWithBounds(leafletScope.bounds, centerModel)) {
              map.fitBounds(leafletBoundsHelpers.createLeafletBounds(leafletScope.bounds), leafletScope.bounds.options);
              centerModel = map.getCenter();
              safeApply(leafletScope, function(scope) {
                angular.extend(scope[directiveName], {
                  lat: map.getCenter().lat,
                  lng: map.getCenter().lng,
                  zoom: map.getZoom(),
                  autoDiscover: false,
                });
              });

              safeApply(leafletScope, function(scope) {
                var mapBounds = map.getBounds();
                scope.bounds = {
                  northEast: {
                    lat: mapBounds._northEast.lat,
                    lng: mapBounds._northEast.lng,
                  },
                  southWest: {
                    lat: mapBounds._southWest.lat,
                    lng: mapBounds._southWest.lng,
                  },
                };
              });
            } else if (!isDefined(centerModel)) {
              $log.error(errorHeader + ' The "center" property is not defined in the main scope');
              map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
              return;
            } else if (!(isDefined(centerModel.lat) && isDefined(centerModel.lng)) && !isDefined(centerModel.autoDiscover)) {
              angular.copy(defaults.center, centerModel);
            }

            var urlCenterHash;
            var mapReady;
            if (attrs.urlHashCenter === 'yes') {
              var extractCenterFromUrl = function() {
                var search = $location.search();
                var centerParam;
                if (isDefined(search.c)) {
                  var cParam = search.c.split(':');
                  if (cParam.length === 3) {
                    centerParam = {
                      lat: parseFloat(cParam[0]),
                      lng: parseFloat(cParam[1]),
                      zoom: parseInt(cParam[2], 10),
                    };
                  }
                }

                return centerParam;
              };

              urlCenterHash = extractCenterFromUrl();

              leafletScope.$on('$locationChangeSuccess', function(event) {
                var scope = event.currentScope;

                //$log.debug("updated location...");
                var urlCenter = extractCenterFromUrl();
                if (isDefined(urlCenter) && !isSameCenterOnMap(urlCenter, map)) {
                  //$log.debug("updating center model...", urlCenter);
                  angular.extend(scope[directiveName], {
                    lat: urlCenter.lat,
                    lng: urlCenter.lng,
                    zoom: urlCenter.zoom,
                  });
                }
              });
            }

            leafletScope.$watch(directiveName, function(center) {
              if (leafletScope.settingCenterFromLeaflet)
                  return;

              //$log.debug("updated center model...");
              // The center from the URL has priority
              if (isDefined(urlCenterHash)) {
                angular.copy(urlCenterHash, center);
                urlCenterHash = undefined;
              }

              if (!isValidCenter(center) && center.autoDiscover !== true) {
                $log.warn(errorHeader + ' invalid \'center\'');

                //map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
                return;
              }

              if (center.autoDiscover === true) {
                if (!isNumber(center.zoom)) {
                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
                }

                if (isNumber(center.zoom) && center.zoom > defaults.center.zoom) {
                  map.locate({
                    setView: true,
                    maxZoom: center.zoom,
                  });
                } else if (isDefined(defaults.maxZoom)) {
                  map.locate({
                    setView: true,
                    maxZoom: defaults.maxZoom,
                  });
                } else {
                  map.locate({
                    setView: true,
                  });
                }

                return;
              }

              if (mapReady && isSameCenterOnMap(center, map)) {
                //$log.debug("no need to update map again.");
                return;
              }

              //$log.debug("updating map center...", center);
              leafletScope.settingCenterFromScope = true;
              map.setView([center.lat, center.lng], center.zoom);
              leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
              $timeout(function() {
                leafletScope.settingCenterFromScope = false;

                //$log.debug("allow center scope updates");
              });
            }, true);

            map.whenReady(function() {
              mapReady = true;
            });

            map.on('moveend', function(/* event */) {
              // Resolve the center after the first map position
              _leafletCenter.resolve();
              leafletMapEvents.notifyCenterUrlHashChanged(leafletScope, map, attrs, $location.search());

              //$log.debug("updated center on map...");
              if (isSameCenterOnMap(centerModel, map) || leafletScope.settingCenterFromScope) {
                //$log.debug("same center in model, no need to update again.");
                return;
              }

              leafletScope.settingCenterFromLeaflet = true;
              safeApply(leafletScope, function(scope) {
                if (!leafletScope.settingCenterFromScope) {
                  //$log.debug("updating center model...", map.getCenter(), map.getZoom());
                  angular.extend(scope[directiveName], {
                    lat: map.getCenter().lat,
                    lng: map.getCenter().lng,
                    zoom: map.getZoom(),
                    autoDiscover: false,
                  });
                }

                leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
                $timeout(function() {
                  leafletScope.settingCenterFromLeaflet = false;
                });
              });
            });

            if (centerModel.autoDiscover === true) {
              map.on('locationerror', function() {
                $log.warn(errorHeader + ' The Geolocation API is unauthorized on this page.');
                if (isValidCenter(centerModel)) {
                  map.setView([centerModel.lat, centerModel.lng], centerModel.zoom);
                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
                } else {
                  map.setView([defaults.center.lat, defaults.center.lng], defaults.center.zoom);
                  leafletMapEvents.notifyCenterChangedToBounds(leafletScope, map);
                }
              });
            }
          });
        },
      };
    },
    ];
});

centerDirectiveTypes.forEach(function(dirType) {
  angular.module('leaflet-directive').directive(dirType, centerDirectives[dirType]);
});

angular.module('leaflet-directive').directive('controls', ["$log", "leafletHelpers", "leafletControlHelpers", function($log, leafletHelpers, leafletControlHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: '?^leaflet',

    link: function(scope, element, attrs, controller) {
      if (!controller) {
        return;
      }

      var createControl = leafletControlHelpers.createControl;
      var isValidControlType = leafletControlHelpers.isValidControlType;
      var leafletScope  = controller.getLeafletScope();
      var isDefined = leafletHelpers.isDefined;
      var isArray = leafletHelpers.isArray;
      var leafletControls = {};
      var errorHeader = leafletHelpers.errorHeader + ' [Controls] ';

      controller.getMap().then(function(map) {

        leafletScope.$watchCollection('controls', function(newControls) {

          // Delete controls from the array
          for (var name in leafletControls) {
            if (!isDefined(newControls[name])) {
              if (map.hasControl(leafletControls[name])) {
                map.removeControl(leafletControls[name]);
              }

              delete leafletControls[name];
            }
          }

          for (var newName in newControls) {
            var control;

            var controlType = isDefined(newControls[newName].type) ? newControls[newName].type : newName;

            if (!isValidControlType(controlType)) {
              $log.error(errorHeader + ' Invalid control type: ' + controlType + '.');
              return;
            }

            if (controlType !== 'custom') {
              control = createControl(controlType, newControls[newName]);
              map.addControl(control);
              leafletControls[newName] = control;
            } else {
              var customControlValue = newControls[newName];
              if (isArray(customControlValue)) {
                for (var i in customControlValue) {
                  var customControl = customControlValue[i];
                  map.addControl(customControl);
                  leafletControls[newName] = !isDefined(leafletControls[newName]) ? [customControl] : leafletControls[newName].concat([customControl]);
                }
              } else {
                map.addControl(customControlValue);
                leafletControls[newName] = customControlValue;
              }
            }
          }

        });

      });
    },
  };
}]);

angular.module('leaflet-directive').directive('decorations', ["$log", "leafletHelpers", function($log, leafletHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {
      var leafletScope = controller.getLeafletScope();
      var PolylineDecoratorPlugin = leafletHelpers.PolylineDecoratorPlugin;
      var isDefined = leafletHelpers.isDefined;
      var leafletDecorations = {};

      /* Creates an "empty" decoration with a set of coordinates, but no pattern. */
      function createDecoration(options) {
        if (isDefined(options) && isDefined(options.coordinates)) {
          if (!PolylineDecoratorPlugin.isLoaded()) {
            $log.error('[AngularJS - Leaflet] The PolylineDecorator Plugin is not loaded.');
          }
        }

        return L.polylineDecorator(options.coordinates);
      }

      /* Updates the path and the patterns for the provided decoration, and returns the decoration. */
      function setDecorationOptions(decoration, options) {
        if (isDefined(decoration) && isDefined(options)) {
          if (isDefined(options.coordinates) && isDefined(options.patterns)) {
            decoration.setPaths(options.coordinates);
            decoration.setPatterns(options.patterns);
            return decoration;
          }
        }
      }

      controller.getMap().then(function(map) {
        leafletScope.$watch('decorations', function(newDecorations) {
          for (var name in leafletDecorations) {
            if (!isDefined(newDecorations[name]) || !angular.equals(newDecorations[name], leafletDecorations)) {
              map.removeLayer(leafletDecorations[name]);
              delete leafletDecorations[name];
            }
          }

          for (var newName in newDecorations) {
            var decorationData = newDecorations[newName];
            var newDecoration = createDecoration(decorationData);

            if (isDefined(newDecoration)) {
              leafletDecorations[newName] = newDecoration;
              map.addLayer(newDecoration);
              setDecorationOptions(newDecoration, decorationData);
            }
          }
        }, true);
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('eventBroadcast', ["$log", "$rootScope", "leafletHelpers", "leafletMapEvents", "leafletIterators", function($log, $rootScope, leafletHelpers, leafletMapEvents, leafletIterators) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {
      var isObject = leafletHelpers.isObject;
      var isDefined = leafletHelpers.isDefined;
      var leafletScope  = controller.getLeafletScope();
      var eventBroadcast = leafletScope.eventBroadcast;
      var availableMapEvents = leafletMapEvents.getAvailableMapEvents();
      var addEvents = leafletMapEvents.addEvents;

      controller.getMap().then(function(map) {

        var mapEvents = [];
        var logic = 'broadcast';

        // We have a possible valid object
        if (!isDefined(eventBroadcast.map)) {
          // We do not have events enable/disable do we do nothing (all enabled by default)
          mapEvents = availableMapEvents;
        } else if (!isObject(eventBroadcast.map)) {
          // Not a valid object
          $log.warn('[AngularJS - Leaflet] event-broadcast.map must be an object check your model.');
        } else {
          // We have a possible valid map object
          // Event propadation logic
          if (eventBroadcast.map.logic !== 'emit' && eventBroadcast.map.logic !== 'broadcast') {
            // This is an error
            $log.warn('[AngularJS - Leaflet] Available event propagation logic are: \'emit\' or \'broadcast\'.');
          } else {
            logic = eventBroadcast.map.logic;
          }

          if (!(isObject(eventBroadcast.map.enable) && eventBroadcast.map.enable.length >= 0)) {
            $log.warn('[AngularJS - Leaflet] event-broadcast.map.enable must be an object check your model.');
          } else {
            // Enable events
            leafletIterators.each(eventBroadcast.map.enable, function(eventName) {
              // Do we have already the event enabled?
              if (mapEvents.indexOf(eventName) === -1 && availableMapEvents.indexOf(eventName) !== -1) {
                mapEvents.push(eventName);
              }
            });
          }

        }

        // as long as the map is removed in the root leaflet directive we
        // do not need ot clean up the events as leaflet does it itself
        addEvents(map, mapEvents, 'eventName', leafletScope, logic);
      });
    },
  };
}]);

angular.module('leaflet-directive')
.directive('geojson', ["$log", "$rootScope", "leafletData", "leafletHelpers", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", "leafletIterators", "leafletGeoJsonEvents", function($log, $rootScope, leafletData, leafletHelpers,
    leafletWatchHelpers, leafletDirectiveControlsHelpers, leafletIterators, leafletGeoJsonEvents) {
  var _maybeWatch = leafletWatchHelpers.maybeWatch;
  var _watchOptions = leafletHelpers.watchOptions;
  var _extendDirectiveControls = leafletDirectiveControlsHelpers.extend;
  var hlp = leafletHelpers;
  var $it = leafletIterators;

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {
      var isDefined = leafletHelpers.isDefined;
      var leafletScope  = controller.getLeafletScope();
      var leafletGeoJSON = {};
      var _hasSetLeafletData = false;

      controller.getMap().then(function(map) {
        var watchOptions = leafletScope.geojsonWatchOptions || _watchOptions;

        var _hookUpEvents = function(geojson, maybeName) {
          var onEachFeature;

          if (angular.isFunction(geojson.onEachFeature)) {
            onEachFeature = geojson.onEachFeature;
          } else {
            onEachFeature = function(feature, layer) {
              if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(feature.properties.description)) {
                layer.bindLabel(feature.properties.description);
              }

              leafletGeoJsonEvents.bindEvents(attrs.id, layer, null, feature,
                  leafletScope, maybeName,
                  {resetStyleOnMouseout: geojson.resetStyleOnMouseout,
                  mapId: attrs.id, });
            };
          }

          return onEachFeature;
        };

        var isNested = (hlp.isDefined(attrs.geojsonNested) &&
            hlp.isTruthy(attrs.geojsonNested));

        var _clean = function() {
          if (!leafletGeoJSON)
              return;
          var _remove = function(lObject) {
            if (isDefined(lObject) && map.hasLayer(lObject)) {
              map.removeLayer(lObject);
            }
          };

          if (isNested) {
            $it.each(leafletGeoJSON, function(lObject) {
              _remove(lObject);
            });

            return;
          }

          _remove(leafletGeoJSON);
        };

        var _addGeojson = function(model, maybeName) {
          var geojson = angular.copy(model);
          if (!(isDefined(geojson) && isDefined(geojson.data))) {
            return;
          }

          var onEachFeature = _hookUpEvents(geojson, maybeName);

          if (!isDefined(geojson.options)) {
            //right here is why we use a clone / copy (we modify and thus)
            //would kick of a watcher.. we need to be more careful everywhere
            //for stuff like this
            geojson.options = {
              style: geojson.style,
              filter: geojson.filter,
              onEachFeature: onEachFeature,
              pointToLayer: geojson.pointToLayer,
            };
          }

          var lObject = L.geoJson(geojson.data, geojson.options);

          if (maybeName && hlp.isString(maybeName)) {
            leafletGeoJSON[maybeName] = lObject;
          }          else {
            leafletGeoJSON = lObject;
          }

          lObject.addTo(map);

          if (!_hasSetLeafletData) {//only do this once and play with the same ref forever
            _hasSetLeafletData = true;
            leafletData.setGeoJSON(leafletGeoJSON, attrs.id);
          }
        };

        var _create = function(model) {
          _clean();
          if (isNested) {
            if (!model || !Object.keys(model).length)
                return;
            $it.each(model, function(m, name) {
              //name could be layerName and or groupName
              //for now it is not tied to a layer
              _addGeojson(m, name);
            });

            return;
          }

          _addGeojson(model);
        };

        _extendDirectiveControls(attrs.id, 'geojson', _create, _clean);

        _maybeWatch(leafletScope, 'geojson', watchOptions, function(geojson) {
          _create(geojson);
        });
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('layercontrol', ["$filter", "$log", "leafletData", "leafletHelpers", function($filter, $log, leafletData, leafletHelpers) {

  return {
    restrict: 'E',
    scope: {
      icons: '=?',
      autoHideOpacity: '=?', // Hide other opacity controls when one is activated.
      showGroups: '=?', // Hide other opacity controls when one is activated.
      title: '@',
      baseTitle: '@',
      overlaysTitle: '@',
    },
    replace: true,
    transclude: false,
    require: '^leaflet',
    controller: ["$scope", "$element", "$sce", function($scope, $element, $sce) {
      $log.debug('[Angular Directive - Layers] layers', $scope, $element);
      var safeApply = leafletHelpers.safeApply;
      var isDefined = leafletHelpers.isDefined;
      angular.extend($scope, {
        baselayer: '',
        oldGroup: '',
        layerProperties: {},
        groupProperties: {},
        rangeIsSupported: leafletHelpers.rangeIsSupported(),
        changeBaseLayer: function(key, e) {
          leafletHelpers.safeApply($scope, function(scp) {
            scp.baselayer = key;
            leafletData.getMap().then(function(map) {
              leafletData.getLayers().then(function(leafletLayers) {
                if (map.hasLayer(leafletLayers.baselayers[key])) {
                  return;
                }

                for (var i in scp.layers.baselayers) {
                  scp.layers.baselayers[i].icon = scp.icons.unradio;
                  if (map.hasLayer(leafletLayers.baselayers[i])) {
                    map.removeLayer(leafletLayers.baselayers[i]);
                  }
                }

                map.addLayer(leafletLayers.baselayers[key]);
                scp.layers.baselayers[key].icon = $scope.icons.radio;
              });
            });
          });

          e.preventDefault();
        },

        moveLayer: function(ly, newIndex, e) {
          var delta = Object.keys($scope.layers.baselayers).length;
          if (newIndex >= (1 + delta) && newIndex <= ($scope.overlaysArray.length + delta)) {
            var oldLy;
            for (var key in $scope.layers.overlays) {
              if ($scope.layers.overlays[key].index === newIndex) {
                oldLy = $scope.layers.overlays[key];
                break;
              }
            }

            if (oldLy) {
              safeApply($scope, function() {
                oldLy.index = ly.index;
                ly.index = newIndex;
              });
            }
          }

          e.stopPropagation();
          e.preventDefault();
        },

        initIndex: function(layer, idx) {
          var delta = Object.keys($scope.layers.baselayers).length;
          layer.index = isDefined(layer.index) ? layer.index : idx + delta + 1;
        },

        initGroup: function(groupName) {
          $scope.groupProperties[groupName] = $scope.groupProperties[groupName] ? $scope.groupProperties[groupName] : {};
        },

        toggleOpacity: function(e, layer) {
          if (layer.visible) {
            if ($scope.autoHideOpacity && !$scope.layerProperties[layer.name].opacityControl) {
              for (var k in $scope.layerProperties) {
                $scope.layerProperties[k].opacityControl = false;
              }
            }

            $scope.layerProperties[layer.name].opacityControl = !$scope.layerProperties[layer.name].opacityControl;
          }

          e.stopPropagation();
          e.preventDefault();
        },

        toggleLegend: function(layer) {
          $scope.layerProperties[layer.name].showLegend = !$scope.layerProperties[layer.name].showLegend;
        },

        showLegend: function(layer) {
          return layer.legend && $scope.layerProperties[layer.name].showLegend;
        },

        unsafeHTML: function(html) {
          return $sce.trustAsHtml(html);
        },

        getOpacityIcon: function(layer) {
          return layer.visible && $scope.layerProperties[layer.name].opacityControl ? $scope.icons.close : $scope.icons.open;
        },

        getGroupIcon: function(group) {
          return group.visible ? $scope.icons.check : $scope.icons.uncheck;
        },

        changeOpacity: function(layer) {
          var op = $scope.layerProperties[layer.name].opacity;
          leafletData.getMap().then(function(map) {
            leafletData.getLayers().then(function(leafletLayers) {
              var ly;
              for (var k in $scope.layers.overlays) {
                if ($scope.layers.overlays[k] === layer) {
                  ly = leafletLayers.overlays[k];
                  break;
                }
              }

              if (map.hasLayer(ly)) {
                if (ly.setOpacity) {
                  ly.setOpacity(op / 100);
                }

                if (ly.getLayers && ly.eachLayer) {
                  ly.eachLayer(function(lay) {
                    if (lay.setOpacity) {
                      lay.setOpacity(op / 100);
                    }
                  });
                }
              }
            });
          });
        },

        changeGroupVisibility: function(groupName) {
          if (!isDefined($scope.groupProperties[groupName])) {
            return;
          }

          var visible = $scope.groupProperties[groupName].visible;
          for (var k in $scope.layers.overlays) {
            var layer = $scope.layers.overlays[k];
            if (layer.group === groupName) {
              layer.visible = visible;
            }
          }
        },
      });

      var div = $element.get(0);
      if (!L.Browser.touch) {
        L.DomEvent.disableClickPropagation(div);
        L.DomEvent.on(div, 'mousewheel', L.DomEvent.stopPropagation);
      } else {
        L.DomEvent.on(div, 'click', L.DomEvent.stopPropagation);
      }
    }],

    template:
    '<div class="angular-leaflet-control-layers" ng-show="overlaysArray.length">' +
        '<h4 ng-if="title">{{ title }}</h4>' +
        '<div class="lf-baselayers">' +
            '<h5 class="lf-title" ng-if="baseTitle">{{ baseTitle }}</h5>' +
            '<div class="lf-row" ng-repeat="(key, layer) in baselayersArray">' +
                '<label class="lf-icon-bl" ng-click="changeBaseLayer(key, $event)">' +
                    '<input class="leaflet-control-layers-selector" type="radio" name="lf-radio" ' +
                        'ng-show="false" ng-checked="baselayer === key" ng-value="key" /> ' +
                    '<i class="lf-icon lf-icon-radio" ng-class="layer.icon"></i>' +
                    '<div class="lf-text">{{layer.name}}</div>' +
                '</label>' +
            '</div>' +
        '</div>' +
        '<div class="lf-overlays">' +
            '<h5 class="lf-title" ng-if="overlaysTitle">{{ overlaysTitle }}</h5>' +
            '<div class="lf-container">' +
                '<div class="lf-row" ng-repeat="layer in (o = (overlaysArray | orderBy:\'index\':order))" ng-init="initIndex(layer, $index)">' +
                    '<label class="lf-icon-ol-group" ng-if="showGroups &amp;&amp; layer.group &amp;&amp; layer.group != o[$index-1].group">' +
                        '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ' +
                            'ng-change="changeGroupVisibility(layer.group)" ng-model="groupProperties[layer.group].visible"/> ' +
                        '<i class="lf-icon lf-icon-check" ng-class="getGroupIcon(groupProperties[layer.group])"></i>' +
                        '<div class="lf-text">{{ layer.group }}</div>' +
                    '</label>' +
                    '<label class="lf-icon-ol">' +
                        '<input class="lf-control-layers-selector" type="checkbox" ng-show="false" ng-model="layer.visible"/> ' +
                        '<i class="lf-icon lf-icon-check" ng-class="layer.icon"></i>' +
                        '<div class="lf-text">{{layer.name}}</div>' +
                    '</label>' +
                    '<div class="lf-icons">' +
                        '<i class="lf-icon lf-up" ng-class="icons.up" ng-click="moveLayer(layer, layer.index - orderNumber, $event)"></i> ' +
                        '<i class="lf-icon lf-down" ng-class="icons.down" ng-click="moveLayer(layer, layer.index + orderNumber, $event)"></i> ' +
                        '<i class="lf-icon lf-toggle-legend" ng-class="icons.toggleLegend" ng-if="layer.legend" ng-click="toggleLegend(layer)"></i> ' +
                        '<i class="lf-icon lf-open" ng-class="getOpacityIcon(layer)" ng-click="toggleOpacity($event, layer)"></i>' +
                    '</div>' +
                    '<div class="lf-legend" ng-if="showLegend(layer)" ng-bind-html="unsafeHTML(layer.legend)"></div>' +
                    '<div class="lf-opacity clearfix" ng-if="layer.visible &amp;&amp; layerProperties[layer.name].opacityControl">' +
                        '<label ng-if="rangeIsSupported" class="pull-left" style="width: 50%">0</label>' +
                        '<label ng-if="rangeIsSupported" class="pull-left text-right" style="width: 50%">100</label>' +
                        '<input ng-if="rangeIsSupported" class="clearfix" type="range" min="0" max="100" class="lf-opacity-control" ' +
                            'ng-model="layerProperties[layer.name].opacity" ng-change="changeOpacity(layer)"/>' +
                        '<h6 ng-if="!rangeIsSupported">Range is not supported in this browser</h6>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>',
    link: function(scope, element, attrs, controller) {
      var isDefined = leafletHelpers.isDefined;
      var leafletScope = controller.getLeafletScope();
      var layers = leafletScope.layers;

      scope.$watch('icons', function() {
        var defaultIcons = {
          uncheck: 'fa fa-square-o',
          check: 'fa fa-check-square-o',
          radio: 'fa fa-dot-circle-o',
          unradio: 'fa fa-circle-o',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down',
          open: 'fa fa-angle-double-down',
          close: 'fa fa-angle-double-up',
          toggleLegend: 'fa fa-pencil-square-o',
        };
        if (isDefined(scope.icons)) {
          angular.extend(defaultIcons, scope.icons);
          angular.extend(scope.icons, defaultIcons);
        } else {
          scope.icons = defaultIcons;
        }
      });

      // Setting layer stack order.
      attrs.order = (isDefined(attrs.order) && (attrs.order === 'normal' || attrs.order === 'reverse')) ? attrs.order : 'normal';
      scope.order = attrs.order === 'normal';
      scope.orderNumber = attrs.order === 'normal' ? -1 : 1;

      scope.layers = layers;
      controller.getMap().then(function(map) {
        leafletScope.$watch('layers.baselayers', function(newBaseLayers) {
          var baselayersArray = {};
          leafletData.getLayers().then(function(leafletLayers) {
            var key;
            for (key in newBaseLayers) {
              var layer = newBaseLayers[key];
              layer.icon = scope.icons[map.hasLayer(leafletLayers.baselayers[key]) ? 'radio' : 'unradio'];
              baselayersArray[key] = layer;
            }

            scope.baselayersArray = baselayersArray;
          });
        });

        leafletScope.$watch('layers.overlays', function(newOverlayLayers) {
          var overlaysArray = [];
          var groupVisibleCount = {};
          leafletData.getLayers().then(function(leafletLayers) {
            var key;
            for (key in newOverlayLayers) {
              var layer = newOverlayLayers[key];
              layer.icon = scope.icons[(layer.visible ? 'check' : 'uncheck')];
              overlaysArray.push(layer);
              if (!isDefined(scope.layerProperties[layer.name])) {
                scope.layerProperties[layer.name] = {
                  opacity: isDefined(layer.layerOptions.opacity) ? layer.layerOptions.opacity * 100 : 100,
                  opacityControl: false,
                  showLegend: true,
                };
              }

              if (isDefined(layer.group)) {
                if (!isDefined(scope.groupProperties[layer.group])) {
                  scope.groupProperties[layer.group] = {
                    visible: false,
                  };
                }

                groupVisibleCount[layer.group] = isDefined(groupVisibleCount[layer.group]) ? groupVisibleCount[layer.group] : {
                  count: 0,
                  visibles: 0,
                };
                groupVisibleCount[layer.group].count++;
                if (layer.visible) {
                  groupVisibleCount[layer.group].visibles++;
                }
              }

              if (isDefined(layer.index) && leafletLayers.overlays[key].setZIndex) {
                leafletLayers.overlays[key].setZIndex(newOverlayLayers[key].index);
              }
            }

            for (key in groupVisibleCount) {
              scope.groupProperties[key].visible = groupVisibleCount[key].visibles === groupVisibleCount[key].count;
            }

            scope.overlaysArray = overlaysArray;
          });
        }, true);
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('layers', ["$log", "$q", "leafletData", "leafletHelpers", "leafletLayerHelpers", "leafletControlHelpers", function($log, $q, leafletData, leafletHelpers, leafletLayerHelpers, leafletControlHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',
    controller: ["$scope", function($scope) {
      $scope._leafletLayers = $q.defer();
      this.getLayers = function() {
        return $scope._leafletLayers.promise;
      };
    }],

    link: function(scope, element, attrs, controller) {
      var isDefined = leafletHelpers.isDefined;
      var leafletLayers = {};
      var leafletScope  = controller.getLeafletScope();
      var layers = leafletScope.layers;
      var createLayer = leafletLayerHelpers.createLayer;
      var safeAddLayer = leafletLayerHelpers.safeAddLayer;
      var safeRemoveLayer = leafletLayerHelpers.safeRemoveLayer;
      var updateLayersControl = leafletControlHelpers.updateLayersControl;
      var isLayersControlVisible = false;

      controller.getMap().then(function(map) {

        // We have baselayers to add to the map
        scope._leafletLayers.resolve(leafletLayers);
        leafletData.setLayers(leafletLayers, attrs.id);

        leafletLayers.baselayers = {};
        leafletLayers.overlays = {};

        var mapId = attrs.id;

        // Setup all baselayers definitions
        var oneVisibleLayer = false;
        for (var layerName in layers.baselayers) {
          var newBaseLayer = createLayer(layers.baselayers[layerName]);
          if (!isDefined(newBaseLayer)) {
            delete layers.baselayers[layerName];
            continue;
          }

          leafletLayers.baselayers[layerName] = newBaseLayer;

          // Only add the visible layer to the map, layer control manages the addition to the map
          // of layers in its control
          if (layers.baselayers[layerName].top === true) {
            safeAddLayer(map, leafletLayers.baselayers[layerName]);
            oneVisibleLayer = true;
          }
        }

        // If there is no visible layer add first to the map
        if (!oneVisibleLayer && Object.keys(leafletLayers.baselayers).length > 0) {
          safeAddLayer(map, leafletLayers.baselayers[Object.keys(layers.baselayers)[0]]);
        }

        // Setup the Overlays
        for (layerName in layers.overlays) {
          //if (layers.overlays[layerName].type === 'cartodb') {
          //
          //}

          var newOverlayLayer = createLayer(layers.overlays[layerName]);
          if (!isDefined(newOverlayLayer)) {
            delete layers.overlays[layerName];
            continue;
          }

          leafletLayers.overlays[layerName] = newOverlayLayer;

          // Only add the visible overlays to the map
          if (layers.overlays[layerName].visible === true) {
            safeAddLayer(map, leafletLayers.overlays[layerName]);
          }
        }

        // Watch for the base layers
        leafletScope.$watch('layers.baselayers', function(newBaseLayers, oldBaseLayers) {
          if (angular.equals(newBaseLayers, oldBaseLayers)) {
            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
            return true;
          }

          // Delete layers from the array
          for (var name in leafletLayers.baselayers) {
            if (!isDefined(newBaseLayers[name]) || newBaseLayers[name].doRefresh) {
              // Remove from the map if it's on it
              if (map.hasLayer(leafletLayers.baselayers[name])) {
                map.removeLayer(leafletLayers.baselayers[name]);
              }

              delete leafletLayers.baselayers[name];

              if (newBaseLayers[name] && newBaseLayers[name].doRefresh) {
                newBaseLayers[name].doRefresh = false;
              }
            }
          }

          // add new layers
          for (var newName in newBaseLayers) {
            if (!isDefined(leafletLayers.baselayers[newName])) {
              var testBaseLayer = createLayer(newBaseLayers[newName]);
              if (isDefined(testBaseLayer)) {
                leafletLayers.baselayers[newName] = testBaseLayer;

                // Only add the visible layer to the map
                if (newBaseLayers[newName].top === true) {
                  safeAddLayer(map, leafletLayers.baselayers[newName]);
                }
              }
            } else {
              if (newBaseLayers[newName].top === true && !map.hasLayer(leafletLayers.baselayers[newName])) {
                safeAddLayer(map, leafletLayers.baselayers[newName]);
              } else if (newBaseLayers[newName].top === false && map.hasLayer(leafletLayers.baselayers[newName])) {
                map.removeLayer(leafletLayers.baselayers[newName]);
              }
            }
          }

          //we have layers, so we need to make, at least, one active
          var found = false;

          // search for an active layer
          for (var key in leafletLayers.baselayers) {
            if (map.hasLayer(leafletLayers.baselayers[key])) {
              found = true;
              break;
            }
          }

          // If there is no active layer make one active
          if (!found && Object.keys(leafletLayers.baselayers).length > 0) {
            safeAddLayer(map, leafletLayers.baselayers[Object.keys(leafletLayers.baselayers)[0]]);
          }

          // Only show the layers switch selector control if we have more than one baselayer + overlay
          isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, newBaseLayers, layers.overlays, leafletLayers);
        }, true);

        // Watch for the overlay layers
        leafletScope.$watch('layers.overlays', function(newOverlayLayers, oldOverlayLayers) {
          if (angular.equals(newOverlayLayers, oldOverlayLayers)) {
            isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
            return true;
          }

          // Delete layers from the array
          for (var name in leafletLayers.overlays) {
            if (!isDefined(newOverlayLayers[name]) || newOverlayLayers[name].doRefresh) {
              // Remove from the map if it's on it
              if (map.hasLayer(leafletLayers.overlays[name])) {
                // Safe remove when ArcGIS layers is loading.
                var options = isDefined(newOverlayLayers[name]) ?
                    newOverlayLayers[name].layerOptions : null;
                safeRemoveLayer(map, leafletLayers.overlays[name], options);
              }

              // TODO: Depending on the layer type we will have to delete what's included on it
              delete leafletLayers.overlays[name];

              if (newOverlayLayers[name] && newOverlayLayers[name].doRefresh) {
                newOverlayLayers[name].doRefresh = false;
              }
            }
          }

          // add new overlays
          for (var newName in newOverlayLayers) {
            if (!isDefined(leafletLayers.overlays[newName])) {
              var testOverlayLayer = createLayer(newOverlayLayers[newName]);
              if (!isDefined(testOverlayLayer)) {
                // If the layer creation fails, continue to the next overlay
                continue;
              }

              leafletLayers.overlays[newName] = testOverlayLayer;
              if (newOverlayLayers[newName].visible === true) {
                safeAddLayer(map, leafletLayers.overlays[newName]);
              }
            } else {
              // check for the .visible property to hide/show overLayers
              if (newOverlayLayers[newName].visible && !map.hasLayer(leafletLayers.overlays[newName])) {
                safeAddLayer(map, leafletLayers.overlays[newName]);
              } else if (newOverlayLayers[newName].visible === false && map.hasLayer(leafletLayers.overlays[newName])) {
                // Safe remove when ArcGIS layers is loading.
                safeRemoveLayer(map, leafletLayers.overlays[newName], newOverlayLayers[newName].layerOptions);
              }
            }

            //refresh heatmap data if present
            if (newOverlayLayers[newName].visible && map._loaded && newOverlayLayers[newName].data && newOverlayLayers[newName].type === 'heatmap') {
              leafletLayers.overlays[newName].setData(newOverlayLayers[newName].data);
              leafletLayers.overlays[newName].update();
            }
          }

          // Only add the layers switch selector control if we have more than one baselayer + overlay
          isLayersControlVisible = updateLayersControl(map, mapId, isLayersControlVisible, layers.baselayers, newOverlayLayers, leafletLayers);
        }, true);
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('legend', ["$log", "$http", "leafletHelpers", "leafletLegendHelpers", function($log, $http, leafletHelpers, leafletLegendHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {

      var isArray = leafletHelpers.isArray;
      var isDefined = leafletHelpers.isDefined;
      var isFunction = leafletHelpers.isFunction;
      var leafletScope = controller.getLeafletScope();
      var legend = leafletScope.legend;

      var legendClass;
      var position;
      var leafletLegend;
      var type;

      leafletScope.$watch('legend', function(newLegend) {

        if (isDefined(newLegend)) {

          legendClass = newLegend.legendClass ? newLegend.legendClass : 'legend';

          position = newLegend.position || 'bottomright';

          // default to arcgis
          type = newLegend.type || 'arcgis';
        }

      }, true);

      controller.getMap().then(function(map) {

        leafletScope.$watch('legend', function(newLegend) {

          if (!isDefined(newLegend)) {

            if (isDefined(leafletLegend)) {
              leafletLegend.removeFrom(map);
              leafletLegend = null;
            }

            return;
          }

          if (!isDefined(newLegend.url) && (type === 'arcgis') && (!isArray(newLegend.colors) || !isArray(newLegend.labels) || newLegend.colors.length !== newLegend.labels.length)) {

            $log.warn('[AngularJS - Leaflet] legend.colors and legend.labels must be set.');

            return;
          }

          if (isDefined(newLegend.url)) {

            $log.info('[AngularJS - Leaflet] loading legend service.');

            return;
          }

          if (isDefined(leafletLegend)) {
            leafletLegend.removeFrom(map);
            leafletLegend = null;
          }

          leafletLegend = L.control({
            position: position,
          });
          if (type === 'arcgis') {
            leafletLegend.onAdd = leafletLegendHelpers.getOnAddArrayLegend(newLegend, legendClass);
          }

          leafletLegend.addTo(map);

        });

        leafletScope.$watch('legend.url', function(newURL) {

          if (!isDefined(newURL)) {
            return;
          }

          $http.get(newURL)
                            .success(function(legendData) {

                              if (isDefined(leafletLegend)) {

                                leafletLegendHelpers.updateLegend(leafletLegend.getContainer(), legendData, type, newURL);

                              } else {

                                leafletLegend = L.control({
                                  position: position,
                                });
                                leafletLegend.onAdd = leafletLegendHelpers.getOnAddLegend(legendData, legendClass, type, newURL);
                                leafletLegend.addTo(map);
                              }

                              if (isDefined(legend.loadedData) && isFunction(legend.loadedData)) {
                                legend.loadedData();
                              }
                            })
                            .error(function() {
                              $log.warn('[AngularJS - Leaflet] legend.url not loaded.');
                            });
        });

      });
    },
  };
}]);

angular.module('leaflet-directive').directive('markers',
    ["$log", "$rootScope", "$q", "leafletData", "leafletHelpers", "leafletMapDefaults", "leafletMarkersHelpers", "leafletMarkerEvents", "leafletIterators", "leafletWatchHelpers", "leafletDirectiveControlsHelpers", function($log, $rootScope, $q, leafletData, leafletHelpers, leafletMapDefaults,
              leafletMarkersHelpers, leafletMarkerEvents, leafletIterators, leafletWatchHelpers,
              leafletDirectiveControlsHelpers) {
      //less terse vars to helpers
      var isDefined = leafletHelpers.isDefined;
      var errorHeader = leafletHelpers.errorHeader;
      var Helpers = leafletHelpers;
      var isString = leafletHelpers.isString;
      var addMarkerWatcher = leafletMarkersHelpers.addMarkerWatcher;
      var updateMarker = leafletMarkersHelpers.updateMarker;
      var listenMarkerEvents = leafletMarkersHelpers.listenMarkerEvents;
      var addMarkerToGroup = leafletMarkersHelpers.addMarkerToGroup;
      var createMarker = leafletMarkersHelpers.createMarker;
      var deleteMarker = leafletMarkersHelpers.deleteMarker;
      var $it = leafletIterators;
      var _markersWatchOptions = leafletHelpers.watchOptions;
      var maybeWatch = leafletWatchHelpers.maybeWatch;
      var extendDirectiveControls = leafletDirectiveControlsHelpers.extend;

      var _getLMarker = function(leafletMarkers, name, maybeLayerName) {
        if (!Object.keys(leafletMarkers).length) return;
        if (maybeLayerName && isString(maybeLayerName)) {
          if (!leafletMarkers[maybeLayerName] || !Object.keys(leafletMarkers[maybeLayerName]).length)
              return;
          return leafletMarkers[maybeLayerName][name];
        }

        return leafletMarkers[name];
      };

      var _setLMarker = function(lObject, leafletMarkers, name, maybeLayerName) {
        if (maybeLayerName && isString(maybeLayerName)) {
          if (!isDefined(leafletMarkers[maybeLayerName]))
              leafletMarkers[maybeLayerName] = {};
          leafletMarkers[maybeLayerName][name] = lObject;
        } else
            leafletMarkers[name] = lObject;
        return lObject;
      };

      var _maybeAddMarkerToLayer = function(layerName, layers, model, marker, doIndividualWatch, map) {

        if (!isString(layerName)) {
          $log.error(errorHeader + ' A layername must be a string');
          return false;
        }

        if (!isDefined(layers)) {
          $log.error(errorHeader + ' You must add layers to the directive if the markers are going to use this functionality.');
          return false;
        }

        if (!isDefined(layers.overlays) || !isDefined(layers.overlays[layerName])) {
          $log.error(errorHeader + ' A marker can only be added to a layer of type "group"');
          return false;
        }

        var layerGroup = layers.overlays[layerName];
        if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
          $log.error(errorHeader + ' Adding a marker to an overlay needs a overlay of the type "group" or "featureGroup"');
          return false;
        }

        // The marker goes to a correct layer group, so first of all we add it
        layerGroup.addLayer(marker);

        // The marker is automatically added to the map depending on the visibility
        // of the layer, so we only have to open the popup if the marker is in the map
        if (!doIndividualWatch && map.hasLayer(marker) && model.focus === true) {
          marker.openPopup();
        }

        return true;
      };

      //TODO: move to leafletMarkersHelpers??? or make a new class/function file (leafletMarkersHelpers is large already)
      var _addMarkers = function(mapId, markersToRender, oldModels, map, layers, leafletMarkers, leafletScope,
                                 watchOptions, maybeLayerName, skips) {
        for (var newName in markersToRender) {
          if (skips[newName])
              continue;

          if (newName.search('-') !== -1) {
            $log.error('The marker can\'t use a "-" on his key name: "' + newName + '".');
            continue;
          }

          var model = Helpers.copy(markersToRender[newName]);
          var pathToMarker = Helpers.getObjectDotPath(maybeLayerName ? [maybeLayerName, newName] : [newName]);
          var maybeLMarker = _getLMarker(leafletMarkers, newName, maybeLayerName);
          if (!isDefined(maybeLMarker)) {
            //(nmccready) very important to not have model changes when lObject is changed
            //this might be desirable in some cases but it causes two-way binding to lObject which is not ideal
            //if it is left as the reference then all changes from oldModel vs newModel are ignored
            //see _destroy (where modelDiff becomes meaningless if we do not copy here)
            var marker = createMarker(model);
            var layerName = (model ? model.layer : undefined) || maybeLayerName; //original way takes pref
            if (!isDefined(marker)) {
              $log.error(errorHeader + ' Received invalid data on the marker ' + newName + '.');
              continue;
            }

            _setLMarker(marker, leafletMarkers, newName, maybeLayerName);

            // Bind message
            if (isDefined(model.message)) {
              marker.bindPopup(model.message, model.popupOptions);
            }

            // Add the marker to a cluster group if needed
            if (isDefined(model.group)) {
              var groupOptions = isDefined(model.groupOption) ? model.groupOption : null;
              addMarkerToGroup(marker, model.group, groupOptions, map);
            }

            // Show label if defined
            if (Helpers.LabelPlugin.isLoaded() && isDefined(model.label) && isDefined(model.label.message)) {
              marker.bindLabel(model.label.message, model.label.options);
            }

            // Check if the marker should be added to a layer
            if (isDefined(model) && (isDefined(model.layer) || isDefined(maybeLayerName))) {

              var pass = _maybeAddMarkerToLayer(layerName, layers, model, marker,
                  watchOptions.individual.doWatch, map);
              if (!pass)
                  continue; //something went wrong move on in the loop
            } else if (!isDefined(model.group)) {
              // We do not have a layer attr, so the marker goes to the map layer
              map.addLayer(marker);
              if (!watchOptions.individual.doWatch && model.focus === true) {
                marker.openPopup();
              }
            }

            if (watchOptions.individual.doWatch) {
              addMarkerWatcher(marker, pathToMarker, leafletScope, layers, map,
                  watchOptions.individual.isDeep);
            }

            listenMarkerEvents(marker, model, leafletScope, watchOptions.individual.doWatch, map);
            leafletMarkerEvents.bindEvents(mapId, marker, pathToMarker, model, leafletScope, layerName);
          }          else {
            var oldModel = isDefined(oldModel) ? oldModels[newName] : undefined;
            updateMarker(model, oldModel, maybeLMarker, pathToMarker, leafletScope, layers, map);
          }
        }
      };

      var _seeWhatWeAlreadyHave = function(markerModels, oldMarkerModels, lMarkers, isEqual, cb) {
        var hasLogged = false;
        var equals = false;
        var oldMarker;
        var newMarker;

        var doCheckOldModel =  isDefined(oldMarkerModels);
        for (var name in lMarkers) {
          if (!hasLogged) {
            $log.debug(errorHeader + '[markers] destroy: ');
            hasLogged = true;
          }

          if (doCheckOldModel) {
            //might want to make the option (in watch options) to disable deep checking
            //ie the options to only check !== (reference check) instead of angular.equals (slow)
            newMarker = markerModels[name];
            oldMarker = oldMarkerModels[name];
            equals = angular.equals(newMarker, oldMarker) && isEqual;
          }

          if (!isDefined(markerModels) ||
              !Object.keys(markerModels).length ||
              !isDefined(markerModels[name]) ||
              !Object.keys(markerModels[name]).length ||
              equals) {
            if (cb && Helpers.isFunction(cb))
                cb(newMarker, oldMarker, name);
          }
        }
      };

      var _destroy = function(markerModels, oldMarkerModels, lMarkers, map, layers) {
        _seeWhatWeAlreadyHave(markerModels, oldMarkerModels, lMarkers, false,
            function(newMarker, oldMarker, lMarkerName) {
              $log.debug(errorHeader + '[marker] is deleting marker: ' + lMarkerName);
              deleteMarker(lMarkers[lMarkerName], map, layers);
              delete lMarkers[lMarkerName];
            });
      };

      var _getNewModelsToSkipp =  function(newModels, oldModels, lMarkers) {
        var skips = {};
        _seeWhatWeAlreadyHave(newModels, oldModels, lMarkers, true,
            function(newMarker, oldMarker, lMarkerName) {
              $log.debug(errorHeader + '[marker] is already rendered, marker: ' + lMarkerName);
              skips[lMarkerName] = newMarker;
            });

        return skips;
      };

      return {
        restrict: 'A',
        scope: false,
        replace: false,
        require: ['leaflet', '?layers'],

        link: function(scope, element, attrs, controller) {
          var mapController = controller[0];
          var leafletScope  = mapController.getLeafletScope();

          mapController.getMap().then(function(map) {
            var leafletMarkers = {};
            var getLayers;

            // If the layers attribute is used, we must wait until the layers are created
            if (isDefined(controller[1])) {
              getLayers = controller[1].getLayers;
            } else {
              getLayers = function() {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
              };
            }

            var watchOptions = leafletScope.markersWatchOptions || _markersWatchOptions;

            // backwards compat
            if (isDefined(attrs.watchMarkers))
                watchOptions.doWatch = watchOptions.individual.doWatch =
                    (!isDefined(attrs.watchMarkers) || Helpers.isTruthy(attrs.watchMarkers));

            var isNested = (isDefined(attrs.markersNested) && Helpers.isTruthy(attrs.markersNested));

            getLayers().then(function(layers) {
              var _clean = function(models, oldModels) {
                if (isNested) {
                  $it.each(models, function(markerToMaybeDel, layerName) {
                    var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
                    _destroy(markerToMaybeDel, oldModel, leafletMarkers[layerName], map, layers);
                  });

                  return;
                }

                _destroy(models, oldModels, leafletMarkers, map, layers);
              };

              var _create = function(models, oldModels) {
                _clean(models, oldModels);
                var skips = null;
                if (isNested) {
                  $it.each(models, function(markersToAdd, layerName) {
                    var oldModel = isDefined(oldModel) ? oldModels[layerName] : undefined;
                    skips = _getNewModelsToSkipp(models[layerName], oldModel, leafletMarkers[layerName]);
                    _addMarkers(attrs.id, markersToAdd, oldModels, map, layers, leafletMarkers, leafletScope,
                        watchOptions, layerName, skips);
                  });

                  return;
                }

                skips = _getNewModelsToSkipp(models, oldModels, leafletMarkers);
                _addMarkers(attrs.id, models, oldModels, map, layers, leafletMarkers, leafletScope,
                    watchOptions, undefined, skips);
              };

              extendDirectiveControls(attrs.id, 'markers', _create, _clean);
              leafletData.setMarkers(leafletMarkers, attrs.id);

              maybeWatch(leafletScope, 'markers', watchOptions, function(newMarkers, oldMarkers) {
                _create(newMarkers, oldMarkers);
              });
            });
          });
        },
      };
    }]);

angular.module('leaflet-directive').directive('maxbounds', ["$log", "leafletMapDefaults", "leafletBoundsHelpers", "leafletHelpers", function($log, leafletMapDefaults, leafletBoundsHelpers, leafletHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {
      var leafletScope  = controller.getLeafletScope();
      var isValidBounds = leafletBoundsHelpers.isValidBounds;
      var isNumber = leafletHelpers.isNumber;

      controller.getMap().then(function(map) {
        leafletScope.$watch('maxbounds', function(maxbounds) {
          if (!isValidBounds(maxbounds)) {
            // Unset any previous maxbounds
            map.setMaxBounds();
            return;
          }

          var leafletBounds = leafletBoundsHelpers.createLeafletBounds(maxbounds);
          if (isNumber(maxbounds.pad)) {
            leafletBounds = leafletBounds.pad(maxbounds.pad);
          }

          map.setMaxBounds(leafletBounds);
          if (!attrs.center && !attrs.lfCenter) {
            map.fitBounds(leafletBounds);
          }
        });
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('paths', ["$log", "$q", "leafletData", "leafletMapDefaults", "leafletHelpers", "leafletPathsHelpers", "leafletPathEvents", function($log, $q, leafletData, leafletMapDefaults, leafletHelpers, leafletPathsHelpers, leafletPathEvents) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: ['leaflet', '?layers'],

    link: function(scope, element, attrs, controller) {
      var mapController = controller[0];
      var isDefined = leafletHelpers.isDefined;
      var isString = leafletHelpers.isString;
      var leafletScope  = mapController.getLeafletScope();
      var paths     = leafletScope.paths;
      var createPath = leafletPathsHelpers.createPath;
      var bindPathEvents = leafletPathEvents.bindPathEvents;
      var setPathOptions = leafletPathsHelpers.setPathOptions;

      mapController.getMap().then(function(map) {
        var defaults = leafletMapDefaults.getDefaults(attrs.id);
        var getLayers;

        // If the layers attribute is used, we must wait until the layers are created
        if (isDefined(controller[1])) {
          getLayers = controller[1].getLayers;
        } else {
          getLayers = function() {
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
          };
        }

        if (!isDefined(paths)) {
          return;
        }

        getLayers().then(function(layers) {

          var leafletPaths = {};
          leafletData.setPaths(leafletPaths, attrs.id);

          // Should we watch for every specific marker on the map?
          var shouldWatch = (!isDefined(attrs.watchPaths) || attrs.watchPaths === 'true');

          // Function for listening every single path once created
          var watchPathFn = function(leafletPath, name) {
            var clearWatch = leafletScope.$watch('paths["' + name + '"]', function(pathData, old) {
              if (!isDefined(pathData)) {
                if (isDefined(old.layer)) {
                  for (var i in layers.overlays) {
                    var overlay = layers.overlays[i];
                    overlay.removeLayer(leafletPath);
                  }
                }

                map.removeLayer(leafletPath);
                clearWatch();
                return;
              }

              setPathOptions(leafletPath, pathData.type, pathData);
            }, true);
          };

          leafletScope.$watchCollection('paths', function(newPaths) {

            // Delete paths (by name) from the array
            for (var name in leafletPaths) {
              if (!isDefined(newPaths[name])) {
                map.removeLayer(leafletPaths[name]);
                delete leafletPaths[name];
              }
            }

            // Create the new paths
            for (var newName in newPaths) {
              if (newName.search('\\$') === 0) {
                continue;
              }

              if (newName.search('-') !== -1) {
                $log.error('[AngularJS - Leaflet] The path name "' + newName + '" is not valid. It must not include "-" and a number.');
                continue;
              }

              if (!isDefined(leafletPaths[newName])) {
                var pathData = newPaths[newName];
                var newPath = createPath(newName, newPaths[newName], defaults);

                // bind popup if defined
                if (isDefined(newPath) && isDefined(pathData.message)) {
                  newPath.bindPopup(pathData.message, pathData.popupOptions);
                }

                // Show label if defined
                if (leafletHelpers.LabelPlugin.isLoaded() && isDefined(pathData.label) && isDefined(pathData.label.message)) {
                  newPath.bindLabel(pathData.label.message, pathData.label.options);
                }

                // Check if the marker should be added to a layer
                if (isDefined(pathData) && isDefined(pathData.layer)) {

                  if (!isString(pathData.layer)) {
                    $log.error('[AngularJS - Leaflet] A layername must be a string');
                    continue;
                  }

                  if (!isDefined(layers)) {
                    $log.error('[AngularJS - Leaflet] You must add layers to the directive if the markers are going to use this functionality.');
                    continue;
                  }

                  if (!isDefined(layers.overlays) || !isDefined(layers.overlays[pathData.layer])) {
                    $log.error('[AngularJS - Leaflet] A path can only be added to a layer of type "group"');
                    continue;
                  }

                  var layerGroup = layers.overlays[pathData.layer];
                  if (!(layerGroup instanceof L.LayerGroup || layerGroup instanceof L.FeatureGroup)) {
                    $log.error('[AngularJS - Leaflet] Adding a path to an overlay needs a overlay of the type "group" or "featureGroup"');
                    continue;
                  }

                  // Listen for changes on the new path
                  leafletPaths[newName] = newPath;

                  // The path goes to a correct layer group, so first of all we add it
                  layerGroup.addLayer(newPath);

                  if (shouldWatch) {
                    watchPathFn(newPath, newName);
                  } else {
                    setPathOptions(newPath, pathData.type, pathData);
                  }
                } else if (isDefined(newPath)) {
                  // Listen for changes on the new path
                  leafletPaths[newName] = newPath;
                  map.addLayer(newPath);

                  if (shouldWatch) {
                    watchPathFn(newPath, newName);
                  } else {
                    setPathOptions(newPath, pathData.type, pathData);
                  }
                }

                bindPathEvents(attrs.id, newPath, newName, pathData, leafletScope);
              }
            }
          });
        });
      });
    },
  };
}]);

angular.module('leaflet-directive').directive('tiles', ["$log", "leafletData", "leafletMapDefaults", "leafletHelpers", function($log, leafletData, leafletMapDefaults, leafletHelpers) {

  return {
    restrict: 'A',
    scope: false,
    replace: false,
    require: 'leaflet',

    link: function(scope, element, attrs, controller) {
      var isDefined = leafletHelpers.isDefined;
      var leafletScope  = controller.getLeafletScope();
      var tiles = leafletScope.tiles;

      if (!isDefined(tiles) ||  !isDefined(tiles.url)) {
        $log.warn('[AngularJS - Leaflet] The \'tiles\' definition doesn\'t have the \'url\' property.');
        return;
      }

      controller.getMap().then(function(map) {
        var defaults = leafletMapDefaults.getDefaults(attrs.id);
        var tileLayerObj;
        leafletScope.$watch('tiles', function(tiles, oldtiles) {
          var tileLayerOptions = defaults.tileLayerOptions;
          var tileLayerUrl = defaults.tileLayer;

          // If no valid tiles are in the scope, remove the last layer
          if (!isDefined(tiles.url) && isDefined(tileLayerObj)) {
            map.removeLayer(tileLayerObj);
            return;
          }

          // No leafletTiles object defined yet
          if (!isDefined(tileLayerObj)) {
            if (isDefined(tiles.options)) {
              angular.copy(tiles.options, tileLayerOptions);
            }

            if (isDefined(tiles.url)) {
              tileLayerUrl = tiles.url;
            }

            if (tiles.type === 'wms') {
              tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
            } else {
              tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
            }

            tileLayerObj.addTo(map);
            leafletData.setTiles(tileLayerObj, attrs.id);
            return;
          }

          // If the options of the tilelayer is changed, we need to redraw the layer
          if (isDefined(tiles.url) && isDefined(tiles.options) &&
              (tiles.type !== oldtiles.type || !angular.equals(tiles.options, tileLayerOptions))) {
            map.removeLayer(tileLayerObj);
            tileLayerOptions = defaults.tileLayerOptions;
            angular.copy(tiles.options, tileLayerOptions);
            tileLayerUrl = tiles.url;

            if (tiles.type === 'wms') {
              tileLayerObj = L.tileLayer.wms(tileLayerUrl, tileLayerOptions);
            } else {
              tileLayerObj = L.tileLayer(tileLayerUrl, tileLayerOptions);
            }

            tileLayerObj.addTo(map);
            leafletData.setTiles(tileLayerObj, attrs.id);
            return;
          }

          // Only the URL of the layer is changed, update the tiles object
          if (isDefined(tiles.url)) {
            tileLayerObj.setUrl(tiles.url);
          }
        }, true);
      });
    },
  };
}]);

/*
    Create multiple similar directives for watchOptions to support directiveControl
    instead. (when watches are disabled)
    NgAnnotate does not work here due to the functional creation
*/
['markers', 'geojson'].forEach(function(name) {
  angular.module('leaflet-directive').directive(name + 'WatchOptions', [
      '$log', '$rootScope', '$q', 'leafletData', 'leafletHelpers',
        function($log, $rootScope, $q, leafletData, leafletHelpers) {

          var isDefined = leafletHelpers.isDefined,
              errorHeader = leafletHelpers.errorHeader,
              isObject = leafletHelpers.isObject,
              _watchOptions = leafletHelpers.watchOptions;

          return {
            restrict: 'A',
            scope: false,
            replace: false,
            require: ['leaflet'],

            link: function(scope, element, attrs, controller) {
              var mapController = controller[0],
                  leafletScope = mapController.getLeafletScope();

              mapController.getMap().then(function() {
                if (isDefined(scope[name + 'WatchOptions'])) {
                  if (isObject(scope[name + 'WatchOptions']))
                      angular.extend(_watchOptions, scope[name + 'WatchOptions']);
                  else
                      $log.error(errorHeader + '[' + name + 'WatchOptions] is not an object');
                  leafletScope[name + 'WatchOptions'] = _watchOptions;
                }
              });
            },
          };
        },]);
});

angular.module('leaflet-directive')
.factory('LeafletEventsHelpersFactory', ["$rootScope", "$q", "$log", "leafletHelpers", function($rootScope, $q, $log, leafletHelpers) {
  var safeApply = leafletHelpers.safeApply;
  var isDefined = leafletHelpers.isDefined;
  var isObject = leafletHelpers.isObject;
  var isArray = leafletHelpers.isArray;
  var errorHeader = leafletHelpers.errorHeader;

  var EventsHelper = function(rootBroadcastName, lObjectType) {
    this.rootBroadcastName = rootBroadcastName;
    $log.debug('LeafletEventsHelpersFactory: lObjectType: ' + lObjectType + 'rootBroadcastName: ' + rootBroadcastName);

    //used to path/key out certain properties based on the type , "markers", "geojson"
    this.lObjectType = lObjectType;
  };

  EventsHelper.prototype.getAvailableEvents = function() {return [];};

  /*
   argument: name: Note this can be a single string or dot notation
   Example:
   markerModel : {
   m1: { lat:_, lon: _}
   }
   //would yield name of
   name = "m1"

   If nested:
   markerModel : {
   cars: {
   m1: { lat:_, lon: _}
   }
   }
   //would yield name of
   name = "cars.m1"
   */
  EventsHelper.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
    var _this = this;

    maybeMapId = maybeMapId || '';
    if (maybeMapId)
      maybeMapId = '.' + maybeMapId;

    return function(e) {
      var broadcastName = _this.rootBroadcastName + maybeMapId + '.' + eventName;
      $log.debug(broadcastName);
      _this.fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName, extra);
    };
  };

  EventsHelper.prototype.fire = function(scope, broadcastName, logic, event, lObject, model, modelName, layerName) {
    // Safely broadcast the event
    safeApply(scope, function() {
      var toSend = {
        leafletEvent: event,
        leafletObject: lObject,
        modelName: modelName,
        model: model,
      };
      if (isDefined(layerName))
          angular.extend(toSend, {layerName: layerName});

      if (logic === 'emit') {
        scope.$emit(broadcastName, toSend);
      } else {
        $rootScope.$broadcast(broadcastName, toSend);
      }
    });
  };

  EventsHelper.prototype.bindEvents = function(maybeMapId, lObject, name, model, leafletScope, layerName, extra) {
    var events = [];
    var logic = 'emit';
    var _this = this;

    if (!isDefined(leafletScope.eventBroadcast)) {
      // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
      events = this.getAvailableEvents();
    } else if (!isObject(leafletScope.eventBroadcast)) {
      // Not a valid object
      $log.error(errorHeader + 'event-broadcast must be an object check your model.');
    } else {
      // We have a possible valid object
      if (!isDefined(leafletScope.eventBroadcast[_this.lObjectType])) {
        // We do not have events enable/disable do we do nothing (all enabled by default)
        events = this.getAvailableEvents();
      } else if (!isObject(leafletScope.eventBroadcast[_this.lObjectType])) {
        // Not a valid object
        $log.warn(errorHeader + 'event-broadcast.' + [_this.lObjectType]  + ' must be an object check your model.');
      } else {
        // We have a possible valid map object
        // Event propadation logic
        if (isDefined(leafletScope.eventBroadcast[this.lObjectType].logic)) {
          // We take care of possible propagation logic
          if (leafletScope.eventBroadcast[_this.lObjectType].logic !== 'emit' &&
              leafletScope.eventBroadcast[_this.lObjectType].logic !== 'broadcast')
                  $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
        }

        // Enable / Disable
        var eventsEnable = false;
        var eventsDisable = false;
        if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].enable) &&
            isArray(leafletScope.eventBroadcast[_this.lObjectType].enable))
                eventsEnable = true;
        if (isDefined(leafletScope.eventBroadcast[_this.lObjectType].disable) &&
            isArray(leafletScope.eventBroadcast[_this.lObjectType].disable))
                eventsDisable = true;

        if (eventsEnable && eventsDisable) {
          // Both are active, this is an error
          $log.warn(errorHeader + 'can not enable and disable events at the same time');
        } else if (!eventsEnable && !eventsDisable) {
          // Both are inactive, this is an error
          $log.warn(errorHeader + 'must enable or disable events');
        } else {
          // At this point the object is OK, lets enable or disable events
          if (eventsEnable) {
            // Enable events
            leafletScope.eventBroadcast[this.lObjectType].enable.forEach(function(eventName) {
              // Do we have already the event enabled?
              if (events.indexOf(eventName) !== -1) {
                // Repeated event, this is an error
                $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
              } else {
                // Does the event exists?
                if (_this.getAvailableEvents().indexOf(eventName) === -1) {
                  // The event does not exists, this is an error
                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
                } else {
                  // All ok enable the event
                  events.push(eventName);
                }
              }
            });
          } else {
            // Disable events
            events = this.getAvailableEvents();
            leafletScope.eventBroadcast[_this.lObjectType].disable.forEach(function(eventName) {
              var index = events.indexOf(eventName);
              if (index === -1) {
                // The event does not exist
                $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');

              } else {
                events.splice(index, 1);
              }
            });
          }
        }
      }
    }

    events.forEach(function(eventName) {
      lObject.on(eventName, _this.genDispatchEvent(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra));
    });

    return logic;
  };

  return EventsHelper;
}])
.service('leafletEventsHelpers', ["LeafletEventsHelpersFactory", function(LeafletEventsHelpersFactory) {
  return new LeafletEventsHelpersFactory();
}]);

angular.module('leaflet-directive')
.factory('leafletGeoJsonEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletData", function($rootScope, $q, $log, leafletHelpers,
  LeafletEventsHelpersFactory, leafletData) {
  var safeApply = leafletHelpers.safeApply;
  var EventsHelper = LeafletEventsHelpersFactory;

  var GeoJsonEvents = function() {
      EventsHelper.call(this, 'leafletDirectiveGeoJson', 'geojson');
    };

  GeoJsonEvents.prototype =  new EventsHelper();

  GeoJsonEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName, extra) {
    var base = EventsHelper.prototype.genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
    var _this = this;

    return function(e) {
      if (eventName === 'mouseout') {
        if (extra.resetStyleOnMouseout) {
          leafletData.getGeoJSON(extra.mapId)
                    .then(function(leafletGeoJSON) {
                      //this is broken on nested needs to traverse or user layerName (nested)
                      var lobj = layerName ? leafletGeoJSON[layerName] : leafletGeoJSON;
                      lobj.resetStyle(e.target);
                    });

        }

        safeApply(leafletScope, function() {
          $rootScope.$broadcast(_this.rootBroadcastName + '.mouseout', e);
        });
      }

      base(e); //common
    };
  };

  GeoJsonEvents.prototype.getAvailableEvents = function() { return [
      'click',
      'dblclick',
      'mouseover',
      'mouseout',
      ];
  };

  return new GeoJsonEvents();
}]);

angular.module('leaflet-directive')
.factory('leafletLabelEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", function($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory) {
  var Helpers = leafletHelpers;
  var EventsHelper = LeafletEventsHelpersFactory;

  var LabelEvents = function() {
          EventsHelper.call(this, 'leafletDirectiveLabel', 'markers');
        };

  LabelEvents.prototype =  new EventsHelper();

  LabelEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
    var markerName = name.replace('markers.', '');
    return EventsHelper.prototype
        .genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, markerName, model, layerName);
  };

  LabelEvents.prototype.getAvailableEvents = function() {
    return [
        'click',
        'dblclick',
        'mousedown',
        'mouseover',
        'mouseout',
        'contextmenu',
    ];
  };

  LabelEvents.prototype.genEvents = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
    var _this = this;
    var labelEvents = this.getAvailableEvents();
    var scopeWatchName = Helpers.getObjectArrayPath('markers.' + name);
    labelEvents.forEach(function(eventName) {
      lObject.label.on(eventName, _this.genDispatchEvent(
          maybeMapId, eventName, logic, leafletScope, lObject.label, scopeWatchName, model, layerName));
    });
  };

  LabelEvents.prototype.bindEvents = function() {};

  return new LabelEvents();
}]);

angular.module('leaflet-directive')
.factory('leafletMapEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletEventsHelpers", "leafletIterators", function($rootScope, $q, $log, leafletHelpers, leafletEventsHelpers, leafletIterators) {
  var isDefined = leafletHelpers.isDefined;
  var fire = leafletEventsHelpers.fire;

  var _getAvailableMapEvents = function() {
    return [
        'click',
        'dblclick',
        'mousedown',
        'mouseup',
        'mouseover',
        'mouseout',
        'mousemove',
        'contextmenu',
        'focus',
        'blur',
        'preclick',
        'load',
        'unload',
        'viewreset',
        'movestart',
        'move',
        'moveend',
        'dragstart',
        'drag',
        'dragend',
        'zoomstart',
        'zoomanim',
        'zoomend',
        'zoomlevelschange',
        'resize',
        'autopanstart',
        'layeradd',
        'layerremove',
        'baselayerchange',
        'overlayadd',
        'overlayremove',
        'locationfound',
        'locationerror',
        'popupopen',
        'popupclose',
        'draw:created',
        'draw:edited',
        'draw:deleted',
        'draw:drawstart',
        'draw:drawstop',
        'draw:editstart',
        'draw:editstop',
        'draw:deletestart',
        'draw:deletestop',
    ];
  };

  var _genDispatchMapEvent = function(scope, eventName, logic, maybeMapId) {
    if (maybeMapId)
      maybeMapId = maybeMapId + '.';
    return function(e) {
      // Put together broadcast name
      var broadcastName = 'leafletDirectiveMap.' + maybeMapId + eventName;
      $log.debug(broadcastName);

      // Safely broadcast the event
      fire(scope, broadcastName, logic, e, e.target, scope);
    };
  };

  var _notifyCenterChangedToBounds = function(scope) {
    scope.$broadcast('boundsChanged');
  };

  var _notifyCenterUrlHashChanged = function(scope, map, attrs, search) {
    if (!isDefined(attrs.urlHashCenter)) {
      return;
    }

    var center = map.getCenter();
    var centerUrlHash = (center.lat).toFixed(4) + ':' + (center.lng).toFixed(4) + ':' + map.getZoom();
    if (!isDefined(search.c) || search.c !== centerUrlHash) {
      //$log.debug("notified new center...");
      scope.$emit('centerUrlHash', centerUrlHash);
    }
  };

  var _addEvents =  function(map, mapEvents, contextName, scope, logic) {
    leafletIterators.each(mapEvents, function(eventName) {
      var context = {};
      context[contextName] = eventName;
      map.on(eventName, _genDispatchMapEvent(scope, eventName, logic, map._container.id || ''), context);
    });
  };

  return {
    getAvailableMapEvents: _getAvailableMapEvents,
    genDispatchMapEvent: _genDispatchMapEvent,
    notifyCenterChangedToBounds: _notifyCenterChangedToBounds,
    notifyCenterUrlHashChanged: _notifyCenterUrlHashChanged,
    addEvents: _addEvents,
  };
}]);

angular.module('leaflet-directive')
.factory('leafletMarkerEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "LeafletEventsHelpersFactory", "leafletLabelEvents", function($rootScope, $q, $log, leafletHelpers, LeafletEventsHelpersFactory, leafletLabelEvents) {
  var safeApply = leafletHelpers.safeApply;
  var isDefined = leafletHelpers.isDefined;
  var Helpers = leafletHelpers;
  var lblHelp = leafletLabelEvents;
  var EventsHelper = LeafletEventsHelpersFactory;

  var MarkerEvents = function() {
      EventsHelper.call(this, 'leafletDirectiveMarker', 'markers');
    };

  MarkerEvents.prototype = new EventsHelper();

  MarkerEvents.prototype.genDispatchEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
    var handle = EventsHelper.prototype
        .genDispatchEvent.call(this, maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName);
    return function(e) {
      // Broadcast old marker click name for backwards compatibility
      if (eventName === 'click') {
        safeApply(leafletScope, function() {
          $rootScope.$broadcast('leafletDirectiveMarkersClick', name);
        });
      } else if (eventName === 'dragend') {
        safeApply(leafletScope, function() {
          model.lat = lObject.getLatLng().lat;
          model.lng = lObject.getLatLng().lng;
        });

        if (model.message && model.focus === true) {
          lObject.openPopup();
        }
      }

      handle(e); //common
    };
  };

  MarkerEvents.prototype.getAvailableEvents = function() { return [
      'click',
      'dblclick',
      'mousedown',
      'mouseover',
      'mouseout',
      'contextmenu',
      'dragstart',
      'drag',
      'dragend',
      'move',
      'remove',
      'popupopen',
      'popupclose',
      'touchend',
      'touchstart',
      'touchmove',
      'touchcancel',
      'touchleave',
      ];
  };

  MarkerEvents.prototype.bindEvents = function(maybeMapId, lObject, name, model, leafletScope, layerName) {
      var logic = EventsHelper.prototype.bindEvents.call(this, maybeMapId, lObject, name, model, leafletScope, layerName);

      if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
        lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model, layerName);
      }
    };

  return new MarkerEvents();
}]);

angular.module('leaflet-directive')
.factory('leafletPathEvents', ["$rootScope", "$q", "$log", "leafletHelpers", "leafletLabelEvents", "leafletEventsHelpers", function($rootScope, $q, $log, leafletHelpers, leafletLabelEvents, leafletEventsHelpers) {
  var isDefined = leafletHelpers.isDefined;
  var isObject = leafletHelpers.isObject;
  var Helpers = leafletHelpers;
  var errorHeader = leafletHelpers.errorHeader;
  var lblHelp = leafletLabelEvents;
  var fire = leafletEventsHelpers.fire;

  /*
  TODO (nmccready) This EventsHelper needs to be derrived from leafletEventsHelpers to elminate copy and paste code.
  */

  var _genDispatchPathEvent = function(maybeMapId, eventName, logic, leafletScope, lObject, name, model, layerName) {
    maybeMapId = maybeMapId || '';

    if (maybeMapId)
      maybeMapId = '.' + maybeMapId;

    return function(e) {
      var broadcastName = 'leafletDirectivePath' + maybeMapId + '.' + eventName;
      $log.debug(broadcastName);
      fire(leafletScope, broadcastName, logic, e, e.target || lObject, model, name, layerName);
    };
  };

  var _bindPathEvents = function(maybeMapId, lObject, name, model, leafletScope) {
    var pathEvents = [];
    var i;
    var eventName;
    var logic = 'broadcast';

    if (!isDefined(leafletScope.eventBroadcast)) {
      // Backward compatibility, if no event-broadcast attribute, all events are broadcasted
      pathEvents = _getAvailablePathEvents();
    } else if (!isObject(leafletScope.eventBroadcast)) {
      // Not a valid object
      $log.error(errorHeader + 'event-broadcast must be an object check your model.');
    } else {
      // We have a possible valid object
      if (!isDefined(leafletScope.eventBroadcast.path)) {
        // We do not have events enable/disable do we do nothing (all enabled by default)
        pathEvents = _getAvailablePathEvents();
      } else if (isObject(leafletScope.eventBroadcast.paths)) {
        // Not a valid object
        $log.warn(errorHeader + 'event-broadcast.path must be an object check your model.');
      } else {
        // We have a possible valid map object
        // Event propadation logic
        if (leafletScope.eventBroadcast.path.logic !== undefined && leafletScope.eventBroadcast.path.logic !== null) {
          // We take care of possible propagation logic
          if (leafletScope.eventBroadcast.path.logic !== 'emit' && leafletScope.eventBroadcast.path.logic !== 'broadcast') {
            // This is an error
            $log.warn(errorHeader + 'Available event propagation logic are: \'emit\' or \'broadcast\'.');
          } else if (leafletScope.eventBroadcast.path.logic === 'emit') {
            logic = 'emit';
          }
        }

        // Enable / Disable
        var pathEventsEnable = false;
        var pathEventsDisable = false;
        if (leafletScope.eventBroadcast.path.enable !== undefined && leafletScope.eventBroadcast.path.enable !== null) {
          if (typeof leafletScope.eventBroadcast.path.enable === 'object') {
            pathEventsEnable = true;
          }
        }

        if (leafletScope.eventBroadcast.path.disable !== undefined && leafletScope.eventBroadcast.path.disable !== null) {
          if (typeof leafletScope.eventBroadcast.path.disable === 'object') {
            pathEventsDisable = true;
          }
        }

        if (pathEventsEnable && pathEventsDisable) {
          // Both are active, this is an error
          $log.warn(errorHeader + 'can not enable and disable events at the same time');
        } else if (!pathEventsEnable && !pathEventsDisable) {
          // Both are inactive, this is an error
          $log.warn(errorHeader + 'must enable or disable events');
        } else {
          // At this point the path object is OK, lets enable or disable events
          if (pathEventsEnable) {
            // Enable events
            for (i = 0; i < leafletScope.eventBroadcast.path.enable.length; i++) {
              eventName = leafletScope.eventBroadcast.path.enable[i];

              // Do we have already the event enabled?
              if (pathEvents.indexOf(eventName) !== -1) {
                // Repeated event, this is an error
                $log.warn(errorHeader + 'This event ' + eventName + ' is already enabled');
              } else {
                // Does the event exists?
                if (_getAvailablePathEvents().indexOf(eventName) === -1) {
                  // The event does not exists, this is an error
                  $log.warn(errorHeader + 'This event ' + eventName + ' does not exist');
                } else {
                  // All ok enable the event
                  pathEvents.push(eventName);
                }
              }
            }
          } else {
            // Disable events
            pathEvents = _getAvailablePathEvents();
            for (i = 0; i < leafletScope.eventBroadcast.path.disable.length; i++) {
              eventName = leafletScope.eventBroadcast.path.disable[i];
              var index = pathEvents.indexOf(eventName);
              if (index === -1) {
                // The event does not exist
                $log.warn(errorHeader + 'This event ' + eventName + ' does not exist or has been already disabled');

              } else {
                pathEvents.splice(index, 1);
              }
            }
          }
        }
      }
    }

    for (i = 0; i < pathEvents.length; i++) {
      eventName = pathEvents[i];
      lObject.on(eventName, _genDispatchPathEvent(maybeMapId, eventName, logic, leafletScope, pathEvents, name));
    }

    if (Helpers.LabelPlugin.isLoaded() && isDefined(lObject.label)) {
      lblHelp.genEvents(maybeMapId, name, logic, leafletScope, lObject, model);
    }
  };

  var _getAvailablePathEvents = function() {
    return [
        'click',
        'dblclick',
        'mousedown',
        'mouseover',
        'mouseout',
        'contextmenu',
        'add',
        'remove',
        'popupopen',
        'popupclose',
    ];
  };

  return {
    getAvailablePathEvents: _getAvailablePathEvents,
    bindPathEvents: _bindPathEvents,
  };
}]);

}(angular));
/* eslint-enable */

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('keypressEscape', keypressEscape);

  /** @ngInject */
  function keypressEscape() {
    var ESCAPE_KEY = 27;

    var directive = {
      restrict: 'A',
      link: function postLink(scope, element, attrs) {
        element.bind('keydown', function (event) {
          if (event.keyCode === ESCAPE_KEY) {
            scope.$apply(attrs.keypressEscape);
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('inputMask', inputMask);

  /** @ngInject */
  function inputMask() {
    var directive = {
      restrict:'A',
      scope: true,
      link: function (scope, element, attrs) {
        var options;
        if (attrs.inputMask) {
          options = scope.$eval(attrs.inputMask);
        } else if (attrs.maskOptions) {
          options = scope.$eval(attrs.maskOptions);
        }
        angular.element(element).inputmask(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('gaugeChart', gaugeChart);

  /** @ngInject */
  function gaugeChart() {
    /* eslint-disable */
    var directive = {
      restrict: 'A',
      scope: {
        data: '=',
        options: '='
      },
      link: function($scope, $el) {
        var data = $scope.data,
            options = $scope.options,
            gauge = new Gauge($el[0]).setOptions(options);

        gauge.maxValue = data.maxValue;
        gauge.animationSpeed = data.animationSpeed;
        gauge.set(data.val);
      }
    };

    return directive;
    /* esling-enable */

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('countTo', countTo);

  /** @ngInject */
  function countTo($timeout) {
    /* eslint-disable */
    var directive = {
      replace: false,
      scope: true,
      link: function (scope, element, attrs) {

        var e = element[0];
        var num, refreshInterval, duration, steps, step, countTo, value, increment;

        var calculate = function () {
          refreshInterval = 30;
          step = 0;
          scope.timoutId = null;
          countTo = parseInt(attrs.countTo) || 0;
          scope.value = parseInt(attrs.value, 10) || 0;
          duration = (parseFloat(attrs.duration) * 1000) || 0;

          steps = Math.ceil(duration / refreshInterval);
          increment = ((countTo - scope.value) / steps);
          num = scope.value;
        };

        var tick = function () {
          scope.timoutId = $timeout(function () {
            num += increment;
            step++;
            if (step >= steps) {
              $timeout.cancel(scope.timoutId);
              num = countTo;
              e.textContent = countTo;
            } else {
              e.textContent = Math.round(num);
              tick();
            }
          }, refreshInterval);

        };

        var start = function () {
          if (scope.timoutId) {
            $timeout.cancel(scope.timoutId);
          }
          calculate();
          tick();
        };

        attrs.$observe('countTo', function (val) {
          if (val) {
            start();
          }
        });

        attrs.$observe('value', function (val) {
          start();
        });

        return true;
      }
    };

    return directive;
    /* esling-enable */

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('clock', clock);

  /** @ngInject */
  function clock($interval, moment) {
    var directive = {
      restrict: 'EA',
      replace: true,
      scope: {
        radius: '@',
        zone: '@?',
        lightFill: '@?',
        darkFill: '@?'
      },
      template: '<div class=\'bloc-clock\' ng-style=\'divStyle()\'>\n  <svg xmlns="http://www.w3.org/2000/svg"\n   style="padding: 10px 0"\n    width="100%"\n       height="100%"\n       viewBox="0 0 200 200">\n    <g class=\'face\' style=\'stroke: black; stroke-width: 0px;\'>\n      <g>\n        <circle style="stroke: rgba(255,255,255,.5); fill: rgba(255,255,255,0); stroke-width: 6px;"\n                cx="100"\n                cy="100"\n                r="100"/>\n        <line x1="100"\n              x2="100"\n              y1="10"\n              y2="0"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="150"\n              x2="145"\n              y1="13"\n              y2="22"\n              />\n        <line x1="187"\n              x2="178"\n              y1="50"\n              y2="55"\n              />\n        <line x1="190"\n              x2="200"\n              y1="100"\n              y2="100"\n              />\n        <line x1="187"\n              x2="178"\n              y1="150"\n              y2="145"\n              />\n        <line x1="150"\n              x2="145"\n              y1="187"\n              y2="178"\n              />\n        <line x1="100"\n              x2="100"\n              y1="190"\n              y2="200"\n              />\n        <line x1="50"\n              x2="55"\n              y1="187"\n              y2="178"\n              />\n        <line x1="13"\n              x2="22"\n              y1="150"\n              y2="145"\n              />\n        <line x1="0"\n              x2="10"\n              y1="100"\n              y2="100"\n              />\n        <line x1="13"\n              x2="22"\n              y1="50"\n              y2="55"\n              />\n        <line x1="50"\n              x2="55"\n              y1="13"\n              y2="22"\n              />\n      </g>\n      <g>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="45"\n                style="stroke-width: 6px"\n                class="hourhand"/>\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="15"\n                style="stroke-width: 6px"\n                class="minutehand" />\n          <line x1="100"\n                y1="100"\n                x2="100"\n                y2="5"\n                style="stroke-width: 3px; stroke: rgba(255,255,255,.5)"\n                class="secondhand"/>\n      <circle cx="100"\n cy="100"\n r="8"\n fill="white"\n />\n   </g>\n    </g>\n  </svg>\n</div>',
      link: function(scope, el) {
        var drawHands, getRad, getX, getY;

        scope.divStyle = function() {
          return {
            width: scope.w(),
            height: scope.w(),
            margin: '0 auto'
          };
        };

        scope.w = function() {
          return scope.radius * 2;
        };

        getX = function(degrees, r, adjust, x) {
          var adj;
          x = x || r;
          adj = adjust || 1;
          return x + r * adj * Math.cos(getRad(degrees));
        };

        getY = function(degrees, r, adjust, y) {
          var adj;
          y = y || r;
          adj = adjust || 1;
          return y + r * adj * Math.sin(getRad(degrees));
        };

        getRad = function(degrees) {
          var adjust;
          adjust = Math.PI / 2;
          return (degrees * Math.PI / 180) - adjust;
        };

        drawHands = function() {
          var H_HAND_SIZE, M_HAND_SIZE, S_HAND_SIZE, drawHand, hour, r, strokeColor, t;
          S_HAND_SIZE = 0.95;
          M_HAND_SIZE = 0.85;
          H_HAND_SIZE = 0.55;
          t = scope.zone ? moment.tz(new Date(), scope.zone) : moment();
          r = 100;
          strokeColor = 'rgba(255,255,255,1)';
          el.find('line').not('.secondhand').css('stroke', strokeColor);
          drawHand = function(hand, value, size, degrees) {
            var deg, x2, y2;
            deg = degrees * value;
            x2 = getX(deg, r, size, r);
            y2 = getY(deg, r, size, r);
            hand.attr('x1', r);
            hand.attr('y1', r);
            hand.attr('x2', x2);
            hand.attr('y2', y2);
          };
          hour = t.hour() + t.minute() / 60;
          drawHand(angular.element(el).find('.secondhand'), t.second(), S_HAND_SIZE, 6);
          drawHand(angular.element(el).find('.minutehand'), t.minute(), M_HAND_SIZE, 6);
          drawHand(angular.element(el).find('.hourhand'), hour, H_HAND_SIZE, 30);
        };
        drawHands();
        $interval(drawHands, 1000);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('filestyle', filestyle);

  /** @ngInject */
  function filestyle() {
    var directive = {
      restrict:'AC',
      scope: true,
      link: function (scope, element, attrs) {
        var options = {
          'input': attrs.input === 'false' ? false : true,
          'icon': attrs.icon === 'false' ? false : true,
          'buttonBefore': attrs.buttonBefore === 'true' ? true : false,
          'disabled': attrs.disabled === 'true' ? true : false,
          'size': attrs.size,
          'buttonText': attrs.buttonText,
          'buttonName': attrs.buttonName,
          'iconName': attrs.iconName,
          'badge': attrs.badge === 'false' ? false : true,
          'placeholder': attrs.placeholder
        };
        angular.element(element).filestyle(options);
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('anchorScroll', anchorScroll);

  /** @ngInject */
  function anchorScroll($location, $anchorScroll) {
    var directive = {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function() {
          $location.hash(attr.anchorScroll);
          $anchorScroll();
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('activeToggle', activeToggle);

  /** @ngInject */
  function activeToggle() {
    var directive = {
      restrict: 'A',
      link: function postLink(scope, element, attr) {

        element.on('click', function(){

          var target = angular.element(attr.target) || Array(element);

          if (element.hasClass('active')) {
            element.removeClass('active');
            target.removeClass('show');
          } else {
            element.addClass('active');
            target.addClass('show');
          }

        });

      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('activateButton', activateButton);

  /** @ngInject */
  function activateButton($timeout) {
    var directive = {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var activatedClass = 'btn-activated';
        var status = attrs.activateButton;
        var activate = function() {
          element.addClass(activatedClass);
          $timeout(function() {
            element.removeClass(activatedClass);
          }, 1000 );
        };

        element.on('click', function() {
          if (!element.hasClass(activatedClass) && status === 'success') {
            element.addClass('btn-activated-success');
            $timeout(function() {
              element.removeClass('btn-activated-success');
            }, 1000 );
          } else if (!element.hasClass(activatedClass) && status === 'error') {
            element.addClass('btn-activated-error');
            $timeout(function() {
              element.removeClass('btn-activated-error');
            }, 1000 );
          } else if (!element.hasClass(activatedClass)) {
            activate();
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;

    var unregisterSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      event.targetScope.$watch('$viewContentLoaded', function () {
        angular.element('html, body, #content').animate({ scrollTop: 0 }, 200);
      });
      $rootScope.$state.current = toState;
      $rootScope.specialClass = toState.specialClass;
    });
    $rootScope.$on('$destroy', unregisterSuccess);

    var unregisterError = $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
      // We can catch the error thrown when the $requireSignIn promise is rejected
      // and redirect the user back to the home page
      if (error === "AUTH_REQUIRED") {
        $state.go("core.login");
      }
    });
    $rootScope.$on('$destroy', unregisterError);
  }

})();

(function() {
  'use strict';
  angular
    .module('minotaur')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
    //dashboard
      .state('dashboard', {
        url: '/app/dashboard',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //categories
      .state('categories', {
        url: '/categories',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.list', {
        url: '/list',
        templateUrl: 'app/pages/categories/list.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.new', {
        url: '/new',
        templateUrl: 'app/pages/categories/new.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/categories/edit.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('categories.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/categories/show.html',
        controller: 'CategoriesController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      //location
      .state('locations', {
        url: '/locations',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.list', {
        url: '/list',
        templateUrl: 'app/pages/locations/list.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.new', {
        url: '/new',
        templateUrl: 'app/pages/locations/new.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/locations/edit.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('locations.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/locations/show.html',
        controller: 'LocationsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })   
      //stocks
      .state('stocks', {
        abstract: true,
        url: '/stocks',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('stocks.list', {
        url: '/list',
        templateUrl: 'app/pages/stocks/list.html',
        controller: 'StocksController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('stocks.new', {
        url: '/new',
        templateUrl: 'app/pages/stocks/new.html',
        controller: 'StocksController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('stocks.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/stocks/edit.html',
        controller: 'StocksController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('stocks.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/stocks/show.html',
        controller: 'StocksController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })  
      //weather
      .state('weather', {
        abstract: true,
        url: '/weather',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('weather.list', {
        url: '/list',
        templateUrl: 'app/pages/weather/list.html',
        controller: 'WeatherController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('weather.new', {
        url: '/new',
        templateUrl: 'app/pages/weather/new.html',
        controller: 'WeatherController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('weather.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/weather/edit.html',
        controller: 'WeatherController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('weather.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/weather/show.html',
        controller: 'WeatherController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      }) 
      //news
      .state('news', {
        abstract: true,
        url: '/news',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('news.list', {
        url: '/list',
        templateUrl: 'app/pages/news/list.html',
        controller: 'NewsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('news.new', {
        url: '/new',
        templateUrl: 'app/pages/news/new.html',
        controller: 'NewsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('news.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/news/edit.html',
        controller: 'NewsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('news.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/news/show.html',
        controller: 'NewsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
     //ViVa
      .state('viva', {
        abstract: true,
        url: '/viva',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('viva.list', {
        url: '/list',
        templateUrl: 'app/pages/viva/list.html',
        controller: 'VivaController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('viva.new', {
        url: '/new',
        templateUrl: 'app/pages/viva/new.html',
        controller: 'VivaController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('viva.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/viva/edit.html',
        controller: 'VivaController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('viva.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/viva/show.html',
        controller: 'VivaController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      //products
      .state('products', {
        abstract: true,
        url: '/products',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('products.list', {
        url: '/list',
        templateUrl: 'app/pages/products/list.html',
        controller: 'ProductsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('products.new', {
        url: '/new',
        templateUrl: 'app/pages/products/new.html',
        controller: 'ProductsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('products.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/products/edit.html',
        controller: 'ProductsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('products.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/products/show.html',
        controller: 'ProductsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //orders
      .state('orders', {
        abstract: true,
        url: '/orders',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('orders.list', {
        url: '/list',
        templateUrl: 'app/pages/orders/list.html',
        controller: 'OrdersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('orders.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/orders/show.html',
        controller: 'OrdersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })

      //users
      .state('users', {
        abstract: true,
        url: '/users',
        template: '<div ui-view></div>',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.list', {
        url: '/list',
        templateUrl: 'app/pages/users/list.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.new', {
        url: '/new',
        templateUrl: 'app/pages/users/new.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.edit', {
        url: '/edit/:id',
        templateUrl: 'app/pages/users/edit.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('users.show', {
        url: '/show/:id',
        templateUrl: 'app/pages/users/show.html',
        controller: 'UsersController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('profile', {
        url: '/profile',
        templateUrl: 'app/pages/profile/profile.html',
        controller: 'ProfileController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('settings', {
        url: '/settings',
        templateUrl: 'app/pages/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
       .state('support', {
        url: '/support',
        templateUrl: 'app/pages/support/support.html',
        controller: 'SupportController',
        controllerAs: 'ctrl',
        resolve: {
          // controller will not be loaded until $requireSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $requireSignIn returns a promise so the resolve waits for it to complete
            // If the promise is rejected, it will throw a $stateChangeError (see above)
            return Auth.$requireSignIn();
          }]
        }
      })
      .state('core', {
        abstract: true,
        url: '/core',
        template: '<div ui-view></div>',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        controller: 'LoginController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.signup', {
        url: '/signup',
        templateUrl: 'app/pages/signup/signup.html',
        controller: 'SignupController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      })
      .state('core.forgotpass', {
        url: '/forgotpass',
        templateUrl: 'app/pages/forgotpass/forgotpass.html',
        controller: 'ForgotpassController',
        controllerAs: 'ctrl',
        specialClass: 'core',
        resolve: {
          // controller will not be loaded until $waitForSignIn resolves
          // Auth refers to our $firebaseAuth wrapper in the factory below
          'currentAuth': ['Auth', function(Auth) {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn();
          }]
        }
      });

    $urlRouterProvider.otherwise('/app/dashboard');
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($translate, Auth, $firebaseObject, firebase) {
    var vm = this;

    vm.auth = Auth;

    // any time auth state changes, add the user data to scope
    vm.auth.$onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        vm.settings = $firebaseObject(firebase.database().ref().child('settings'));
        vm.currentUser = $firebaseObject(firebase.database().ref().child('users').child(firebaseUser.uid));
      }
      vm.firebaseUser = firebaseUser;
    });



    vm.changeLanguage = function (langKey) {
      $translate.use(langKey);
      vm.currentLanguage = langKey;
    };
    vm.currentLanguage = $translate.proposedLanguage() || $translate.use();
  }
})();

/* global moment:false, firebase: false */
(function() {
  'use strict';

  /* eslint-disable */
  angular
    .module('minotaur')
    .constant('moment', moment)
    .constant('firebase', firebase);
  /*eslint-enable*/

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, $locationProvider, $provide) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    // angular-language
    $translateProvider.useStaticFilesLoader({
      prefix: 'assets/languages/',
      suffix: '.json'
    });
    $translateProvider.useLocalStorage();
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy(null);

    // remove ! hash prefix
    $locationProvider.hashPrefix('');

    // inject the $delegate dependency into our decorator method
    firebaseDecorator.$inject = ['$delegate'];

    // Whenever $firebaseArray's and $firebaseObjects are created,
    // they'll now be tracked by window.openFirebaseConnections
    $provide.decorator("$firebaseArray", firebaseDecorator);
    $provide.decorator("$firebaseObject", firebaseDecorator);

    function firebaseDecorator ($delegate) {
      return function (ref) {
        var list = $delegate(ref);
        /* eslint-disable */
        window.openFirebaseConnections.push(list);
        /* eslint-enable */
        return list;
      };
    }

  }

})();

angular.module("minotaur").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/templates/messages_tmpl.html","<p ng-message=required style=\"margin: 0\">This field is required</p><p ng-message=minlength style=\"margin: 0\">This field is too short</p><p ng-message=maxlength style=\"margin: 0\">This field is too long</p><p ng-message=email style=\"margin: 0\">This needs to be a valid email</p><p ng-message=number style=\"margin: 0\">This needs to be a valid number</p><p ng-message=match style=\"margin: 0\">Values do not match!</p><p ng-message=pattern style=\"margin: 0\">Input in bad format!</p><p ng-message=min style=\"margin: 0\">This value is too low</p><p ng-message=max style=\"margin: 0\">This value is too high</p>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"page page-dashboard pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Dashboard</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-8><!-- tile --><div class=tile ng-controller=\"OrdersChartController as vm\"><!-- tile header --><section class=tile-header><h1 class=heading>Dashboard</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><section class=\"tile-widget text-right\"><div uib-dropdown class=\"dropdown rounded-dropdown\"></div></section><!-- tile body --><section class=tile-body></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --><!-- col --><div class=col-md-4><!-- tile --><div class=tile ng-controller=\"ProductsChartController as vm\"><!-- tile header --><section class=tile-header><h1 class=heading>ViVa Box</h1><div class=controls><div class=btn-group uib-dropdown></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- cards row --><div class=row><!-- col --><div class=\"card-container col-lg-3 col-sm-6 col-sm-12\"><div class=card><div class=\"front bg-lightred\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-tv fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.products.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.products.length when=\"{\'0\': \'location\',\n                       \'one\': \'location\',\n                       \'other\': \'locations\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-lightred\"><!-- row --><div class=row><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=locations.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Display / Locations</a></div><div class=col-xs-6><a href=javascript:; ui-sref=locations.new><i class=\"fa fa-plus fa-2x\"></i> Add Display / Location</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- col --><div class=\"card-container col-lg-3 col-sm-6 col-sm-12\"><div class=card><div class=\"front bg-greensea\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-unlock fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.activeUsers.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.activeUsers.length when=\"{\'0\': \'Users\',\n                       \'one\': \'User\',\n                       \'other\': \'Users\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-greensea\"><!-- row --><div class=row><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=users.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Users</a></div><div class=col-xs-6><a href=javascript:; ui-sref=users.new><i class=\"fa fa-plus fa-2x\"></i> Add User</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --><!-- viva --><div class=\"card-container col-lg-3 col-sm-6 col-sm-12\"><div class=card><div class=\"front bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-users fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.activeUsers.length}} value=0 duration=0.3></p><span><ng-pluralize count=ctrl.activeUsers.length when=\"{\'0\': \'Viva\',\n                       \'one\': \'Viva\',\n                       \'other\': \'Viva\'}\"></ng-pluralize></span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-slategray\"><!-- row --><div class=row><!-- col --><div class=col-xs-6><a href=javascript:; ui-sref=users.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Manage Viva Users</a></div><div class=col-xs-6><a href=javascript:; ui-sref=users.new><i class=\"fa fa-plus fa-2x\"></i> Add Viva User</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /viva --><!-- col --><div class=\"card-container col-lg-3 col-sm-6 col-sm-12\"><div class=card><div class=\"front bg-blue\"><!-- row --><div class=row><!-- col --><div class=col-xs-4><i class=\"fa fa-envira fa-4x\"></i></div><!-- /col --><!-- col --><div class=col-xs-8><p class=\"text-xl line-xl text-strong mb-0\" count-to={{ctrl.ordersValue}} value=0 duration=0.3></p><span>StarLeaf Calls</span></div><!-- /col --></div><!-- /row --></div><div class=\"back bg-blue\"><!-- row --><div class=row><!-- col --><div class=col-xs-12><a href=javascript:; ui-sref=viva.list><i class=\"fa fa-ellipsis-h fa-2x\"></i> Recent Calls</a></div><!-- /col --></div><!-- /row --></div></div></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Category name...\" ng-model=vm.category.name required></div></div><div class=form-group><label for=parent class=\"col-sm-3 control-label minotaur-label\">Parent Category</label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=parent class=form-control id=parent ng-options=\"c.$id as c.name for c in vm.categories\" ng-model=vm.category.parentId data-placeholder=\"Select a parent category...\"><option></option></select></div></div><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=categories.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/categories/edit.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"EditCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>{{vm.category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/list.html","<div class=\"page page-categories pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>Manage Categories</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Categories</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Category\" tooltip-placement=bottom ui-sref=categories.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"category in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"categories.show({ id: category.$id })\">{{category.name}}</a></td><td data-title=\"\'Parent Category\'\" sortable>{{category.parentName}}</td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"categories.edit({ id: category.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(category)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/new.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"NewCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>New Category</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/categories/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/categories/show.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"ShowCategoryController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Categories</a></li><li class=active>{{vm.category.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li><strong>Name:</strong> {{vm.category.name}}</li><li ng-if=vm.category.parentId><strong>Parent Category:</strong> {{vm.categoriesObject[vm.category.parentId].name}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=categories.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/news/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"news ID...\" ng-model=vm.news.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"news name...\" ng-model=vm.news.name required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Link <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=link class=form-control id=link placeholder=\"Zip Code...\" ng-model=vm.news.link required></div></div><div class=form-group><label for=location class=\"col-sm-3 control-label minotaur-label\">Location <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=location class=form-control id=location ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childLocations\" ng-model=vm.news.locationId data-placeholder=\"Select a location...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.news.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=news.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/news/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditNewsController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=news.list>News</a></li><li class=active>{{vm.news.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/news/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/news/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=news.list>news</a></li><li class=active>Manage news</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage News</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add news\" tooltip-placement=bottom ui-sref=news.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"news in $data\"><td data-title=\"\'ID\'\" sortable>{{news.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"news.show({ id: news.$id })\">{{news.name}}</a></td><td data-title=\"\'Date Created\'\" sortable>{{news.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : news.status == \'published\',\'bg-warning\' : news.status == \'not published\',\'bg-lightred\' : news.status == \'banned\'}\">{{ news.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"news.edit({ id: news.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(news)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/news/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewNewsController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=news.list>News</a></li><li class=active>New News</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/news/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/news/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowNewsController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=news.list>News</a></li><li class=active>{{vm.News.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.news.name}} <span class=label ng-class=\"{\'bg-success\' : vm.news.status == \'published\',\'bg-warning\' : vm.news.status == \'not published\',\'bg-lightred\' : vm.news.status == \'banned\'}\">{{ vm.news.status }}</span></h2><p class=\"desc text-default lt mb-20\">{{vm.news.description}}</p><p class=\"desc text-default lt mb-20\"><strong>Zip Code:</strong> {{vm.news.zipcode}}</p><p class=\"desc text-default lt mb-20\"><strong>City Name:</strong> {{vm.news.cityname}}</p><p class=\"desc text-default lt mb-20\"><strong>State:</strong> {{vm.news.state}}</p><p class=\"desc text-default lt mb-20\"><strong>GPS LAT:</strong> {{vm.news.gpslat}}</p><p class=\"desc text-default lt mb-20\"><strong>GPS LON:</strong> {{vm.news.gpslon}}</p><h6><strong>Location:</strong> {{ctrl.locationsObject[vm.news.locationId].name}}</h6></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=news.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/forgotpass/forgotpass.html","<div class=\"page page-core page-forgotpass\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>Admin</strong>Panel</h2></div><form name=form ng-submit=ctrl.submit()><p class=\"help-block text-left\">Enter your e-mail address below to reset your password.</p><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-envelope></i></span> <input type=email placeholder=\"Email address\" class=form-control ng-model=ctrl.email required></div><button type=submit class=\"btn btn-lg btn-block btn-rounded-40\" ng-disabled=form.$invalid>Submit</button></form><div class=\"mt-15 text-center\">Know your password? <a ui-sref=core.login>Please log in</a></div></div></div>");
$templateCache.put("app/pages/login/login.html","<div class=\"page page-core page-login\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>Admin</strong>Panel</h2></div><form name=form ng-submit=ctrl.login();><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-user></i></span> <input type=email placeholder=\"Email address\" ng-model=ctrl.email class=form-control required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-key></i></span> <input type=password placeholder=Password ng-model=ctrl.password class=form-control required></div><div class=form-group><a ui-sref=core.forgotpass>Forgot Password?</a></div><button type=submit class=\"btn btn-block btn-lg btn-rounded-40\" ng-disabled=form.$invalid>Login</button></form></div></div>");
$templateCache.put("app/pages/locations/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"location name...\" ng-model=vm.location.name required></div></div><div class=form-group><label for=parent class=\"col-sm-3 control-label minotaur-label\">Parent location</label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=parent class=form-control id=parent ng-options=\"c.$id as c.name for c in vm.locations\" ng-model=vm.location.parentId data-placeholder=\"Select a parent location...\"><option></option></select></div></div><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=locations.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/locations/edit.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"EditLocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Locations</a></li><li class=active>{{vm.location.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/locations/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/list.html","<div class=\"page page-categories pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Locations</a></li><li class=active>Manage Locations</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Locations</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add location\" tooltip-placement=bottom ui-sref=locations.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"location in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"locations.show({ id: location.$id })\">{{location.name}}</a></td><td data-title=\"\'Parent location\'\" sortable>{{category.parentName}}</td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"locations.edit({ id: location.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(location)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/new.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"NewLocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=locations.list>Locations</a></li><li class=active>New location</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/locations/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/locations/show.html","<div class=\"page page-categories pull-to-header\" ng-controller=\"ShowlocationController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Locations</a></li><li class=active>{{vm.location.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li><strong>Name:</strong> {{vm.location.name}}</li><li ng-if=vm.location.parentId><strong>Parent location:</strong> {{vm.locationsObject[vm.location.parentId].name}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=locations.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/orders/list.html","<div class=\"page page-orders pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=orders.list>Orders</a></li><li class=active>Manage Orders</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Orders</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive style=\"overflow-x: visible\"><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"order in $data\"><td data-title=\"\'ID\'\" sortable><a ui-sref=\"orders.show({id: order.$id})\">{{order.id}}</a></td><td data-title=\"\'Date\'\" sortable>{{order.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Customer\'\" sortable>{{order.customer.name}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : order.status == \'approved\',\'bg-warning\' : order.status == \'pending\',\'bg-lightred\' : order.status == \'cancelled\',\'bg-primary\' : order.status == \'received\'}\">{{ order.status }}</span></td><td data-title=\"\'Ship To\'\" sortable>{{ order.shipTo.name }}, {{ order.shipTo.street }}, {{ order.shipTo.city }} {{ order.shipTo.zip }}, {{ order.shipTo.country }}</td><td data-title=\"\'Total\'\" sortable>{{order.subTotal | currency }}</td><td data-title=\"\'Actions\'\" class=w-md><div class=\"text-left rounded-dropdown\" uib-dropdown><button type=button class=\"btn btn-default btn-sm btn-rounded-20\" uib-dropdown-toggle><span><span ng-class=\"{\'text-success\' : order.status == \'approved\',\'text-warning\' : order.status == \'pending\',\'text-lightred\' : order.status == \'cancelled\',\'text-primary\' : order.status == \'received\'}\">{{order.status}}</span> <i class=\"fa fa-chevron-down\"></i></span></button><ul class=\"dropdown-menu pull-right\" role=menu aria-labelledby=single-button><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'pending\')\">Pending</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'approved\')\">Approved</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'cancelled\')\">Cancelled</a></li><li role=menuitem><a href=javascript:; ng-click=\"ctrl.changeStatus(order, \'received\')\">Received</a></li></ul></div><button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(category)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/orders/show.html","<div class=\"page page-orders pull-to-header\" ng-controller=\"ShowOrderController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=orders.list>Orders</a></li><li class=active>{{vm.order.id}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><!-- row --><div class=row><!-- col --><div class=col-md-9><p class=\"text-default lt\">Created: {{ vm.order.created_at | date: \'MMMM dd, yyyy\' }} at {{ vm.order.created_at | date: \'HH:mm\' }}</p><h5 class=\"text-uppercase text-strong mt-40 mb-0\">Status</h5><h3 class=\"text-uppercase mt-0 mb-20\" ng-class=\"{\'text-success\' : vm.order.status == \'approved\',\'text-warning\' : vm.order.status == \'pending\',\'text-lightred\' : vm.order.status == \'cancelled\',\'text-primary\' : vm.order.status == \'received\'}\">{{vm.order.status | uppercase}}</h3></div><!-- /col --><!-- col --><div class=col-md-3><h5 class=\"text-uppercase text-strong mb-10\">Customer</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong class=\"inline-block w-xs\">Name:</strong> {{vm.order.customer.name}}</li><li><strong class=\"inline-block w-xs\">State:</strong> {{vm.order.customer.country}}</li><li><strong class=\"inline-block w-xs\">Phone:</strong> {{vm.order.customer.phone}}</li><li><strong class=\"inline-block w-xs\">Email:</strong> <a href=javascript:;>{{vm.order.customer.email}}</a></li></ul></div><!-- /col --></div><!-- /row --><!-- row --><div class=\"row b-t pt-20\"><!-- col --><div class=\"col-md-3 b-r\"><h5 class=\"text-uppercase text-strong mb-10\">Order Details</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong>ID:</strong> <a href=javascript:;>{{vm.order.id}}</a></li><li>{{ vm.order.created_at | date: \'MMMM dd, yyyy\' }} at {{ vm.order.created_at | date: \'HH:mm\' }}</li><li>{{vm.order.customer.name}}</li><li>{{vm.order.customer.country}}</li></ul></div><!-- /col --><!-- col --><div class=\"col-md-6 b-r\"><h5 class=\"text-uppercase text-strong mb-10\">Address</h5><!-- col --><div class=col-md-6><ul class=\"list-unstyled text-default lt mb-20\"><li>{{vm.order.shipTo.name}}</li><li>{{vm.order.shipTo.street}}</li><li>{{vm.order.shipTo.city}}</li><li>{{vm.order.shipTo.zip}}</li><li>{{vm.order.shipTo.country}}</li></ul></div><!-- /col --><!-- col --><div class=col-md-6><ul class=\"list-unstyled text-default lt mb-20\"><li>{{vm.order.customer.email}}</li><li>{{vm.order.customer.phone}}</li></ul></div><!-- /col --></div><!-- /col --><!-- col --><div class=col-md-3><h5 class=\"text-uppercase text-strong mb-10\">Delivery & Payment</h5><ul class=\"list-unstyled text-default lt mb-20\"><li><strong>Delivery:</strong> {{vm.order.delivery}}</li><li><strong>Payment:</strong> {{vm.order.payment}}</li></ul></div><!-- /col --></div><!-- /row --></section><!-- /tile body --></div><!-- /tile --><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=\"tile-body p-0\"><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>Product Image</th><th>Product</th><th>Category</th><th>Unit Price</th><th>Amount</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"(id, product) in vm.order.products\"><td style=\"vertical-align: middle\"><img ng-src={{ctrl.productsObject[id].images[0].src}} alt={{ctrl.productsObject[id].name}} style=\"width: 64px; height: 64px\"></td><td style=\"vertical-align: middle\"><a ui-sref=\"products.show({id: id})\">{{ctrl.productsObject[id].name}}</a><br><span class=\"text-sm text-muted\">{{ctrl.productsObject[id].shortDescription | limitTo: 80}}...</span></td><td style=\"vertical-align: middle\">{{ctrl.categoriesObject[ctrl.productsObject[id].categoryId].name}}</td><td style=\"vertical-align: middle\">{{product.price | currency}}</td><td style=\"vertical-align: middle\">{{product.amount}}</td><td style=\"vertical-align: middle\">{{(product.price) * product.amount | currency}}</td></tr></tbody></table></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=\"col-md-3 col-md-offset-9 price-total\"><!-- tile --><div class=\"tile tile-simple bg-slategray\"><!-- tile body --><section class=tile-body><ul class=list-unstyled><li><strong class=\"inline-block w-sm mb-5\">Subtotal:</strong> {{vm.order.subTotal | currency}}</li><li><strong class=\"inline-block w-sm mb-5\">Vat %:</strong> {{ main.settings.globalVAT }}</li><li><strong class=\"inline-block w-sm mb-5\">Vat Total:</strong> {{ vm.order.subTotal * (main.settings.globalVAT / 100) | currency}}</li><li><strong class=\"inline-block w-sm\">Total:</strong><h3 class=\"inline-block text-success\">{{ vm.order.subTotal + (vm.order.subTotal * (main.settings.globalVAT / 100)) | currency}}</h3></li></ul></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/pages/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Product ID...\" ng-model=vm.product.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Product name...\" ng-model=vm.product.name required></div></div><div class=form-group><label for=description class=\"col-sm-3 control-label minotaur-label\">Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=description id=description ng-model=vm.product.description class=form-control placeholder=\"Product description...\" rows=5 required></textarea></div></div><div class=form-group><label for=shortDescription class=\"col-sm-3 control-label minotaur-label\">Short Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=shortDescription id=shortDescription ng-model=vm.product.shortDescription class=form-control placeholder=\"Product short description...\" rows=2 ng-maxlength=260 required></textarea><span class=help-block>as show in product listing, max. 260 characters</span></div></div><div class=form-group><label for=category class=\"col-sm-3 control-label minotaur-label\">Category <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childCategories\" ng-model=vm.product.categoryId data-placeholder=\"Select a category...\" required><option></option></select></div></div><div class=form-group><label for=price class=\"col-sm-3 control-label minotaur-label\">Price <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><div class=input-group-addon>$</div><input type=number class=form-control name=price id=price ng-model=vm.product.price min=0 step=any required></div></div></div><div class=form-group><label for=discount class=\"col-sm-3 control-label minotaur-label\">Discount <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><input type=number class=form-control name=discount id=discount ng-model=vm.product.discount min=0 max=100 required><div class=input-group-addon>%</div></div></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Unit <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=unit class=form-control id=unit ng-options=\"k as v for (k,v) in ctrl.units\" ng-model=vm.product.unit data-placeholder=\"Select a unit...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.product.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-group><label class=\"control-label minotaur-label col-sm-3\">Images</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><li ng-repeat=\"image in vm.product.images\"><img ngf-thumbnail=image alt=\"\" style=\"width: 120px; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"image = null\" ng-show=\"image && !vm.editing\">x</button></li></ul><p class=\"help-block text-danger\" ng-show=vm.editing>Adding new images will rewrite actual images!</p><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true accept=image/* ng-model=vm.product.images class=\"fileupload drop-box\" name=images>click or drop files here...</div></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/pages/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/pages/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>Manage Products</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Products</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Product\" tooltip-placement=bottom ui-sref=products.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"product in $data\"><td data-title=\"\'ID\'\" sortable>{{product.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"products.show({ id: product.$id })\">{{product.name}}</a></td><td data-title=\"\'Category\'\" sortable>{{product.categoryName}}</td><td data-title=\"\'Price\'\" sortable>{{product.price | currency}}</td><td data-title=\"\'Date Created\'\" sortable>{{product.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : product.status == \'published\',\'bg-warning\' : product.status == \'not published\',\'bg-lightred\' : product.status == \'banned\'}\">{{ product.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"products.edit({ id: product.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(product)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/pages/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>New Product</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/pages/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.product.images[0].src}} class=img-link ng-show=\"vm.product.images.length > 0\"><img ng-src={{vm.product.images[0].src}} alt=vm.product.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.product.images.length === 0 || !vm.product.images\"><img src=assets/images/no-product-image.png alt=vm.product.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.product.images><div ng-repeat=\"image in vm.product.images\" ng-if=!$first href={{vm.product.images[$index].src}} class=mr-5><a href={{vm.product.images[$index].src}} class=img-link><img ng-src={{vm.product.images[$index].src}} alt=vm.product.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.product.name}} <span class=label ng-class=\"{\'bg-success\' : vm.product.status == \'published\',\'bg-warning\' : vm.product.status == \'not published\',\'bg-lightred\' : vm.product.status == \'banned\'}\">{{ vm.product.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.product.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.product.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.product.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.product.price | currency}} / <small>{{vm.product.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.product.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Product ID...\" ng-model=vm.product.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Product name...\" ng-model=vm.product.name required></div></div><div class=form-group><label for=description class=\"col-sm-3 control-label minotaur-label\">Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=description id=description ng-model=vm.product.description class=form-control placeholder=\"Product description...\" rows=5 required></textarea></div></div><div class=form-group><label for=shortDescription class=\"col-sm-3 control-label minotaur-label\">Short Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=shortDescription id=shortDescription ng-model=vm.product.shortDescription class=form-control placeholder=\"Product short description...\" rows=2 ng-maxlength=260 required></textarea><span class=help-block>as show in product listing, max. 260 characters</span></div></div><div class=form-group><label for=category class=\"col-sm-3 control-label minotaur-label\">Category <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=category class=form-control id=category ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childCategories\" ng-model=vm.product.categoryId data-placeholder=\"Select a category...\" required><option></option></select></div></div><div class=form-group><label for=price class=\"col-sm-3 control-label minotaur-label\">Price <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><div class=input-group-addon>$</div><input type=number class=form-control name=price id=price ng-model=vm.product.price min=0 step=any required></div></div></div><div class=form-group><label for=discount class=\"col-sm-3 control-label minotaur-label\">Discount <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><div class=input-group><input type=number class=form-control name=discount id=discount ng-model=vm.product.discount min=0 max=100 required><div class=input-group-addon>%</div></div></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Unit <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=unit class=form-control id=unit ng-options=\"k as v for (k,v) in ctrl.units\" ng-model=vm.product.unit data-placeholder=\"Select a unit...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.product.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-group><label class=\"control-label minotaur-label col-sm-3\">Images</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><li ng-repeat=\"image in vm.product.images\"><img ngf-thumbnail=image alt=\"\" style=\"width: 120px; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"image = null\" ng-show=\"image && !vm.editing\">x</button></li></ul><p class=\"help-block text-danger\" ng-show=vm.editing>Adding new images will rewrite actual images!</p><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true accept=image/* ng-model=vm.product.images class=\"fileupload drop-box\" name=images>click or drop files here...</div></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/products/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>Manage Products</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Products</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add Product\" tooltip-placement=bottom ui-sref=products.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"product in $data\"><td data-title=\"\'ID\'\" sortable>{{product.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"products.show({ id: product.$id })\">{{product.name}}</a></td><td data-title=\"\'Category\'\" sortable>{{product.categoryName}}</td><td data-title=\"\'Price\'\" sortable>{{product.price | currency}}</td><td data-title=\"\'Date Created\'\" sortable>{{product.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : product.status == \'published\',\'bg-warning\' : product.status == \'not published\',\'bg-lightred\' : product.status == \'banned\'}\">{{ product.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"products.edit({ id: product.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(product)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=products.list>Products</a></li><li class=active>New Product</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/products/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/products/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowProductController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=categories.list>Products</a></li><li class=active>{{vm.product.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.product.images[0].src}} class=img-link ng-show=\"vm.product.images.length > 0\"><img ng-src={{vm.product.images[0].src}} alt=vm.product.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.product.images.length === 0 || !vm.product.images\"><img src=assets/images/no-product-image.png alt=vm.product.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.product.images><div ng-repeat=\"image in vm.product.images\" ng-if=!$first href={{vm.product.images[$index].src}} class=mr-5><a href={{vm.product.images[$index].src}} class=img-link><img ng-src={{vm.product.images[$index].src}} alt=vm.product.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.product.name}} <span class=label ng-class=\"{\'bg-success\' : vm.product.status == \'published\',\'bg-warning\' : vm.product.status == \'not published\',\'bg-lightred\' : vm.product.status == \'banned\'}\">{{ vm.product.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.product.shortDescription}}</p><p class=\"desc text-default lt mb-20\">{{vm.product.description}}</p><h6><strong>Category:</strong> {{ctrl.categoriesObject[vm.product.categoryId].name}}</h6><h3 class=\"price mt-40 mb-0 text-success\">{{ vm.product.price | currency}} / <small>{{vm.product.unit}}</small></h3><p class=\"discount text-sm text-default lt\">Discount: {{vm.product.discount}}%</p></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=products.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/profile/profile.html","<div class=\"page page-dashboard pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>My Account</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Personal Info</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><form name=form class=\"form form-horizontal\"><div class=\"form-group mt-20\"><label for=avatar class=\"col-sm-3 control-label minotaur-label\">Avatar</label><div class=col-sm-9><img ngf-thumbnail=ctrl.user.avatar alt=\"\" class=mb-10 style=\"width: 80px; height: 80px\"><a href=javascript:; class=\"inline-block p-5 text-danger ml-5\" ng-click=\"ctrl.user.avatar = null\" ng-show=ctrl.user.avatar><i class=\"fa fa-times\"></i></a> <input type=file name=avatar id=avatar ng-model=ctrl.user.avatar ngf-select ngf-pattern=\"\'image/*\'\" accept=image/* ngf-max-size=5MB></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name</label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"User name...\" ng-model=ctrl.user.name></div></div><div class=form-group ng-show=ctrl.changeEmail><label for=email class=\"col-sm-3 control-label minotaur-label\">Email <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=email name=email class=form-control id=email placeholder=\"User email...\" ng-model=ctrl.user.email required></div></div><div class=form-group ng-show=ctrl.changePass><label for=oldpassword class=\"col-sm-3 control-label minotaur-label\">Old Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=oldpassword class=form-control id=oldpassword placeholder=\"User old password...\" ng-model=ctrl.oldpassword ng-required=ctrl.changePass></div></div><div class=form-group ng-show=\"ctrl.changePass || ctrl.changeEmail\"><label for=password class=\"col-sm-3 control-label minotaur-label\">Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=password class=form-control id=password placeholder=\"User password...\" ng-model=ctrl.user.password ng-required=\"ctrl.changePass || ctrl.changeEmail\"></div></div><div class=form-group ng-show=\"ctrl.changePass || ctrl.changeEmail\"><label for=password class=\"col-sm-3 control-label minotaur-label\">Password Confirm <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=passwordConfirm placeholder=\"Password confirmarion...\" class=form-control ng-model=ctrl.passwordConfirm match=ctrl.user.password ng-required=\"ctrl.changePass || ctrl.changeEmail\"></div></div><div class=form-group><label for=street class=\"col-sm-3 control-label minotaur-label\">Street</label><div class=col-sm-9><input type=text name=street class=form-control id=street placeholder=\"User address street...\" ng-model=ctrl.user.address.street></div></div><div class=form-group><label for=city class=\"col-sm-3 control-label minotaur-label\">City</label><div class=col-sm-9><input type=text name=city class=form-control id=city placeholder=\"User address city...\" ng-model=ctrl.user.address.city></div></div><div class=form-group><label for=zip class=\"col-sm-3 control-label minotaur-label\">ZIP</label><div class=col-sm-9><input type=text name=zip class=form-control id=zip placeholder=\"User address zip...\" ng-model=ctrl.user.address.zip></div></div><div class=form-group><label for=country class=\"col-sm-3 control-label minotaur-label\">Country</label><div class=col-sm-9><input type=text name=country class=form-control id=country placeholder=\"User address country...\" ng-model=ctrl.user.address.country></div></div><div class=form-group><label for=phone class=\"col-sm-3 control-label minotaur-label\">Phone</label><div class=col-sm-9><input type=text name=phone class=form-control id=phone placeholder=\"User address phone...\" ng-model=ctrl.user.phone></div></div><div class=form-group><div class=\"col-sm-9 col-md-offset-3\"><label class=\"checkbox minotaur-checkbox mr-20\" style=\"display: inline-block\"><input type=checkbox ng-disabled=ctrl.changePass ng-model=ctrl.changeEmail> Change email<div class=input-indicator></div></label><label class=\"checkbox minotaur-checkbox\" style=\"display: inline-block\"><input type=checkbox ng-disabled=ctrl.changeEmail ng-model=ctrl.changePass> Change password<div class=input-indicator></div></label></div></div></form></section><!-- /tile body --><div class=\"tile-footer text-right bg-tr-black lter\"><!-- SUBMIT BUTTON --> <button class=\"btn btn-success minotaur-btn\" ng-click=ctrl.save() ng-disabled=form.$invalid>Save</button></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/support/support.html","<div class=\"page page-settings pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Support</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Global Support</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><form name=form class=\"form form-horizontal\"><div class=form-group><label for=vat class=\"col-sm-3 control-label minotaur-label\">Global User ID <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=number name=vat class=form-control id=vat placeholder=\"Set global value...\" ng-model=ctrl.support.global></div></div><div class=form-group><label for=vat class=\"col-sm-3 control-label minotaur-label\">Support info <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=number name=vat class=form-control id=vat placeholder=\"Set global value...\" ng-model=ctrl.support.global></div></div></form></section><!-- /tile body --><div class=\"tile-footer text-right bg-tr-black lter\"><!-- SUBMIT BUTTON --> <button class=\"btn btn-success minotaur-btn\" ng-click=ctrl.save() ng-disabled=form.$invalid>Save</button></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/settings/settings.html","<div class=\"page page-settings pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li class=active>Settings</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-6><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Global Settings</h1><div class=controls><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><form name=form class=\"form form-horizontal\"><div class=form-group><label for=vat class=\"col-sm-3 control-label minotaur-label\">Global VAT <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=number name=vat class=form-control id=vat placeholder=\"Set global VAT value...\" ng-model=ctrl.settings.globalVAT required></div></div></form></section><!-- /tile body --><div class=\"tile-footer text-right bg-tr-black lter\"><!-- SUBMIT BUTTON --> <button class=\"btn btn-success minotaur-btn\" ng-click=ctrl.save() ng-disabled=form.$invalid>Save</button></div></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/signup/signup.html","<div class=\"page page-core page-signup\"><div class=login-modal><div class=branding><img src=assets/images/logo-alt.png alt><h2 class=brand><strong>MIN</strong>OTAUR</h2></div><form name=form ng-submit=ctrl.createUser()><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-user></i></span> <input type=text placeholder=\"Full name\" class=form-control ng-model=ctrl.name required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-envelope></i></span> <input type=email placeholder=\"Email address\" class=form-control ng-model=ctrl.email required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=icon-key></i></span> <input type=password placeholder=Password class=form-control ng-model=ctrl.password required></div><div class=form-group><label class=\"minotaur-checkbox minotaur-label inline-block\">I agree to the <a href=javascript:;>Terms of Service</a> & <a href=javascript:;>Privacy Policy</a> <input type=checkbox required><div class=input-indicator></div></label></div><button type=submit class=\"btn btn-lg btn-block btn-rounded-40\" ng-disabled=form.$invalid>Submit</button></form><div class=\"mt-15 text-center\">Already have an account? <a ui-sref=core.login>Please log in</a></div></div></div>");
$templateCache.put("app/pages/stocks/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Stock ID...\" ng-model=vm.stock.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"Stock name...\" ng-model=vm.stock.name required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Stock Code <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=code class=form-control id=code placeholder=\"Stock Code...\" ng-model=vm.stock.code required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Stock Futures <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=text name=futures1 class=form-control id=futures1 placeholder=\"Stock futures...\" ng-model=vm.stock.futures1></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Stock Futures <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=text name=futures2 class=form-control id=futures2 placeholder=\"Stock futures...\" ng-model=vm.stock.futures2></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Stock Futures <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=text name=futures3 class=form-control id=futures3 placeholder=\"Stock futures...\" ng-model=vm.stock.futures3></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Stock Futures <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><input type=text name=futures4 class=form-control id=futures4 placeholder=\"Stock futures...\" ng-model=vm.stock.futures4></div></div><div class=form-group><label for=description class=\"col-sm-3 control-label minotaur-label\">Description <span class=text-danger style=\"font-size: 15px\"></span></label><div class=col-sm-9><textarea name=description id=description ng-model=vm.stock.description class=form-control placeholder=\"stock description...\" rows=5></textarea></div></div><div class=form-group><label for=location class=\"col-sm-3 control-label minotaur-label\">Location <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=location class=form-control id=location ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childLocations\" ng-model=vm.stock.locationId data-placeholder=\"Select a location...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.stock.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=stocks.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/stocks/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditStockController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stocks.list>Stocks</a></li><li class=active>{{vm.stock.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/stocks/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stocks/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stocks.list>Stocks</a></li><li class=active>Manage Stocks</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Stocks</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add stocks\" tooltip-placement=bottom ui-sref=stocks.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"stock in $data\"><td data-title=\"\'ID\'\" sortable>{{stock.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"stocks.show({ id: stock.$id })\">{{stock.name}}</a></td><td data-title=\"\'Code\'\" sortable>{{stock.code}}</td><td data-title=\"\'Location\'\" sortable>{{stock.locationName}}</td><td data-title=\"\'Date Created\'\" sortable>{{stock.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : stock.status == \'published\',\'bg-warning\' : stock.status == \'not published\',\'bg-lightred\' : stock.status == \'banned\'}\">{{ stock.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"stocks.edit({ id: stock.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(stock)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stocks/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewStockController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stocks.list>Stocks</a></li><li class=active>New Stock</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/stocks/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/stocks/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowStockController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=stocks.list>Stocks</a></li><li class=active>{{vm.stock.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.stock.name}} <span class=label ng-class=\"{\'bg-success\' : vm.stock.status == \'published\',\'bg-warning\' : vm.stock.status == \'not published\',\'bg-lightred\' : vm.stock.status == \'banned\'}\">{{ vm.stock.status }}</span></h2><p class=\"desc text-default lt mb-20\">{{vm.stock.description}}</p><p class=\"desc text-default lt mb-20\"><strong>Stock Code:</strong> {{vm.stock.code}}</p><p class=\"desc text-default lt mb-20\"><strong>Futures:</strong> {{vm.stock.futures1}}</p><p class=\"desc text-default lt mb-20\"><strong>Futures:</strong> {{vm.stock.futures2}}</p><p class=\"desc text-default lt mb-20\"><strong>Futures:</strong> {{vm.stock.futures3}}</p><p class=\"desc text-default lt mb-20\"><strong>Futures:</strong> {{vm.stock.futures4}}</p><h6><strong>Location:</strong> {{ctrl.locationsObject[vm.stock.locationId].name}}</h6></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=stocks.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/viva/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Product ID...\" ng-model=vm.viva.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">First Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=fname class=form-control id=fname placeholder=\"First name...\" ng-model=vm.viva.fname required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Last Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=lname class=form-control id=lname placeholder=\"Last name...\" ng-model=vm.viva.lname required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Title <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=title class=form-control id=title placeholder=Title... ng-model=vm.viva.title required></div></div><div class=form-group><label for=category class=\"col-sm-3 control-label minotaur-label\">Location <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=location class=form-control id=location ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childCategories\" ng-model=vm.viva.locationId data-placeholder=\"Select a location...\"><option></option></select></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Email <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=email class=form-control id=email placeholder=Email... ng-model=vm.viva.email required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Starleaf <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=starleaf class=form-control id=starleaf placeholder=Starleaf... ng-model=vm.viva.starleaf required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Phone Number <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=phone class=form-control id=phone placeholder=Phone... ng-model=vm.viva.phone required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Ext. <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=ext class=form-control id=ext placeholder=Ext... ng-model=vm.viva.ext required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Mobile <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=mobile class=form-control id=mobile placeholder=Mobile... ng-model=vm.viva.mobile required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Mobile Carrier <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=carrier class=form-control id=carrier placeholder=\"Mobile Carrier...\" ng-model=vm.viva.carrier required></div></div><div class=form-group><label class=\"control-label minotaur-label col-sm-3\">Images (User Profile, Not Here, Here)</label><div class=col-sm-9><ul class=\"list-unstyled list-inline thumbs-list\"><li ng-repeat=\"image in vm.viva.images\"><img ngf-thumbnail=image alt=\"\" style=\"width: 120px; height: 120px\"> <img ngf-thumbnail=image.src alt=\"\" style=\"width: 120px; height: 120px\"> <button class=btn-nostyle ng-click=\"image = null\" ng-show=\"image && !vm.editing\">x</button></li></ul><p class=\"help-block text-danger\" ng-show=vm.editing>Adding new images will rewrite actual images!</p><div ngf-drop ngf-select ngf-drag-over-class=dragover ngf-multiple=true accept=image/* ng-model=vm.viva.images class=\"fileupload drop-box\" name=images>click or drop files here...</div></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=viva.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/viva/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditVivaController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=viva.list>Viva</a></li><li class=active>{{vm.viva.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/viva/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/viva/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=viva.list>viva</a></li><li class=active>Manage viva</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage viva</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add viva\" tooltip-placement=bottom ui-sref=viva.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"viva in $data\"><td data-title=\"\'ID\'\" sortable>{{viva.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"viva.show({ id: viva.$id })\">{{viva.fname}}</a></td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"viva.show({ id: viva.$id })\">{{viva.lname}}</a></td><td data-title=\"\'Location\'\" sortable>{{viva.locationName}}</td><td data-title=\"\'Date Created\'\" sortable>{{viva.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : viva.status == \'published\',\'bg-warning\' : viva.status == \'not published\',\'bg-lightred\' : viva.status == \'banned\'}\">{{ viva.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"viva.edit({ id: viva.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(viva)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/viva/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewVivaController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=viva.list>Viva</a></li><li class=active>New Viva User</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/viva/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/viva/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowVivaController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=viva.list>Viva</a></li><li class=active>{{vm.viva.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-4 magnific-popup=\"{delegate: \'a.img-link\', type: \'image\'}\"><a href={{vm.viva.images[0].src}} class=img-link ng-show=\"vm.viva.images.length > 0\"><img ng-src={{vm.viva.images[0].src}} alt=vm.viva.name class=\"img-responsive mb-20\"> </a><a href=javascript:; ng-show=\"vm.viva.images.length === 0 || !vm.viva.images\"><img src=assets/images/no-product-image.png alt=vm.viva.name class=\"img-responsive mb-20\"> </a><!-- thumbnails --><slick dots=true infinite=false speed=300 slides-to-show=4 touch-move=false slides-to-scroll=1 arrows=false init-onload=true data=vm.product.images><div ng-repeat=\"image in vm.viva.images\" ng-if=!$first href={{vm.viva.images[$index].src}} class=mr-5><a href={{vm.viva.images[$index].src}} class=img-link><img ng-src={{vm.viva.images[$index].src}} alt=vm.viva.name class=img-responsive></a></div></slick><!-- /thumbnails --></div><!-- /col --><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.viva.fname}} {{vm.viva.lname}} <span class=label ng-class=\"{\'bg-success\' : vm.viva.status == \'published\',\'bg-warning\' : vm.viva.status == \'not published\',\'bg-lightred\' : vm.product.status == \'banned\'}\">{{ vm.viva.status }}</span></h2><p class=\"short-desc text-sm text-default lt mb-20\">{{vm.viva.phone}} Ext. {{vm.viva.ext}}</p><p class=\"desc text-default lt mb-20\">{{vm.viva.starleaf}}</p><h6><strong>Location:</strong> {{ctrl.categoriesObject[vm.viva.locationId].name}}</h6></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=viva.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/_form.html","<form name=form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=name class=\"col-sm-3 control-label minotaur-label\">Name</label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"User name...\" ng-model=vm.user.name></div></div><div class=form-group ng-if=!vm.editing><label for=email class=\"col-sm-3 control-label minotaur-label\">Email <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=email name=email class=form-control id=email placeholder=\"User email...\" ng-model=vm.user.email required></div></div><div class=form-group ng-if=!vm.editing><label for=password class=\"col-sm-3 control-label minotaur-label\">Password <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=password class=form-control id=password placeholder=\"User password...\" ng-model=vm.user.password required></div></div><div class=form-group ng-if=!vm.editing><label for=password class=\"col-sm-3 control-label minotaur-label\">Password Confirm <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=password name=passwordConfirm placeholder=\"Password confirmarion...\" class=form-control ng-model=passwordConfirm match=vm.user.password required></div></div><div class=form-group><label for=role class=\"col-sm-3 control-label minotaur-label\">Role <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=role class=form-control id=role ng-options=\"v for (k,v) in ctrl.roles\" ng-model=vm.user.role data-placeholder=\"Select a role...\" required><option></option></select></div></div><div class=form-group><label for=street class=\"col-sm-3 control-label minotaur-label\">Street</label><div class=col-sm-9><input type=text name=street class=form-control id=street placeholder=\"User address street...\" ng-model=vm.user.address.street></div></div><div class=form-group><label for=city class=\"col-sm-3 control-label minotaur-label\">City</label><div class=col-sm-9><input type=text name=city class=form-control id=city placeholder=\"User address city...\" ng-model=vm.user.address.city></div></div><div class=form-group><label for=zip class=\"col-sm-3 control-label minotaur-label\">ZIP</label><div class=col-sm-9><input type=text name=zip class=form-control id=zip placeholder=\"User address zip...\" ng-model=vm.user.address.zip></div></div><div class=form-group><label for=country class=\"col-sm-3 control-label minotaur-label\">Country</label><div class=col-sm-9><input type=text name=country class=form-control id=country placeholder=\"User address country...\" ng-model=vm.user.address.country></div></div><div class=form-group><label for=phone class=\"col-sm-3 control-label minotaur-label\">Phone</label><div class=col-sm-9><input type=text name=phone class=form-control id=phone placeholder=\"User address phone...\" ng-model=vm.user.phone></div></div><div class=form-footer><button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=form.$invalid>Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=users.list><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/users/edit.html","<div class=\"page page-users pull-to-header\" ng-controller=\"EditUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>{{vm.user.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/users/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/list.html","<div class=\"page page-users pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>Manage Users</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Users</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add User\" tooltip-placement=bottom ui-sref=users.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"user in $data\"><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"users.show({ id: user.$id })\">{{user.name}}</a></td><td data-title=\"\'Email\'\" sortable><a href=javascript:; ui-sref=\"users.show({ id: user.$id })\">{{user.email}}</a></td><td data-title=\"\'Address\'\" sortable>{{user.address.street}}, {{user.address.city}} {{user.address.zip}}, {{user.address.country}}</td><td data-title=\"\'Phone\'\" sortable>{{user.phone}}</td><td data-title=\"\'Role\'\" sortable>{{user.role}}</td><td data-title=\"\'Actions\'\" class=actions style=\"width: 320px\"><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"users.edit({ id: user.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(user)>Delete</button> <button class=\"btn btn-warning btn-xs minotaur-btn\" ng-click=ctrl.passReset(user)>Password reset</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/new.html","<div class=\"page page-users pull-to-header\" ng-controller=\"NewUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>New User</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/users/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/users/show.html","<div class=\"page page-users pull-to-header\" ng-controller=\"ShowUserController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=users.list>Users</a></li><li class=active>{{vm.user.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><ul class=\"list-unstyled m-20\"><li ng-if=vm.user.name><strong>Name:</strong> {{vm.user.name}}</li><li><strong>Email:</strong> {{vm.user.email}}</li><li><strong>Address:</strong> {{vm.user.address.street}}, {{vm.user.address.city}} {{vm.user.address.zip}}, {{vm.user.address.country}}</li><li><strong>Phone:</strong> {{vm.user.phone}}</li><li><strong>Role:</strong> {{vm.user.role}}</li></ul><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=users.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/weather/_form.html","<form name=vm.form class=\"form-horizontal form-validation\" role=form ng-submit=vm.submit()><div class=\"form-group mt-20\"><label for=id class=\"col-sm-3 control-label minotaur-label\">ID</label><div class=col-sm-9><input type=text name=id class=form-control id=id placeholder=\"Weather ID...\" ng-model=vm.weather.id required disabled></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Name <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=name class=form-control id=name placeholder=\"weather name...\" ng-model=vm.weather.name required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">Zip Code <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=code class=form-control id=code placeholder=\"Zip Code...\" ng-model=vm.weather.zipcode required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">City Name<span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=cityname class=form-control id=cityname placeholder=\"City Name...\" ng-model=vm.weather.cityname required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">State <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=state class=form-control id=state placeholder=State... ng-model=vm.weather.state required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">GPS LAT <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=gpslat class=form-control id=gpslat placeholder=\"GPS LAT...\" ng-model=vm.weather.gpslat required></div></div><div class=form-group><label for=name class=\"col-sm-3 control-label minotaur-label\">GPS LON <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><input type=text name=gpslon class=form-control id=gpslon placeholder=\"GPS LON...\" ng-model=vm.weather.gpslon required></div></div><div class=form-group><label for=description class=\"col-sm-3 control-label minotaur-label\">Description <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><textarea name=description id=description ng-model=vm.weather.description class=form-control placeholder=\"weather description...\" rows=5 required></textarea></div></div><div class=form-group><label for=location class=\"col-sm-3 control-label minotaur-label\">Location <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=location class=form-control id=location ng-options=\"c.$id as c.name group by c.parentName for c in ctrl.childLocations\" ng-model=vm.weather.locationId data-placeholder=\"Select a location...\" required><option></option></select></div></div><div class=form-group><label for=unit class=\"col-sm-3 control-label minotaur-label\">Status <span class=text-danger style=\"font-size: 15px\">*</span></label><div class=col-sm-9><select chosen=\"{width: \'100%\'}\" name=status class=form-control id=status ng-options=\"v as v for (k,v) in ctrl.statuses\" ng-model=vm.weather.status data-placeholder=\"Select a status...\" required><option></option></select></div></div><div class=form-footer><i class=\"fa fa-spinner fa-pulse fa-fw\" ng-if=vm.processing></i> <button type=submit class=\"btn btn-success minotaur-btn pull-right\" ng-disabled=\"vm.form.$invalid || vm.processing\">Submit</button> <button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=weather.list ng-disabled=vm.processing><i class=\"fa fa-arrow-left\"></i> Cancel</button></div></form>");
$templateCache.put("app/pages/weather/edit.html","<div class=\"page page-products pull-to-header\" ng-controller=\"EditWeatherController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=weather.list>Weather</a></li><li class=active>{{vm.weather.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/weather/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/weather/list.html","<div class=\"page page-products pull-to-header\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=weather.list>Weather</a></li><li class=active>Manage Weather</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=tile><!-- tile header --><section class=tile-header><h1 class=heading>Manage Weather</h1><div class=controls><button class=\"btn btn-transparent\" uib-tooltip=\"Add weather\" tooltip-placement=bottom ui-sref=weather.new><i class=\"fa fa-plus\"></i></button><div class=btn-group uib-dropdown><button class=\"btn btn-transparent\" uib-dropdown-toggle><i class=\"fa fa-cog\"></i></button><ul class=\"dropdown-menu dropdown-menu-custom\" uib-dropdown-menu role=menu><li role=menuitem><a href=javascript:; minotaur-tile-minimize></a></li><li role=menuitem><a href=javascript:; minotaur-tile-refresh></a></li><li role=menuitem><a href=javascript:; minotaur-tile-fullscreen></a></li><li role=menuitem><a href=javascript:; minotaur-tile-lightbox></a></li></ul></div><minotaur-tile-close></minotaur-tile-close></div></section><!-- /tile header --><!-- tile body --><section class=tile-body><div class=row><div class=col-md-6></div><div class=col-md-6><input type=text class=\"form-control underline-input w-md pull-right mb-20\" placeholder=Search... ng-model=ctrl.searchText></div></div><div class=table-responsive><table ng-table=ctrl.tableParams class=\"table minotaur-table\" template-pagination=custom/pager><tr ng-repeat=\"weather in $data\"><td data-title=\"\'ID\'\" sortable>{{weather.id}}</td><td data-title=\"\'Name\'\" sortable><a href=javascript:; ui-sref=\"weather.show({ id: weather.$id })\">{{weather.name}}</a></td><td data-title=\"\'zipCode\'\" sortable>{{weather.zipcode}}</td><td data-title=\"\'Location\'\" sortable>{{weather.locationName}}</td><td data-title=\"\'Date Created\'\" sortable>{{weather.created_at | date: \'mediumDate\'}}</td><td data-title=\"\'Status\'\" sortable><span class=label ng-class=\"{\'bg-success\' : weather.status == \'published\',\'bg-warning\' : weather.status == \'not published\',\'bg-lightred\' : weather.status == \'banned\'}\">{{ weather.status }}</span></td><td data-title=\"\'Actions\'\" class=w-md><button class=\"btn btn-theme btn-xs minotaur-btn\" ui-sref=\"weather.edit({ id: weather.$id })\">Edit</button> <button class=\"btn btn-danger btn-xs minotaur-btn\" ng-click=ctrl.delete(weather)>Delete</button></td></tr></table><script type=text/ng-template id=custom/pager><div class=\"ng-table-pager mt-20\" ng-if=\"params.data.length\">\n\n                <div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right\">\n\n                  <button ng-repeat=\"count in params.settings().counts\" type=\"button\" ng-class=\"{\'active\':params.count()==count}\" ng-click=\"params.count(count)\" class=\"btn btn-default\"><span ng-bind=\"count\"></span></button>\n\n                </div>\n\n                <ul class=\"pagination pagination-xs pagination-custom\">\n                  <li ng-class=\"{\'disabled\': !page.active && !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\">\n                    <a ng-switch-when=\"prev\" ng-click=\"params.page(page.number)\" href=\"\">Previous</a>\n                    <a ng-switch-when=\"first\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"page\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"more\" ng-click=\"params.page(page.number)\" href=\"\">&#8230;</a>\n                    <a ng-switch-when=\"last\" ng-click=\"params.page(page.number)\" href=\"\">\n                      <span ng-bind=\"page.number\"></span>\n                    </a>\n                    <a ng-switch-when=\"next\" ng-click=\"params.page(page.number)\" href=\"\">Next</a>\n                  </li>\n                </ul>\n              </div></script></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/weather/new.html","<div class=\"page page-products pull-to-header\" ng-controller=\"NewWeatherController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=weather.list>Weather</a></li><li class=active>New Weather</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body ng-include=\"\'app/pages/weather/_form.html\'\"></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/pages/weather/show.html","<div class=\"page page-products pull-to-header\" ng-controller=\"ShowWeatherController as vm\"><ol class=\"breadcrumb bg-white\"><li><a ui-sref=dashboard>Home</a></li><li><a ui-sref=weather.list>Weather</a></li><li class=active>{{vm.weather.name}}</li></ol><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"tile tile-simple\"><!-- tile body --><section class=tile-body><div class=row><!-- col --><div class=col-md-8><h2 class=\"custom-font mb-5\">{{vm.weather.name}} <span class=label ng-class=\"{\'bg-success\' : vm.weather.status == \'published\',\'bg-warning\' : vm.weather.status == \'not published\',\'bg-lightred\' : vm.weather.status == \'banned\'}\">{{ vm.weather.status }}</span></h2><p class=\"desc text-default lt mb-20\">{{vm.weather.description}}</p><p class=\"desc text-default lt mb-20\"><strong>Zip Code:</strong> {{vm.weather.zipcode}}</p><p class=\"desc text-default lt mb-20\"><strong>City Name:</strong> {{vm.weather.cityname}}</p><p class=\"desc text-default lt mb-20\"><strong>State:</strong> {{vm.weather.state}}</p><p class=\"desc text-default lt mb-20\"><strong>GPS LAT:</strong> {{vm.weather.gpslat}}</p><p class=\"desc text-default lt mb-20\"><strong>GPS LON:</strong> {{vm.weather.gpslon}}</p><h6><strong>Location:</strong> {{ctrl.locationsObject[vm.weather.locationId].name}}</h6></div><!-- /col --></div><!-- /row --><div class=form-footer><button class=\"btn btn-lightred minotaur-btn colored\" ui-sref=weather.list><i class=\"fa fa-arrow-left\"></i> Back</button></div></section><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div>");
$templateCache.put("app/components/partials/customize/minotaur-customize.html","<!--\n<button class=\"btn btn-default toggle\"><i class=\"fa fa-adjust\"></i></button>\n<div class=\"pull-right panel\">\n  <div class=\"panel-heading\">\n    <h4>Customize:</h4>\n  </div>\n  <div class=\"panel-body\">\n\n    <h5>Solid:</h5>\n    <ul>\n      <li><div class=\"default\" ng-click=\"main.headerStyle = \'header-solid-default\'\"></div></li>\n      <li><div class=\"greensea\" ng-click=\"main.headerStyle = \'header-solid-greensea\'\"></div></li>\n      <li><div class=\"lightred\" ng-click=\"main.headerStyle = \'header-solid-lightred\'\"></div></li>\n      <li><div class=\"amethyst\" ng-click=\"main.headerStyle = \'header-solid-amethyst\'\"></div></li>\n      <li><div class=\"drank\" ng-click=\"main.headerStyle = \'header-solid-drank\'\"></div></li>\n      <li><div class=\"gray\" ng-click=\"main.headerStyle = \'header-solid-gray\'\"></div></li>\n    </ul>\n\n    <h5>Gradient:</h5>\n    <ul>\n      <li><div class=\"default\" ng-click=\"main.headerStyle = null\"></div></li>\n      <li><div class=\"greensea\" ng-click=\"main.headerStyle = \'header-gradient-greensea\'\"></div></li>\n      <li><div class=\"lightred\" ng-click=\"main.headerStyle = \'header-gradient-lightred\'\"></div></li>\n      <li><div class=\"amethyst\" ng-click=\"main.headerStyle = \'header-gradient-amethyst\'\"></div></li>\n      <li><div class=\"drank\" ng-click=\"main.headerStyle = \'header-gradient-drank\'\"></div></li>\n      <li><div class=\"gray\" ng-click=\"main.headerStyle = \'header-gradient-gray\'\"></div></li>\n    </ul>\n\n    <h5>Primary Color:</h5>\n    <ul>\n      <li><div class=\"default\" ng-click=\"main.primaryColor = null\"></div></li>\n      <li><div class=\"greensea\" ng-click=\"main.primaryColor = \'primary-color-greensea\'\"></div></li>\n      <li><div class=\"lightred\" ng-click=\"main.primaryColor = \'primary-color-lightred\'\"></div></li>\n      <li><div class=\"amethyst\" ng-click=\"main.primaryColor = \'primary-color-amethyst\'\"></div></li>\n      <li><div class=\"drank\" ng-click=\"main.primaryColor = \'primary-color-drank\'\"></div></li>\n      <li><div class=\"gray\" ng-click=\"main.primaryColor = \'primary-color-gray\'\"></div></li>\n    </ul>\n  </div>\n</div>\n//-->");
$templateCache.put("app/components/partials/navigation/navigation.html","<div class=nav-heading><a class=brand ui-sref=dashboard></a><h3>Navigation <a href=javascript:; class=pull-right id=expand-toggle><i class=\"fa fa-circle-o\"></i></a></h3></div><div slimscroll=\"{\n      height: \'100%\',\n      size: \'4px\',\n      borderRadius: \'0px\',\n      opacity: .2\n     }\"><ul class=\"nav nav-sidebar\"><li ng-class=\"{\'active\':$state.includes(\'dashboard\')}\"><a ui-sref=dashboard><span class=nav-text>Dashboard</span> <i class=\"fa fa-home\"></i></a></li><li ng-class=\"{\'open active\':$state.includes(\'pages\')}\"><a href=javascript:;><span class=nav-text>CropNet</span> <i class=\"fa fa-map-marker\"></i></a><ul><li ng-class=\"{\'active\':$state.includes(\'locations\')}\"><a ui-sref=locations.list><span class=nav-text>Displays / Locations</span> <i class=\"fa fa-bookmark-o\"></i></a></li><li ui-sref-active=active><a ui-sref=stocks.list><span class=nav-text>Stocks</span> <i class=\"fa fa-bar-chart\"></i></a></li><li ui-sref-active=active><a ui-sref=weather.list><span class=nav-text>Weather</span> <i class=\"fa fa-cloud\"></i></a></li><li ui-sref-active=active><a ui-sref=news.list><span class=nav-text>News</span> <i class=\"fa fa-plus-square\"></i></a></li></ul></li><li ng-class=\"{\'open active\':$state.includes(\'viva\')}\"><a href=javascript:;><span class=nav-text>ViVa</span> <i class=\"fa fa-map-marker\"></i></a><ul><li ng-class=\"{\'active\':$state.includes(\'viva\')}\"><a ui-sref=viva.list><span class=nav-text>Users</span> <i class=\"fa fa-user\"></i></a></li><li ui-sref-active=active><a ui-sref=viva.list><span class=nav-text>Messages</span> <i class=\"fa fa-comments\"></i></a></li><li ng-class=\"{\'active\':$state.includes(\'viva\')}\"><a ui-sref=viva.starleaf><span class=nav-text>StarLeaf Calls</span> <i class=\"fa fa-envira\"></i></a></li></ul></li><li ng-class=\"{\'active\':$state.includes(\'users\')}\"><a ui-sref=users.list><span class=nav-text>Admin Users</span> <i class=\"fa fa-users\"></i></a></li><li ng-class=\"{\'active\':$state.includes(\'settings\')}\"><a ui-sref=settings><span class=nav-text>Settings</span> <i class=\"fa fa-cog\"></i></a></li><li ng-class=\"{\'active\':$state.includes(\'support\')}\"><a ui-sref=support><span class=nav-text>Support</span> <i class=\"fa fa-life-ring\"></i></a></li></ul></div>");
$templateCache.put("app/components/partials/header/header.html","<div class=navbar-header><button type=button class=\"header-nav-toggle collapsed\" data-toggle=collapse data-target=#header-navbar aria-expanded=false aria-controls=header-navbar><span class=sr-only>Toggle header</span> <i class=\"fa fa-cog\"></i></button> <button type=button class=navigation-toggle id=navigation-toggle><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-bars\"></i></button> <a class=navbar-brand ui-sref=dashboard><span><strong>Admin</strong>Portal</span></a></div><div id=header-navbar class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><!-- Single button --><div uib-dropdown><button id=profile type=button class=\"btn no-bg\" uib-dropdown-toggle><img src=assets/images/placeholder-avatar.png alt=\"\" class=\"img-responsive img-circle hidden-xs\" ng-if=!main.currentUser.avatar> <img ng-src={{main.currentUser.avatar}} alt=\"\" class=\"img-responsive img-circle hidden-xs\" ng-if=main.currentUser.avatar> <span class=nav-text><i class=\"fa fa-user\"></i> {{main.currentUser.name}}</span></button><div class=\"dropdown-menu with-arrow animated littleFadeInRight profile\" uib-dropdown-menu role=menu aria-labelledby=profile><div class=media><div class=media-left><img src=assets/images/placeholder-avatar.png alt=\"\" class=\"media-object img-circle\" ng-if=!main.currentUser.avatar> <img ng-src={{main.currentUser.avatar}} alt=\"\" class=\"media-object img-circle\" ng-if=main.currentUser.avatar></div><div class=media-body><h4 class=\"text-sm uppercase-bold\">{{main.currentUser.name}}</h4><a href=javascript:;>{{main.currentUser.email}}</a><ul class=list-unstyled><li ng-class=\"{\'active\':$state.includes(\'profile\')}\"><a ui-sref=profile><i class=\"fa fa-user\"></i> Edit Profile</a></li></ul></div></div><div class=footer><button class=\"btn btn-theme minotaur-btn\" ng-click=header.logout();><i class=\"fa fa-power-off\"></i> Logout</button></div></div></div></li></ul></div>");
$templateCache.put("app/components/partials/rightbar/rightbar.html","<uib-tabset><uib-tab id=users><uib-tab-heading>Chat</uib-tab-heading><h6><strong>Online</strong> Users</h6><ul><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/ici-avatar.jpg alt></a><div class=media-body><span class=media-heading>Ing. Imrich <strong>Kamarel</strong></span> <small><i class=\"fa fa-map-marker\"></i> Ulaanbaatar, Mongolia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/arnold-avatar.jpg alt> </a><span class=\"badge bg-lightred unread\">3</span><div class=media-body><span class=media-heading>Arnold <strong>Karlsberg</strong></span> <small><i class=\"fa fa-map-marker\"></i> Bratislava, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/peter-avatar.jpg alt></a><div class=media-body><span class=media-heading>Peter <strong>Kay</strong></span> <small><i class=\"fa fa-map-marker\"></i> Kosice, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/george-avatar.jpg alt></a><div class=media-body><span class=media-heading>George <strong>McCain</strong></span> <small><i class=\"fa fa-map-marker\"></i> Prague, Czech Republic</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar1.jpg alt></a><div class=media-body><span class=media-heading>Lucius <strong>Cashmere</strong></span> <small><i class=\"fa fa-map-marker\"></i> Wien, Austria</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar2.jpg alt></a><div class=media-body><span class=media-heading>Jesse <strong>Phoenix</strong></span> <small><i class=\"fa fa-map-marker\"></i> Berlin, Germany</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul><h6><strong>Offline</strong> Users</h6><ul><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar4.jpg alt></a><div class=media-body><span class=media-heading>Dell <strong>MacApple</strong></span> <small><i class=\"fa fa-map-marker\"></i> Paris, France</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar5.jpg alt></a><div class=media-body><span class=media-heading>Roger <strong>Flopple</strong></span> <small><i class=\"fa fa-map-marker\"></i> Rome, Italia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar6.jpg alt></a><div class=media-body><span class=media-heading>Nico <strong>Vulture</strong></span> <small><i class=\"fa fa-map-marker\"></i> Kyjev, Ukraine</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar7.jpg alt></a><div class=media-body><span class=media-heading>Bobby <strong>Socks</strong></span> <small><i class=\"fa fa-map-marker\"></i> Moscow, Russia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar8.jpg alt></a><div class=media-body><span class=media-heading>Anna <strong>Opichia</strong></span> <small><i class=\"fa fa-map-marker\"></i> Budapest, Hungary</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul></uib-tab><uib-tab><uib-tab-heading>Friends</uib-tab-heading><h6><strong>Friends</strong> List</h6><ul><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/arnold-avatar.jpg alt> </a><span class=\"badge bg-lightred unread\">3</span><div class=media-body><span class=media-heading>Arnold <strong>Karlsberg</strong></span> <small><i class=\"fa fa-map-marker\"></i> Bratislava, Slovakia</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=offline><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar8.jpg alt></a><div class=media-body><span class=media-heading>Anna <strong>Opichia</strong></span> <small><i class=\"fa fa-map-marker\"></i> Budapest, Hungary</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=busy><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/random-avatar1.jpg alt></a><div class=media-body><span class=media-heading>Lucius <strong>Cashmere</strong></span> <small><i class=\"fa fa-map-marker\"></i> Wien, Austria</small> <span class=\"badge badge-outline status\"></span></div></div></li><li class=online><div class=media><a class=\"pull-left thumb thumb-sm\" href=javascript:;><img class=\"media-object img-circle\" src=assets/images/ici-avatar.jpg alt></a><div class=media-body><span class=media-heading>Ing. Imrich <strong>Kamarel</strong></span> <small><i class=\"fa fa-map-marker\"></i> Ulaanbaatar, Mongolia</small> <span class=\"badge badge-outline status\"></span></div></div></li></ul></uib-tab><uib-tab heading=\"Long Justified\"><uib-tab-heading>Settings</uib-tab-heading><h6><strong>Chat</strong> Settings</h6><ul class=settings><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Offline Users</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-offline checked><label class=onoffswitch-label for=show-offline><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Fullname</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-fullname><label class=onoffswitch-label for=show-fullname><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">History Enable</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-history checked><label class=onoffswitch-label for=show-history><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Locations</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-location checked><label class=onoffswitch-label for=show-location><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Notifications</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-notifications><label class=onoffswitch-label for=show-notifications><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li><li><div class=form-group><label class=\"col-xs-8 control-label\">Show Undread Count</label><div class=\"col-xs-4 control-label\"><div class=\"onoffswitch theme\"><input type=checkbox name=onoffswitch class=onoffswitch-checkbox id=show-unread checked><label class=onoffswitch-label for=show-unread><span class=onoffswitch-inner></span> <span class=onoffswitch-switch></span></label></div></div></div></li></ul></uib-tab></uib-tabset><a href=javascript:; id=close-rightbar></a>");}]);